/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */

import * as Segment from './segment'

export interface AccessDeniedError {
	appVersion: string
	failedGraphQLQueries?: any[]
	fullStory?: string | null
	/**
	 * The reason access was denied is a hint that describes whether you couldn't access the workspace or thing you were trying to do because the workspace requires SSO and you aren't auth'd with SSO, or MFA is required, or you are logged in with a different SSO connection than required.
	 */
	reason: string
	route: string | null
	team: string
	timezone: string
	workspaceId?: string
	workspaceSlug?: string
}
export interface ActivityFeedFiltered {
	'Activity Type': string
	'Workspace Slug': string
	/**
	 * Segment workspace id
	 */
	workspace_id: string
	/**
	 * Segment workspace slug
	 */
	workspace_slug: string
}
export interface ActivityFeedSearched {
	'Search Term': string
	'Workspace Slug': string
}
export interface AdCampaignClicked {
	ad_position: string
	adgroup_id: string
	campaign_id: string
	creative: string
	device: string
	extension_id: string
	keyword: string
	landingpage: string
	match_type: string
	network: string
	physical_location: string
	placement: string
	target_id: string
}
export interface AddDestinationClicked {
	/**
	 * ie "workspace checklist"
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	/**
	 * ='Yes" for VT;="No" if without VT
	 */
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
}
export interface AddDestinationCompleted {
	destination_id: string
	destination_slug: string
	/**
	 * ie "workspace checklist"
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	/**
	 * ='Yes" for VT;="No" if without VT
	 */
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
}
export interface AddPageviewsCloseButtonClicked {
	source_id?: string
	source_slug?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface AddPageviewsCopySnippetClickedCopy {
	source_id: string
	source_slug: string
	user_id: string
	/**
	 * ="Yes" if VT Flag On, ="No" otherwise
	 */
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
}
export interface AddPageviewsGetStartedClicked {
	source_id?: string
	source_slug?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface AddSourceButtonClicked {
	/**
	 * Where the button is located. (ie. workspace checklist)
	 */
	location: string
	user_id: any | null
	/**
	 * ="Yes" if VT Flag On, ="No" otherwise
	 */
	vt_flag_on: boolean
	workspace_id: any | null
	workspace_slug: any | null
}
export interface AddSourceNextButtonClicked {
	/**
	 * "source selection", "mobile library selection", "source setup", or "confirmation screen"
	 */
	current_step: string
	source_id?: string
	source_name?: string
	source_slug?: string
	/**
	 * ="javascript" if vt_flag_on='Yes'; ='javascript'/'mobile' when vt_ flag_on='no'
	 */
	source_type?: string
	user_id: string
	/**
	 * ="Yes" if VT Flag On, ="No" otherwise
	 */
	vt_flag_on: boolean
	/**
	 * the website url entered in the "Source setup" step; Null for other steps.
	 */
	website_url: string
	workspace_id: string
	workspace_slug: string
}
export interface AgreementDownloadedSignedCopy {
	agreement_id: string
	agreement_name: string
	agreement_version: string
	user_id: string
	user_name: string
	workspace_id: string
	workspace_slug: string
}
export interface AgreementDownloadedUnsignedCopy {
	agreement_id: string
	agreement_name: string
	agreement_version: string
	user_id: string
	user_name: string
	workspace_id: string
	workspace_slug: string
}
export interface AgreementSigned {
	agreement_id: string
	agreement_name: string
	agreement_version: string
	user_id: string
	user_name: string
	workspace_id: string
	workspace_slug: string
}
export interface AppTimingMetric {
	browser?: any | null
	/**
	 * (Optional) name of the component associated with a timing metric
	 */
	component_name?: string | null
	/**
	 * The value of the web metric
	 */
	duration: number
	/**
	 * The name of the web metric.
	 */
	metric: string
	/**
	 * The current route of the user when the metric was tracked.
	 */
	route: string | null
	/**
	 * (Optional) The team that owns the route
	 */
	team?: string
}
export interface AssignLabelsClicked {
	workspace_id: string
	workspace_slug: string
}
export interface AuditTrailFiltered {
	filter_type: string
	filter_value: string
	workspace_id: string
	workspace_slug: string
}
export interface BetaTermsAccepted {
	/**
	 * Source id, if relevant
	 */
	source_id?: string
	/**
	 * Source slug, if relevant
	 */
	source_slug?: string
	/**
	 * The type of Beta Agreement that was accepted.
	 */
	type: string
	/**
	 * Unique id of the workspace that has accepted the terms
	 */
	workspace_id: string
	/**
	 * Workspace slug of the workspace that has accepted the terms
	 */
	workspace_slug: string
}
export interface BrazeMiddlewareToggled {
	/**
	 * Tier of the account this is toggled on
	 */
	account_tier: string
	/**
	 * Enabled = true, Disabled = false
	 */
	enabled: boolean
	/**
	 * Source ID of the project this is toggled on
	 */
	source_id: string
	/**
	 * Workspace slug of the account this is toggled on
	 */
	workspace_slug: string
}
export interface BulkAssignLabelSaved {
	label: string
	resource_name: string
	resource_type: string
}
export interface CsvDownloaded {
	usage_type: string
	workspace_id: string
	workspace_slug: string
}
export interface CancelButtonBulkAssignEnvironmentsClickCopy {
	workspace_slug: string
}
export interface CatalogCategoryClicked {
	catalog_category: string
	type: string
}
export interface CatalogRecommendationCategoryClicked {
	catalog_category: string
	type: string
}
export interface CatalogRecommendationClicked {
	recommendation_slug: string
	type: string
}
export interface CatalogSidebarCategoryClicked {
	catalog_category: string
	type: string
}
export interface CatalogSidebarSearched {
	/**
	 * Currently selected category in the left nav.
	 */
	current_category: string
	/**
	 * Text searched for by the user.
	 */
	search_query: string
	/**
	 * Whether the user is viewing the Sources or Destinations catalog.
	 */
	title: string
	/**
	 * ID of the workspace.
	 */
	workspace_id: string
}
export interface CatalogSidebarTabClicked {
	layout: string
	platforms: string
	repo: string
	tool_types_displayed: string
	tools: string
	workspace_id: string
	workspace_slug: string
}
export interface CatalogSortBy {
	category_name: string | null
	integration_type?: any | null
	search_term: string | null
	sort_by: string
}
export interface CatalogSortByClicked {
	layout: string
	platforms: string
	repo: string
	tool_types_displayed: string
	tools: string
	workspace_id: string
	workspace_slug: string
}
export interface CatalogTileClicked {
	layout: string
	platforms: string
	repo: string
	tile: string
	tool_types_displayed: string
	tools: string
	workspace_id: string
	workspace_slug: string
}
export interface CensorDestinationSettings {
	metadata_id?: string | null
	method_name: string
	should_censor_flag: boolean
	source_id?: string | null
	user_id?: string | null
	workspace_id?: string | null
}
export interface ChangeWorkspaceClicked {
	target: string
}
export interface ChangeWorkspaceClickedFromAccountSettings {
	target?: string
}
export interface ChangeWorkspaceClickedFromWorkspaceSettings {
	target?: string
}
export interface ChecklistCompletedAppcues {
	checklistId: string
	checklistName: string
	name: string
	sessionId: string
	timestamp: string
	user: string
}
export interface ChecklistCompletedItemLinkClicked {
	destination_id?: string
	destination_slug?: string
	/**
	 * step name or row name
	 */
	item_type?: string
	source_id?: string
	/**
	 * If it's a Source, then list the Source slug
	 */
	source_slug?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ChecklistDismissedAppcues {
	checklistId: string
	name: string
	sessionId: string
	timestamp: string
	user: string
}
export interface ChecklistItemCompletedAppcues {
	checklistId: string
	checklistName: string
	itemId: string
	itemIndex: string
	itemLabel: string
	name: string
	sessionId: string
	timestamp: string
	user: string
}
export interface ChecklistItemExpanded {
	/**
	 * The step name or row name
	 */
	item_type: any | null
	user_id: any | null
	/**
	 * =Yes if w. VT, =No if w/o VT
	 */
	vt_flag_on: boolean
	workspace_id: any | null
	workspace_slug: any | null
}
export interface ChecklistShownAppcues {
	checklistId: string
	checklistName: string
	name: string
	sessionId: string
	timestamp: string
	user: string
}
export interface ClassificationApplied {
	/**
	 * The color of the classification the user applied
	 */
	color: string
	workspace_id: string
}
export interface ClickedAddDestination {
	user_id?: string
	workspace_id: string
}
export interface ClickedAddSource {
	user_id?: string
	workspace_id: string
}
export interface ClickedCta {
	location: string
	type: string
}
export interface ClickedCatalogIntegration {
	category_name?: string | null
	destination_slug: string
	/**
	 * direct v1 or direct v2 or
	 */
	destination_type: string | null
	/**
	 * sources vs. destinations vs. warehouses
	 */
	integration_type: string | null
	/**
	 * tells you if a tile was the featured banner
	 */
	is_featured_banner?: boolean
	/**
	 * tells you if a tile was from the featured section
	 */
	is_featured_tile?: boolean
	search_term?: string | null
}
export interface ClickedCatalogInterestedInBuilding {
	workspace_slug: string
}
export interface ClickedCatalogViewAll {
	category_name: string
	/**
	 * source, destination, or warehouse
	 */
	integration_type: string | null
}
export interface ClickedConfigureDestination {
	/**
	 * is it the top or bottom button
	 */
	button_position: string
	destination_definition_id: string
	destination_slug: string
	/**
	 * direct v1 or direct v2
	 */
	destination_type: string | null
	source_slug: string | null
}
export interface ClickedSqlIntegration {
	partner_name: string
	workspace_id: string
}
export interface ClickedWishlistIntegrationRequestLogo {
	/**
	 * source or a destination
	 */
	integration_type: string
	requested_integration_id?: string
	/**
	 * name of the tool requested
	 */
	tool_name: string
	/**
	 * website/url of the tool
	 */
	tool_url: string
}
export interface ClickedWishlistUpvoteButton {
	/**
	 * source or a destination
	 */
	integration_type: string
	requested_integration_id?: string
	/**
	 * name of the tool requested
	 */
	tool_name: string
	/**
	 * website/url of the tool
	 */
	tool_url: string
}
export interface CodeSnippetCopied {
	/**
	 * specifies which language they selected
	 */
	code_language?: string
	/**
	 * specifies where user copied the code snippet Options: Tracking Plan, Sign Up Flow, Docs, etc.
	 */
	location: string
}
export interface ConnectionHealthDeleteCancelled {
	connection_type: string
	destination_id?: string
	error_type?: string
	source_id?: string
	warehouse_id?: string
	workspace_id: string
}
export interface ConnectionHealthDeleteClicked {
	connection_type: string
	destination_id?: string
	error_type?: string
	source_id?: string
	warehouse_id?: string
	workspace_id: string
}
export interface ConnectionHealthDeleteCompleted {
	connection_type: string
	destination_id?: string
	error_type?: string
	source_id?: string
	warehouse_id?: string
	workspace_id: string
}
export interface ConnectionHealthDisableClicked {
	connection_type: string
	destination_id?: string
	error_type?: string
	source_id?: string
	warehouse_id?: string
	workspace_id: string
}
export interface ConnectionHealthErrorClicked {
	connection_type: string
	destination_id?: string
	error_type: any | null
	source_id?: string
	warehouse_id?: string
	workspace_id: string
}
export interface ConnectionHealthResolveErrorClicked {
	connection_type: string
	destination_id?: string
	error_type?: string
	source_id?: string
	warehouse_id?: string
	workspace_id: string
}
export interface ConnectionPolicyEdited {
	/**
	 * should display names of labels if "Only sources with specific labels"
	 */
	new_setting: any[]
	/**
	 * should display names of labels if "Only sources with specific labels"
	 */
	old_setting: any[]
	workspace_id: string
	workspace_slug: string
}
export interface CreateLabelClicked {
	workspace_id: string
	workspace_slug: string
}
export interface CreatedPlugin {
	plugin_id?: string
	plugin_slug?: string
	source_id?: string
}
export interface CreditCardAdded {
	credit_card_brand?: string
}
export interface CreditCardEditClicked {
	credit_card_brand: string
}
export interface CreditCardErrored {
	credit_card_brand?: string
	credit_card_error?: Record<string, any>
}
export interface Language {
	name?: string
	version?: string
}
export interface Event {
	has_errors?: boolean
	integration_errors?: string
	language?: Language
	method?: string
	name?: string
}
export interface Project {
	/**
	 * Source ID
	 */
	id?: string
	/**
	 * Name of the Source
	 */
	name?: string
	/**
	 * Slug of the Source
	 */
	project: string
}
export interface Workspace {
	/**
	 * Billing email for the workspace
	 */
	email?: string
	/**
	 * Workspace id
	 */
	id?: string
	/**
	 * Workspace name
	 */
	name?: string
	/**
	 * Workspace slug
	 */
	workspace: string
}
export interface DebuggerCallClicked {
	/**
	 * Clicked Event Metadata
	 */
	event?: Event
	/**
	 * Is this a historic event or a live event?
	 */
	historic_event?: boolean
	/**
	 * Source Metadata
	 */
	project: Project
	/**
	 * Is a search applied?
	 */
	search?: boolean
	/**
	 * Workspace metadata
	 */
	workspace: Workspace
}
export interface Project1 {
	/**
	 * Source ID
	 */
	id?: string
	/**
	 * Name of the Source
	 */
	name?: string
	/**
	 * Slug of the Source
	 */
	project: string
}
export interface Workspace1 {
	/**
	 * Billing email for the workspace
	 */
	email?: string
	/**
	 * Workspace id
	 */
	id?: string
	/**
	 * Workspace name
	 */
	name?: string
	/**
	 * Workspace slug
	 */
	workspace: string
}
export interface DebuggerSearched {
	full_payload: boolean
	include_alias: boolean
	include_allowed: boolean
	include_blocked: boolean
	include_group: boolean
	include_identify: boolean
	include_page: boolean
	include_screen: boolean
	include_track: boolean
	keywords: string
	/**
	 * Source Metadata
	 */
	project: Project1
	/**
	 * Search term entered
	 */
	terms: string
	/**
	 * Workspace metadata
	 */
	workspace: Workspace1
}
export interface DemoRequested {
	feature?: string
	user_email?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface DestinationAuthorizeClicked {
	destination_id: string
	destination_metadata_category: string
	destination_metadata_slug: string
	destination_name: string
	destination_slug: string
	destination_type?: string
	funnel_step: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationAuthorizeFailed {
	destination_id: string
	destination_metadata_slug: string
	destination_name: string
	destination_slug: string
	error: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationAuthorized {
	destination_id: string
	destination_metadata_slug: string
	destination_name: string
	destination_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationCredentialsAdded {
	billing_plan_id?: string
	/**
	 * destination_name
	 */
	destination_name?: string
	/**
	 * destination_setting_names
	 */
	destination_setting_names?: any[]
	destination_slug?: string
	/**
	 * source_id
	 */
	source_id?: string
	source_slug?: string
	/**
	 * user_email
	 */
	user_email?: string
	/**
	 * user_id
	 */
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface DestinationDeliverabilityPeriodUpdated {
	billing_plan_id: string
	destination_slug: string
	period: string
	source_id: string
	source_slug: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationDeliverabilityViewed {
	billing_plan_id: string
	destination_slug: string
	source_id: string
	source_slug: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationErrorPayloadCopied {
	billing_plan_id: string
	destination_slug: string
	source_id: string
	source_slug: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationErrorPayloadTabChanged {
	billing_plan_id: string
	destination_slug: string
	source_id: string
	source_slug: string
	tab_name: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationErrorViewed {
	billing_plan_id: string
	destination_slug: string
	error_type: string
	source_id: string
	source_slug: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationFilterCreated {
	/**
	 * List of tsub actions to perform.
	 */
	actions: any[]
	/**
	 * Description of destination filter.
	 */
	description: string
	/**
	 * Whether this destination filter is enabled.
	 */
	enabled: boolean
	/**
	 * FQL condition string.
	 */
	fql: string
	/**
	 * Identifier for destination filter.
	 */
	target: string
	/**
	 * Title of destination filter.
	 */
	title: string
}
export interface DestinationFilterFeedbackSubmitted {
	/**
	 * slug
	 */
	destination?: string
	message: string
	/**
	 * slug
	 */
	source?: string
	/**
	 * slug
	 */
	workspace?: string
}
export interface DestinationFiltersFqlTested {
	/**
	 * Whether the test diff call to gateway-api failed.
	 */
	failed?: boolean
	/**
	 * The FQL condition string.
	 */
	fql?: string
	/**
	 * The selected action for this filter.
	 */
	selected_filter_type: string
}
export interface DestinationFiltersListViewed {
	numFilters: number
}
export interface DestinationOverviewPeriodUpdated {
	billing_plan_id: string
	destination_slug: string
	period: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationOverviewSearched {
	billing_plan_id: string
	destination_slug: string
	search_query: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationOverviewViewed {
	billing_plan_id: string
	destination_slug: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationSimulatorBuilderType {
	eventBuilderType: string
}
export interface DestinationSimulatorDismissedSourceDebuggerDialog {
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationSimulatorEventPayloadCopied {
	viewResultType: string
}
export interface DestinationSimulatorEventSent {
	error: string
	eventBuilderType: string
	eventErrorCode: string
	eventErrorMessage: string
	eventResponseStatusCode: string
	integration_id: string
	integration_slug: string
	numEventResponses: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationSimulatorNavigatedFromSourceDebugger {
	integration_slug: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface DestinationSimulatorResultViewToggled {
	viewResultType: string
}
export interface DestinationsSettingsReverted {
	/**
	 * destination_metadata_name
	 */
	destination_metadata_name?: string
	/**
	 * destination_metadata_slug
	 */
	destination_metadata_slug?: string
	/**
	 * destination_name
	 */
	destination_name?: string
	/**
	 * destination_slug
	 */
	destination_slug?: string
	/**
	 * source_slug
	 */
	source_slug?: Record<string, any>
	/**
	 * workspace_id
	 */
	workspace_id?: string
	/**
	 * workspace_slug
	 */
	workspace_slug?: string
}
export interface DisableTaggerClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface DocsLinkClicked {
	/**
	 * The docs link they clicked on.
	 */
	link: string
	/**
	 * Where the user was when they clicked on this link.
	 */
	location: string
	/**
	 * Segment source id
	 */
	source_id?: string
	/**
	 * Segment source slug
	 */
	source_slug?: string
	/**
	 * Segment workspace id
	 */
	workspace_id: string
	/**
	 * Segment workspace slug
	 */
	workspace_slug: string
}
export interface EditTrackingPlanClicked {
	/**
	 * specifies where the user was when clicking to view violations
	 */
	location: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * The type of Tracking Plan (because Tracking Plans can also be Libraries).
	 */
	type?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface ElementsTreeDropdownClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ElementsTreeElementClicked {
	/**
	 * The selector that the user clicks on
	 */
	selector_selected?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface EmailCaptured {
	email: string
	form: string
}
export interface EmailDelivered {
	campaign_id: string
	email_body: string
	email_recipient: string
	email_sender: string
	email_subject: string
}
export interface EnableDestinationClicked {
	destination_id: string
	destination_slug: string
	/**
	 * ie "workspace checklist"
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	/**
	 * =Yes if w. VT, =No if w/o VT
	 */
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
}
export interface EnableFlowStarted {
	experiment_name: string
	integration: string
	location: string
	url: string
	variation_name: string
}
export interface EnableTaggerClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface EnforcementNotificationClicked {
	feature: string
	target_plan: string
	workspace_id: string
	workspace_slug: string
}
export interface EnforcementNotificationShown {
	feature: string
	target_plan: string
	workspace_id: string
	workspace_slug: string
}
export interface EnforcementSettingsChanged {
	/**
	 * specifies what level of blocking is being changed (unplanned event, unplanned property, JSON schema)
	 */
	blocking_type?: string
	/**
	 * specifies the user's dropdown selection (allow, block, strip)
	 */
	dropdown_selection?: string
	/**
	 * specifies what event type is being changed
	 */
	event_type?: string
	/**
	 * true if a Tracking Plan is connected
	 */
	tracking_plan_connected?: boolean
}
export interface ErrorWritekeyNotFound {
	is_timeout?: boolean
}
export interface ErrorSummaryToggled {
	billing_plan_id: string
	destination_slug: string
	type: string
	user_email: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface EventDisabled {
	event_name: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface EventEdited {
	event_name_after?: Record<string, any>
	event_name_before?: Record<string, any>
	selector_after?: Record<string, any>
	selector_before?: Record<string, any>
	trigger_after?: Record<string, any>
	trigger_before?: Record<string, any>
	user_id?: Record<string, any>
	workspace_id?: Record<string, any>
	workspace_slug?: Record<string, any>
}
export interface EventEnabled {
	event_name: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface EventInferred {
	/**
	 * name of event being inferred
	 */
	event_name?: string
	/**
	 * The type of event being inferred
	 */
	event_type?: string
	/**
	 * Array of properties being added (selected by customer in modal)
	 */
	property_names?: string[]
	/**
	 * Id of segment source
	 */
	source_id?: any | null
	/**
	 * Name of Segment source
	 */
	source_name?: any | null
	/**
	 * Slug of Segment source
	 */
	source_slug?: string
	/**
	 * Tracking plan Resource id
	 */
	tracking_plan_id?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface LabelObject {
	/**
	 * key of the label that is added to this event
	 */
	key?: string
	/**
	 * value of the label that is added to this event
	 */
	value?: any | null
}
export interface EventLabelsEdited {
	/**
	 * ID of event that label is added to
	 */
	event_id?: string
	/**
	 * name of event that label is added to
	 */
	event_name: string
	/**
	 * label object state on save
	 */
	label_object: LabelObject
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * Segment workspace id
	 */
	workspace_id: string
	/**
	 * Segment workspace slug
	 */
	workspace_slug?: string
}
export interface EventStreamTabClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface EventTaggerClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ExtensionActivated {
	user_email?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ExtensionInstalled {
	user_email?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ExtensionLogin {
	user_email?: string
}
export interface ExtensionUninstalled {
	user_email?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface FeatureRequested {
	feature_name: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface FeedbackSubmitted {
	/**
	 * Location of the feedback form in the app.
	 */
	app_location?: string
	/**
	 * The feedback!
	 */
	feedback_text: string
	/**
	 * The team the feedback belongs to.
	 */
	team: string
	workspace_id: string
	workspace_slug: string
}
export interface FilterApplied {
	/**
	 * When type==App Version, pass through app versions selected by user
	 */
	filtered_app_version?: string
	/**
	 * When type==Category, pass through the selected category.
	 */
	filtered_category?: string
	/**
	 * When type==Tag, pass through tag keys selected by user
	 */
	filtered_label_keys?: Record<string, any>
	/**
	 * When type==Search, pass through tag keys selected by user
	 */
	filtered_string?: string
	/**
	 * When type==Time Range, pass through time range selected by user
	 */
	filtered_timeframe?: string
	/**
	 * specifies where the user is entering and applying the filter
	 */
	location: string
	/**
	 * Segment source id
	 */
	source_id?: string
	/**
	 * Segment source slug
	 */
	source_slug?: string
	/**
	 * specifies sublocation where the user is entering and applying the filter. (ex. when filtering in the Tracking Plan Editor, use to specify if user is on the Track, Identify, etc tab)
	 */
	sublocation?: string
	/**
	 * The ID of the Tracking Plan, if applied within the scope of a Tracking Plan.
	 */
	tracking_plan_id?: string
	/**
	 * specifies what type of filter is being applied
	 */
	type: string
	/**
	 * Segment workspace id
	 */
	workspace_id: string
	/**
	 * Segment workspace slug
	 */
	workspace_slug: string
}
export interface FilterByEnvironmentSelectboxChanged {
	workspace_billing_plan: string
	workspace_slug: string
}
export interface FirstContentfulPaint {
	browser?: any | null
	/**
	 * The value of the web metric
	 */
	duration: number
	/**
	 * The current route of the user when the metric was tracked.
	 */
	route: string | null
}
export interface FirstInputDelay {
	browser?: any | null
	/**
	 * The value of the web metric
	 */
	duration: number
	/**
	 * The current route of the user when the metric was tracked.
	 */
	route: string | null
}
export interface FirstPaint {
	browser?: any | null
	/**
	 * The value of the web metric
	 */
	duration: number
	/**
	 * The current route of the user when the metric was tracked.
	 */
	route: string | null
}
export interface FlowCompletedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	name: string
	sessionId: string
	timestamp: string
	user: string
}
export interface FlowSkippedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	name: string
	sessionId: string
	stepId: string
	stepNumber: string
	timestamp: string
	user: string
}
export interface FlowStartedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	name: string
	sessionId: string
	timestamp: string
	user: string
}
export interface ForwardingSettingsChanged {
	/**
	 * specifies if the setting is changed to enabled or disabled
	 */
	forwarding_status: string
	/**
	 * specified the source id
	 */
	selected_source_id: string
	/**
	 * specifies the source slug
	 */
	selected_source_slug?: string
	/**
	 * specifies what type forwarding settings have been changed (blocked event, violations or workspace events)
	 */
	type: string
}
export interface FunctionAttachedToSource {
	/**
	 * the ID of the source that the function has been attached to.
	 */
	source_id?: string
}
export interface GdprBetaRequested {
	workspace_slug: string
}
export interface GateViewed {
	/**
	 * Which Segment product gate the customer is viewing (Personas, Protocols, etc)
	 */
	feature?: string
	/**
	 * Id of workspace
	 */
	workspace_id?: string
	/**
	 * Slug of workspace
	 */
	workspace_slug?: string
}
export interface GraphQlError {
	/**
	 * The set of categories of errors (Access Denied, etc.)
	 */
	categories: string[]
	/**
	 * A string-ified version of category, for Destination Filters usage.
	 */
	categoryString: string
	fullStory?: string | null
	graphqlErrors: any[]
	/**
	 * A string-ified version of messages, for Destination Filters usage.
	 */
	messageString: string
	/**
	 * A list of the error messages
	 */
	messages: string[]
	route: string | null
	sentryId?: any | null
	timezone: string
}
export interface IdentityResolutionBlockedValueUpdated {
	blocked_values: any[]
	identifier_name: string
	space_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface IdentityResolutionEditStateEnabled {
	space_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface IdentityResolutionIdentifierCreated {
	identifier_name: string
	space_name: string
	workspace_id: string
	workspace_slug: string
}
export interface IdentityResolutionLimitBehaviorUpgraded {
	identifier_name: string
	space_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface IdentityResolutionLimitUpdated {
	identifier_name: string
	new_value: number
	old_value: number
	space_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface IdentityResolutionPageClicked {
	space_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface IdentityResolutionPriorityUpdated {
	new_order: any[]
	old_order: any[]
	space_name: string
	workspace_id: string
	workspace_slug: string
}
export interface IncidentContactsChanged {
	contacts_added_count: number
	contacts_removed_count: number
	workspace_id: string
}
export interface IncidentContactsSaved {
	contacts_added_count: number
	contacts_removed_count: number
	workspace_id: string
}
export interface IncidentContactsWarningDialogCanceled {
	workspace_id: string
}
export interface IncidentContactsWarningDialogConfirmed {
	workspace_id: string
}
export interface IncidentContactsWarningDialogDisplayed {
	workspace_id: string
}
export interface IntegrationDisabled {
	destination_type?: string | null
	integration_metadata_slug: string
	integration_name: string
	partner_enable_flow: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface IntegrationEnabled {
	/**
	 * direct v1 or v2 or other
	 */
	destination_type?: string | null
	integration_metadata_slug: string
	integration_name: string
	partner_enable_flow: boolean
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface InvalidDestinationEnableAttempted {
	destination_slug: string
}
export interface InventoryCsvDownloaded {
	workspace_id: string
}
export interface InventorySidesheetViewed {
	tab?: string
}
export interface InvestorProgramHandshakeMade {
	email?: string
	first_name?: string
	initial_handshake_ts?: string
	investor_name?: string
	last_name?: string
}
export interface InviteATeammateClicked {
	/**
	 * location where the action was triggered from (ie "workspace checklist")
	 */
	location: string
	user_id: any | null
	/**
	 * ="Yes" if with VT; ="No" if w. VT
	 */
	vt_flag_on: boolean
	workspace_id: any | null
	workspace_slug: any | null
}
export interface JsonSchemaEdited {
	/**
	 * specifies which json schema is being edited (common rules or event)
	 */
	type: string
}
export interface JavaScriptError {
	appTrace?: string
	/**
	 * The set of categories of errors (Access Denied, etc.)
	 */
	categories: string[]
	/**
	 * A string-ified version of category, for Destination Filters usage.
	 */
	categoryString: string
	extra?: string
	failedGraphQLQueries?: any[]
	feature?: string
	filename?: string
	fullStory?: string | null
	functionName?: string
	graphQLQueries?: any[]
	/**
	 * A string-ified version of messages, for Destination Filters usage.
	 */
	messageString: string
	/**
	 * A list of the error messages
	 */
	messages: string[]
	route?: string | null
	sentryId?: any | null
	timezone?: string
}
export interface LabelAsEnvironmentDropdownSelected {
	environment_selected: string
	sources?: any[]
	workspace_slug: string
}
export interface LabelAssignedToPermissions {
	labels: any[]
	/**
	 * source admin, source read-only, personas admin, etc
	 */
	role_type: string
	workspace_id: string
	workspace_slug: string
}
export interface LabelCreationSuccessful {
	label_name: string
	workspace_id: string
	workspace_slug: string
}
export interface LabelCreationUnsuccessful {
	error_message: any[]
	label_name: string
	workspace_id: string
	workspace_slug: string
}
export interface LabelResourcesSaved {
	labeled_resources: any[]
	resource_type: string
	workspace_id: string
	workspace_slug: string
}
export interface LabelTabClicked {
	workspace_id: string
	workspace_slug: string
}
export interface LabelAssignedToPermission {
	/**
	 * the environment under which all sources are selected
	 */
	environment: string
	/**
	 * the role being applied to the user
	 */
	role: string
	workspace_slug: string
}
export interface LabelYourSourcesButtonClicked {
	workspace_billing_plan: string
	workspace_slug: string
}
export interface LabsFeatureTermsAccepted {
	feature_id: string
	/**
	 * human readable name of the feature
	 */
	feature_name?: string
	workspace_id: string
	workspace_slug?: string
}
export interface LeadCaptured {
	email: string
	event_date?: string
	event_location?: string
	event_speaker?: string
	event_topic?: string
	event_type?: string
	lead_capture_action?: string
	lead_capture_campaign?: string
	lead_capture_method?: string
	lead_capture_type?: string
	lead_source?: string
	location: string
	startup?: boolean
	url: string
}
export interface LibraryItemsImported {
	/**
	 * The kind of items being imported. Could be Properties or Rules.
	 */
	item_type: string
	/**
	 * A list of item keys imported.
	 */
	items_imported: any[]
	/**
	 * Count of items imported.
	 */
	items_imported_count: number
	/**
	 * A list of the IDs of the Libraries being imported from.
	 */
	library_ids: any[]
	/**
	 * A list of Rules receiving imported Properties (when item_type = Property)
	 */
	rules_edited?: any[]
	/**
	 * Count of Rules receiving imported Properties (when item_type = Property)
	 */
	rules_edited_count?: number
	/**
	 * The ID of the Tracking Plan receiving the imported items.
	 */
	tracking_plan_id: string
	/**
	 * The ID of the Workspace.
	 */
	workspace_id: string
	/**
	 * The slug of the Workspace.
	 */
	workspace_slug: string
}
export interface LocalStorageToggled {
	/**
	 * Enabled = true, Disabled = False
	 */
	enabled: boolean
	/**
	 * Source ID of the project this is toggled on.
	 */
	source_id: string
	/**
	 * Workspace of the project this is toggled on.
	 */
	workspace_id: string
}
export interface LockoutModalShown {
	current_plan: string
	lockout_type: string
	workspace_id: string
	workspace_slug: string
}
export interface MfaVerificationFailure {
	type?: string
}
export interface MfaCtaClicked {
	/**
	 * The user that performed the action
	 */
	user_id: string
}
export interface MfaCtaDismissed {
	/**
	 * The user that performed the action
	 */
	user_id: string
}
export interface MfaCtaSidesheetClosed {
	/**
	 * The user that performed the action
	 */
	user_id: string
}
export interface NavSearchResultClicked {
	/**
	 * The category for this search result - likely 'source', 'destination', or 'catalog'
	 */
	nav_category?: string
	/**
	 * The billing plan for the current workspace
	 */
	plan_id?: string
	/**
	 * The index indicating how far down the search results the current search result is
	 */
	search_index?: number
	/**
	 * The search term entered into Omnisearch
	 */
	search_term?: string
	/**
	 * The current user's email
	 */
	user_email?: string
	/**
	 * The current user's id
	 */
	user_id?: string
	/**
	 * The current workspace's id
	 */
	workspace_id?: string
	/**
	 * The current workspace's slug
	 */
	workspace_slug?: string
}
export interface NavSearchResultsEmpty {
	/**
	 * The workspace billing plan
	 */
	plan_id?: string
	/**
	 * The search term entered into Omnisearch that produced empty results
	 */
	search_term?: string
	/**
	 * The current user's email
	 */
	user_email?: string
	/**
	 * The current user's id
	 */
	user_id?: string
	/**
	 * The current workspace's id
	 */
	workspace_id?: string
	/**
	 * The current workspace's slug
	 */
	workspace_slug?: string
}
export interface NavSearchTermEntered {
	/**
	 * The workspace billing plan
	 */
	plan_id?: string
	/**
	 * The search term entered into Omnisearch
	 */
	search_term?: string
	/**
	 * The current user's email
	 */
	user_email?: string
	/**
	 * The current user's id
	 */
	user_id?: string
	/**
	 * The current workspace id
	 */
	workspace_id?: string
	/**
	 * The current workspace slug
	 */
	workspace_slug?: string
}
export interface NavigateClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface NetworkError {
	appTrace?: string
	/**
	 * The set of categories of errors (Access Denied, etc.)
	 */
	categories: string[]
	/**
	 * A string-ified version of category, for Destination Filters usage.
	 */
	categoryString: string
	failedGraphQLQueries?: any[]
	filename?: string
	fullStory?: string | null
	functionName?: string
	/**
	 * A string-ified version of messages, for Destination Filters usage.
	 */
	messageString: string
	/**
	 * A list of the error messages
	 */
	messages: string[]
	operation?: string
	route?: string | null
	sentryId?: any | null
	statusCode?: number | null
	timezone?: string
}
export interface NewPasswordStrength {
	new_pwned?: number
	new_score?: number
}
export interface NewTransformationClicked {
	/**
	 * Segment workspace id
	 */
	workspace_id: string
	/**
	 * Segment workspace slug
	 */
	workspace_slug: string
}
export interface NotificationBannerClicked {
	cta: string
	importance: string
	violation: string
	workspace_id: string
	workspace_slug: string
}
export interface NotificationBannerShown {
	cta: string
	importance: string
	violation: string
	workspace_id: string
	workspace_slug: string
}
export interface NotificationCenterLoadMoreClicked {
	workspace_id: string
	workspace_slug: string
}
export interface NotificationCenterOpened {
	has_unread_notifications?: boolean
	workspace_id: string
	workspace_slug: string
}
export interface NotificationClicked {
	is_unread: boolean
	template_key: string
	workspace_id: string
	workspace_slug: string
}
export interface NotificationsSettingsCategoryClick {
	/**
	 * The category for the notification
	 */
	category: string
	/**
	 * Indicates whether it was expanded or collapsed
	 */
	expanded: boolean
	/**
	 * The workspace Id
	 */
	workspace_id?: string
	/**
	 * The worksapce slug
	 */
	workspace_slug: string
}
export interface NotificationsSettingsChanged {
	/**
	 * The category for the notification
	 */
	category?: string
	/**
	 * Whether the notification was enabled or disabled
	 */
	enabled?: boolean
	/**
	 * The type of the resource the setting refers to (e.g. ware
house, destination, cloud-source)
	 */
	resource_type?: string
	/**
	 * The type of notification (web or email)
	 */
	type?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface NotificationsSettingsSidesheetCustomCategoryClick {
	resource_type: string
	workspace_slug: string
}
export interface NotificationsSettingsSidesheetLinkClick {
	integration_name: string
	resource_type: string
	workspace_slug: string
}
export interface NotificationsSettingsSidesheetOpenClick {
	category: string
	workspace_slug: string
}
export interface NotificationsSettingsSliderInteraction {
	threshold: number
	workspace_slug: string
}
export interface OAuthConsentAllowClicked {
	/**
	 * Referring domain
	 */
	domain: string
	/**
	 * OAuth scope, e.g. `workspace:read` or `destination/myapp`
	 */
	scope: string
}
export interface OAuthConsentLogoutClicked {
	/**
	 * Referring domain
	 */
	domain: string
	/**
	 * OAuth scope, e.g. `workspace:read` or `destination/myapp`
	 */
	scope: string
}
export interface OAuthConsentPageViewed {
	/**
	 * Referring domain
	 */
	domain: string
	/**
	 * OAuth scope, e.g. `workspace:read` or `destination/myapp`
	 */
	scope: string
}
export interface OAuthConsentStarted {
	/**
	 * Referring domain
	 */
	domain: string
	/**
	 * OAuth scope, e.g. `workspace:read` or `destination/myapp`
	 */
	scope: string
}
export interface OneClickDestinationsIntegrationsConfigured {
	billing_plan_id?: string
	billing_tier?: string
	current_url?: string
	/**
	 * Whether job succeeded or failed
	 */
	job_status?: string
	/**
	 * Number of integration results successfully configured for the workspace
	 */
	num_results_configured?: number
	/**
	 * Number of integration results returned by the job
	 */
	num_results_returned?: number
	/**
	 * Number of integration results selected by the user to auto-configure
	 */
	num_results_selected?: number
	qs_step?: string
	qs_track?: string
	/**
	 * Array of the integration names successfully auto-configured
	 */
	results_configured?: any[]
	/**
	 * Array of the integration names that were returned as results by Snoop Lion service
	 */
	results_returned?: any[]
	/**
	 * Array of the integration names that the user opted to auto-configure
	 */
	results_selected?: any[]
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	website_url?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface OneClickDestinationsJobCompleted {
	billing_plan_id?: string
	billing_tier?: string
	current_url?: string
	/**
	 * Whether job succeeded or failed
	 */
	job_status?: string
	/**
	 * Number of integration results returned by the job
	 */
	num_results_returned?: number
	qs_step?: string
	qs_track?: string
	/**
	 * Array of the integration names that were returned as results by Snoop Lion service
	 */
	results_returned?: any[]
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	website_url?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface OneClickDestinationsSearchOptedIn {
	billing_plan_id?: string
	billing_tier?: string
	current_url?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	website_url?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PageCallDuplicated {
	/**
	 * The generic route matcher
	 */
	route?: string
	/**
	 * The url that was possibly tracked more than once.
	 */
	url?: string
}
export interface PageViewed {
	audience_id?: string
	audience_name?: string
	/**
	 * Whether or not this page view was autotracked via the router
	 */
	autotracked?: boolean
	category?: string
	destination_slug?: string
	event_name?: string
	last_run_collection_nb?: string
	metadata_slug?: string
	metadata_type?: string
	name?: string
	path: string
	referrer?: string
	/**
	 * The generic route matcher associated with this page view.
	 */
	route?: string | null
	/**
	 * The values that make up the route matcher placeholder parameters.
	 */
	route_params?: Record<string, any>
	schema_collection?: string
	schema_object?: string
	search?: string
	slug?: string
	source_collaborators?: string
	source_enabled?: string
	source_id?: string
	source_metadata_slug?: string
	source_name?: string
	source_nb?: string
	source_slug?: string
	source_type?: string
	title?: string
	url: string
	user_id?: string
	/**
	 * The version of autotracking.
	 */
	version?: any | null
	viewport?: string
	warehouse_enabled?: string
	warehouse_id?: string
	warehouse_needs_upgrade?: string
	workspace_id?: string
	workspace_name?: string
	workspace_slug?: string
}
export interface PasswordChanged {
	current_pwned?: number
	current_score?: number
	new_pwned?: number
	new_score?: number
}
export interface PasswordSubmitted {
	hipb?: number
	score?: number
}
export interface PersonasAudienceCreated {
	audience_id: string
	audience_name: string
	destination_count: number
	destinations: string[]
	is_audience_realtime: boolean
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceDeleted {
	audience_id: string
	audience_name: string
	is_audience_realtime: boolean
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceDestinationAdded {
	audience_id: string
	audience_name: string
	destination_count: number
	destinations: string[]
	is_audience_realtime: boolean
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceDestinationRemoved {
	audience_id?: string
	audience_name?: string
	destination_name?: string
	is_audience_realtime?: boolean
	space_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasAudienceDestinationUpdated {
	audience_id: string
	audience_name: string
	destination_name: string
	is_audience_realtime: boolean
	space_id?: string
	type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceDisabled {
	audience_id: string
	audience_name: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceInsightsViewed {
	audience_id?: string
	audience_name?: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceOverlapFailed {
	audience_id?: string
	audience_name?: string
	compared_audience_id: string
	compared_audience_name: string
	is_personas_preview?: boolean
	run_id: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceOverlapSucceeded {
	audience_id?: string
	audience_name?: string
	compared_audience_id: string
	compared_audience_name: string
	is_personas_preview?: boolean
	run_id: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudiencePreviewFailed {
	ast_definition: string
	audience_id?: string
	audience_name?: string
	error_message?: string
	is_audience_realtime: boolean
	run_id: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudiencePreviewSucceeded {
	ast_definition: string
	audience_id?: string
	audience_name?: string
	is_audience_realtime: boolean
	run_id: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceRunFailed {
	audience_id?: string
	audience_name?: string
	error_message?: string
	is_sql?: boolean
	space_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasAudienceTemplateRequested {
	description: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasAudienceTemplateViewed {
	template_id?: string
	template_name?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasAudienceTemplatesViewed {
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasAudienceUpdated {
	audience_id: string
	audience_name: string
	is_audience_realtime: boolean
	space_id?: string
	status: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasClickedConnectDestination {
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasClickedSetupDestination {
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasComputationSidesheetViewed {
	computation_id: string
	computation_type: string
	space_id: string
	space_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasConnectedDestinations {
	destinations: string[]
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasContactAboutTrial {
	email?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasEnabled {
	workspace_id: string
	workspace_slug: string
}
export interface PersonasExplorerSearched {
	is_personas_preview?: boolean
	match_found: boolean
	search_string: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasGeneratedAccessToken {
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasOnboardingTourStepCompleted {
	is_personas_preview?: boolean
	step: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasProfileEventsLoadedMore {
	is_personas_preview?: boolean
	profile_id: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasProfileTabViewed {
	profile_id: string
	space_id?: string
	type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasProfileViewed {
	profile_id: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasSpaceCreated {
	space_id: string
	space_name: string
	space_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasSpaceLabelEdited {
	new_labels: any[]
	old_labels: any[]
	space_name?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasSpaceRenamed {
	space_id: string
	space_name: string
	space_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasSpaceSwitched {
	space_id: string
	space_name: string
	space_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasSpacesSettingsViewed {
	workspace_id: string
	workspace_slug: string
}
export interface PersonasSpacesViewed {
	workspace_id: string
	workspace_slug: string
}
export interface PersonasToggledImportDestination {
	destination: string
	space_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitCreated {
	destination_count: number
	destinations: string[]
	is_trait_realtime: boolean
	space_id?: string
	trait_id: string
	trait_name: string
	trait_type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitDeleted {
	is_trait_realtime: boolean
	space_id?: string
	trait_id: string
	trait_name: string
	trait_type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitDestinationAdded {
	destination_count: number
	destinations: string[]
	is_trait_realtime: boolean
	space_id?: string
	trait_id: string
	trait_name: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitDestinationRemoved {
	destination_name?: string
	is_trait_realtime?: boolean
	space_id?: string
	trait_id?: string
	trait_name?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasTraitDestinationUpdated {
	destination_name: string
	is_trait_realtime: boolean
	space_id?: string
	trait_id: string
	trait_name: string
	type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitDisabled {
	space_id?: string
	trait_id: string
	trait_name: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitPreviewClicked {
	is_trait_realtime: boolean
	space_id?: string
	trait_id?: string
	trait_name?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitPreviewFailed {
	ast_definition: string
	error_message?: string
	is_trait_realtime: boolean
	is_trait_sql: boolean
	run_id?: string
	space_id?: string
	trait_id?: string
	trait_name?: string
	trait_type: string
	warehouse_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitPreviewSucceeded {
	ast_definition: string
	is_trait_realtime: boolean
	is_trait_sql: boolean
	run_id: string
	space_id?: string
	trait_id?: string
	trait_name?: string
	trait_type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasTraitRunFailed {
	error_message?: string
	is_sql?: boolean
	space_id?: string
	trait_id?: string
	trait_name?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasTraitUpdated {
	is_trait_realtime: boolean
	space_id?: string
	status: string
	trait_id: string
	trait_name: string
	trait_type: string
	workspace_id: string
	workspace_slug: string
}
export interface PersonasViewedApiAccess {
	space_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PersonasViewedDestinations {
	space_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface PluginDisabled {
	plugin_id?: string
	plugin_slug?: string
	source_id?: string
}
export interface PluginEnabled {
	plugin_id?: string
	plugin_slug?: string
	source_id?: string
}
export interface PrivacyAlertsEnabled {
	/**
	 * The type of alert that was enabled by the user
	 */
	type: string
	workspace_id: string
}
export interface PrivacyControlApplied {
	/**
	 * Control action taken
	 */
	action?: string
	/**
	 * Control classification type: either red or yellow
	 */
	classification?: string
	/**
	 * Either Standard or Advanced controls
	 */
	control_type?: string
	/**
	 * Either Source-level or Destination level control type
	 */
	integration_type?: string
}
export interface PrivacyDemoRequested {
	/**
	 * Email of user that has requested a privacy demo.
	 */
	email: string
	/**
	 * ID of workspace that has requested a privacy demo.
	 */
	workspace_id: string
	/**
	 * Slug of workspace that has requested a privacy demo.
	 */
	workspace_slug: string
}
export interface QuickStartAdditionalIntegrationsSelected {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	number_of_integrations?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartCredentialsAdded {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	destination_id?: string
	destination_slug?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartCredentialsSkipped {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	destination_id?: string
	destination_slug?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartDestinationSelected {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	destination_id?: string
	destination_slug?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_slug?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartFinishedButtonClicked {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	destination_id?: string
	destination_slug?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	workspace_email?: string
	workspace_id?: string
}
export interface QuickStartFlowExited {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	destination_id?: string
	destination_slug?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartNextButtonClicked {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	qs_step?: string
	qs_track?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartPathSelected {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	qs_step?: string
	/**
	 * Which path the user selected in the flow (exploring/ int setup)
	 */
	qs_track?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartPreviousButtonClicked {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	qs_step?: string
	qs_track?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface QuickStartSourceSelected {
	billing_plan_id?: string
	billing_tier?: string
	/**
	 * URL or path that the user is currently on when they trigger the event
	 */
	current_path?: string
	qs_step?: string
	qs_track?: string
	source_id?: string
	source_slug?: string
	user_email?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface RedundantDestinationEnableAttempted {
	destination_slug: string
}
export interface ResetPassword {
	user: string
}
export interface RetriesToggled {
	/**
	 * Enabled = true, Disabled = false
	 */
	enabled: boolean
	/**
	 * Source ID of the project this is toggled on.
	 */
	source_id?: string
	/**
	 * Workspace of the project this is toggled on.
	 */
	workspace_id?: string
}
export interface RunHistoryViewed {
	runId: string
	source: string
	status: string
	warehouseId: string
	workspaceId: string
	workspaceSlug: string
}
export interface SsoConnectionCreated {
	sso_connection_id: string
	workspace_slug: string
}
export interface SsoConnectionDefaultChanged {
	sso_connection_id: string
}
export interface SsoConnectionDeleted {
	sso_connection_id: string
}
export interface SsoConnectionToggled {
	sso_connection_id: string
}
export interface SsoConnectionUpdated {
	sso_connection_id: string
}
export interface SsoDomainAdded {
	sso_domain_name: string
}
export interface SsoDomainRemoved {
	sso_domain_name: string
}
export interface SsoDomainVerified {
	sso_domain_name: string
}
export interface SsoForced {
	sso_forced: boolean
}
export interface SaveButtonBulkAssignEnvironmentsClick {
	/**
	 * A list of SourceEnvironments object. ie [ { source: 'app', environment: 'prod' }]
	 */
	sourceEnvironments?: any[]
	workspace_slug: string
}
export interface ScheduledVacuumingDisabled {
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface ScheduledVacuumingEnabled {
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface ScheduledVacuumingUpdated {
	vacuum_interval: string
	vacuum_interval_count: number
	vacuum_timezone: string
	vacuum_timezone_hour: string
	vacuum_utc_hour: string
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface SchemaDefaultToggle {
	new_value: boolean
	setting_key: string
	setting_name: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SchemaDefaultsRequested {
	/**
	 * Segment source id
	 */
	source_id: string
	/**
	 * Segment source slug
	 */
	source_slug: string
	/**
	 * The currently logged in user's email.
	 */
	user_email: string
	/**
	 * The currently logged in user's Segment id.
	 */
	user_id: string
	/**
	 * The currently logged in user's full name.
	 */
	user_name: string
	/**
	 * Segment workspace id
	 */
	workspace_id: string
	/**
	 * Segment workspace slug
	 */
	workspace_slug: string
}
export interface SchemaDestinationToggle {
	integration_slug: string
	new_setting: string
	object_name: string
	schema_collection: string
	schema_object: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SchemaEventPropertiesConditionalSave {
	allow_null: string
	category: string
	data_type: string
	event_name: string
	property_name: string
	regex: string
	schema_collection: string
	schema_object: string
	source_slug: string
	workspace_slug: string
}
export interface SchemaToggle {
	new_setting: string
	object_name: string
	schema_collection: string
	schema_object: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SetEnvPermissionsOnSourceAdmin {
	environment_type: string
	/**
	 * user that the permission was set on, not the user setting the permission
	 */
	user_email_address: string
	workspace_id: string
	workspace_slug: string
}
export interface SetEnvPermissionsOnSourceReadOnly {
	environment_type: string
	user_email_address: string
	workspace_id: string
	workspace_slug: string
}
export interface SideNavClicked {
	target: string
	workspace_slug: string
}
export interface SideNavClickedCatalog {
	target: string
	workspace_slug: string
}
export interface SideNavClickedDestinations {
	target: string
	workspace_slug: string
}
export interface SideNavClickedDocs {
	target: string
	workspace_slug: string
}
export interface SideNavClickedHealth {
	target: string
	workspace_slug: string
}
export interface SideNavClickedOverview {
	target: string
	workspace_slug: string
}
export interface SideNavClickedPersonas {
	target: string
	workspace_slug: string
}
export interface SideNavClickedProtocols {
	target: string
	workspace_slug: string
}
export interface SideNavClickedSettings {
	target: string
	workspace_slug: string
}
export interface SideNavClickedSources {
	target: string
	workspace_slug: string
}
export interface SidepanelMoveClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface SignupDemoRequestSubmitted {
	business_type?: any | null
	company?: any | null
	company_size?: any | null
	email?: any | null
	name?: any | null
	phone?: any | null
	role?: any | null
}
export interface SignupNextClicked {
	email: string
	enable_signup?: boolean
	partner_signup?: boolean
	plan: string
	step: string
	strong_signup?: boolean
}
export interface SignupPageViewed {
	email?: string
	/**
	 * Signups from the OAuth / Enable With Segment flow.
	 */
	enable_signup?: boolean
	/**
	 * Whether the user has landed on the signup page with an incorrectly formatted token.
	 */
	has_invalid_invite_token?: boolean
	/**
	 * Whether the user has landed on the signup page with an invite token.
	 */
	has_invite_token?: boolean
	/**
	 * These are partner sign-ups for Dev Center.
	 */
	partner_signup?: boolean
	startup?: boolean
	/**
	 * which step the user is on (first = user details; second = business details)
	 */
	step?: string
	/**
	 * whether or not the user is served the password strength validation feature
	 */
	strong_signup?: boolean
}
export interface SignupPasswordStrengthValidated {
	/**
	 * Email address inputted by the user
	 */
	email?: string
	/**
	 * how many times a password has been breached according to the HIBP database
	 */
	hibp?: any | null
	/**
	 * Password strength score returned
	 */
	score?: number
	/**
	 * Whether or not the user is able to sign up with that password
	 */
	success?: boolean
}
export interface SiteExited {
	link_location: string
	link_target: string
	link_text: string
	name: string
}
export interface SlothOfDeath {
	appTrace: string
	/**
	 * The set of categories of errors (Access Denied, etc.)
	 */
	categories: string[]
	/**
	 * A string-ified version of category, for Destination Filters usage.
	 */
	categoryString: string
	failedGraphQLQueries?: any[]
	filename: string
	fullStory?: string | null
	functionName: string
	/**
	 * A string-ified version of messages, for Destination Filters usage.
	 */
	messageString: string
	/**
	 * A list of the error messages
	 */
	messages: string[]
	route: string | null
	sentryId?: any | null
	timezone: string
}
export interface SortApplied {
	/**
	 * The direction of the sort, either asc or desc.
	 */
	direction?: string
	/**
	 * The field that was sorted on.
	 */
	field?: string
	location: string
	source_id?: string
	source_slug?: string
	/**
	 * specifies sublocation where the user is entering and applying the filter. (ex. when filtering in the Tracking Plan Editor, use to specify if user is on the Track, Identify, etc tab)
	 */
	sublocation?: string
	workspace_id?: string
	workspace_slug: string
}
export interface SourceAuthorizeClicked {
	funnel_step: string
	source_id?: string
	source_metadata_category: string
	source_metadata_slug: string
	source_name?: string
	source_slug?: string
	source_type?: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceAuthorized {
	source_id: string
	source_metadata_slug: string
	source_name: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceAuthorizedFailed {
	error: string
}
export interface SourceBasicSettingsChanged {
	source_enabled: boolean
	source_id: string
	source_name: string
	source_old_name: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceCollaboratorInvitedLegacy {
	plan?: any | null
	source_id?: any | null
	source_slug?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface SourceCreated {
	source_count: string
	source_id: string
	source_metadata_category: string
	source_metadata_slug: string
	source_name: string
	source_slug: string
	source_type: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceDeleteClicked {
	source_count: string
	source_enabled: boolean
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceDeleted {
	source_count: string
	source_id: string
	source_metadata_category: string
	source_metadata_slug: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceDisabled {
	source_count: string
	source_id: string
	source_metadata_category: string
	source_metadata_slug: string
	source_name: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceEnabled {
	source_count: string
	source_id: string
	source_metadata_category: string
	source_metadata_slug: string
	source_name: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceLabelEdited {
	new_labels: any[]
	old_labels: any[]
	source_name: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceMoved {
	source_enabled: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_old_slug: string
	workspace_slug: string
}
export interface SourceOverviewAccordionToggled {
	accordion: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceOverviewLinkClicked {
	link: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceSqlSettingsChanged {
	source_enabled: string
	source_id: string
	source_old_slug: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceSchemaCleared {
	source_id?: string
	source_slug: string
	workspace_id?: string
	workspace_slug: string
}
export interface SourceSchemaRefreshClicked {
	source_enabled: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceSchemaRefreshed {
	source_enabled: string
	source_has_sent_data: string
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceSetupFunnelStepCompleted {
	cta_text: string
	error_level?: string
	error_message?: string
	error_reason?: string
	funnel_step: string
	source_metadata_category: string
	source_metadata_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface SourceWriteKeyGenerated {
	source_id: string
	workspace_id: string
}
export interface SourceWriteKeyRevoked {
	source_id: string
	workspace_id: string
}
export interface SourceSearchedOnBulkAssignEnvironments {
	search_term: string
	workspace_slug: string
}
export interface SourcesCollectionToggled {
	/**
	 * The ID of the collection
	 */
	collection_id?: string
	/**
	 * The name of the collection
	 */
	collection_name?: string
	/**
	 * True/False
	 */
	enabled?: boolean
	/**
	 * The ID of the Source
	 */
	source_id?: string
}
export interface SourcesFieldToggled {
	/**
	 * The ID of the collection the field is nested under
	 */
	collection_id?: string
	/**
	 * True or False
	 */
	enabled?: boolean
	/**
	 * The ID of the field
	 */
	field_id?: string
	/**
	 * The name of the field
	 */
	field_name?: string
	/**
	 * The ID of the Source
	 */
	source_id?: string
}
export interface SourcesLinkClicked {
	''?: any | null
	source_metadata_slug?: string
	workspace_id: string
	workspace_slug: string
}
export interface SplitAccountButtonClicked {
	/**
	 * slug
	 */
	workspace: string
}
export interface SplitAccountButtonViewed {
	/**
	 * slug
	 */
	workspace: string
}
export interface StarterTrackingPlanCreated {
	business_type: any | null
	/**
	 * Array of all the event names (including Page, Screen, Identify, Track events) that are selected when the user submits the Starter Tracking Plan form
	 */
	events: any[]
	source_slug: any | null
	user_email: any | null
	user_id: any | null
	workspace_id: any | null
	workspace_slug: any | null
}
export interface StartupApplicationCompleted {
	/**
	 * The mailing address for a company
	 */
	company_address?: string
	company_industry?: string
	company_name: string
	company_website: string
	/**
	 * The URL for a company's profile on Crunchbase
	 */
	crunchbase_profile: string
	date_founded: string
	/**
	 * Number of employees at the company
	 */
	employee_count: number
	experience_with_segment: string
	/**
	 * The total funding raised (USD)
	 */
	funding_raised: string
	funding_round: string
	/**
	 * Is the company affiliated with one of our partners?
	 */
	is_partner_affiliated?: boolean
	personal_linkedin_profile: string
	/**
	 * How will the customer be looking to use Segment
	 */
	segment_usage: string
}
export interface StepCompletedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	name: string
	sessionId: string
	stepId: string
	stepType: string
	timestamp: string
	user: string
}
export interface StepInteractedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	interaction: string
	interactionType: string
	name: string
	sessionId: string
	stepChildId: string
	stepChildNumber: string
	stepId: string
	stepType: string
	timestamp: string
	user: string
}
export interface StepSkippedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	name: string
	sessionId: string
	stepChildId: string
	stepChildNumber: string
	stepId: string
	stepType: string
	timestamp: string
	user: string
}
export interface StepStartedAppcues {
	flowId: string
	flowName: string
	flowType: string
	flowVersion: string
	name: string
	sessionId: string
	stepId: string
	stepType: string
	timestamp: string
	user: string
}
export interface SubmittedWishlistIntegrationRequest {
	/**
	 * source or a destination
	 */
	integration_type: string
	/**
	 * use-case for the request
	 */
	reason: string
	requested_integration_id: string
	/**
	 * name of the tool requested
	 */
	tool_name: string
	/**
	 * website/url of the tool
	 */
	tool_url: string
}
export interface SubscriptionPlanChangeError {
	newPlan: string
	previousPlan: string
	workspaceId: string
	workspaceSlug: string
}
export interface SubscriptionPlanChanged {
	newPlan: string
	newPlanLevel?: string
	previousPlan: string
	version?: string
	workspaceId: string
	workspaceSlug?: string
}
export interface SubscriptionPlanFailed {
	newPlan: string
	newPlanLevel?: string
	previousPlan: string
	workspaceId: string
	workspaceSlug?: string
}
export interface SupportAccessGrantCreated {
	email?: string
	token_expires_at?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface SupportAccessGrantRevoked {
	email?: string
	token_expires_at?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface SurveyClosed {
	plan_type: string
	/**
	 * This is never provided in the app.
	 */
	survey_id?: string
	survey_medium: string
	survey_name: string
	survey_other_feedback: string
	survey_primary_label?: string
	survey_primary_value?: string
	survey_secondary_label?: string
	survey_secondary_value?: string
	survey_time_elapsed: number
	survey_tool: string
	survey_type: string
	workspace_created_date: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface SurveyCompleted {
	plan_type: string
	/**
	 * This is never provided in the app.
	 */
	survey_id?: string
	survey_medium: string
	survey_name: string
	survey_other_feedback: string
	survey_primary_label: string
	survey_primary_value: string
	survey_secondary_label: string
	survey_secondary_value: string
	survey_time_elapsed: number
	survey_tool: string
	survey_type: string
	workspace_created_date: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface SurveyViewed {
	survey_medium: string
	survey_name: string
	survey_tool: string
	survey_type: string
	workspace_created_date: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface TagAnEventClicked {
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface RolesItem {
	all?: boolean
	name?: string
	resources?: string[]
}
export interface TeamMemberDetailViewClosed {
	/**
	 * Current number of users in the workspace excl this invite
	 */
	current_member_count?: number
	roles?: RolesItem[]
	team_member_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface RolesItem1 {
	all?: boolean
	name?: string
	resources?: string[]
}
export interface TeamMemberDetailViewed {
	/**
	 * Current number of users in the workspace excl this invite
	 */
	current_member_count?: number
	roles?: RolesItem1[]
	team_member_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface RolesItem2 {
	all?: boolean
	name?: string
	resources?: string[]
}
export interface TeamMemberInvited {
	/**
	 * Current number of users in the workspace excl this invite
	 */
	current_member_count?: number
	/**
	 * The email of the invited member
	 */
	invitee_email?: string
	/**
	 * Developer,Team,BT
	 */
	plan?: any | null
	roles?: RolesItem2[]
	team_member_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface TeamMemberInvitedLegacy {
	plan?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface RolesItem3 {
	all?: boolean
	name?: string
	resources?: string[]
}
export interface TeamMemberRemoved {
	/**
	 * Current number of users in the workspace excl this invite
	 */
	current_member_count?: number
	roles?: RolesItem3[]
	team_member_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface RolesItem4 {
	all?: boolean
	name?: string
	resources?: string[]
}
export interface TeamMemberSaved {
	/**
	 * The roles added to this user
	 */
	added_roles?: string[]
	/**
	 * Current number of users in the workspace excl this invite
	 */
	current_member_count?: number
	/**
	 * The roles removed from this user
	 */
	removed_roles?: string[]
	roles?: RolesItem4[]
	team_member_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ToolRequestFormSubmitted {
	company: string
	email: string
	layout: string
	name: string
	platforms: string
	reason: string
	repo: string
	tool: string
	tool_requested_name: string
	tool_requested_type: string
	tool_types_displayed: string
	tools: string
	type: string
	use_case: string
	workspaceSlug: string
	workspace_id: string
	workspace_slug: string
}
export interface TrackingPlanConnectionChanged {
	/**
	 * true if source connected to TP, false if disconnected
	 */
	connected: boolean
	/**
	 * project_id of the source being connected
	 */
	connected_source_id: string
	/**
	 * slug of source being connected
	 */
	connected_source_slug?: string
	/**
	 * How the tracking plan was updated (Options: api | app)
	 */
	origin?: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * segment workspace id
	 */
	workspace_id: string
	/**
	 * segment workspace slug
	 */
	workspace_slug?: string
}
export interface TrackingPlanCreated {
	/**
	 * An array of strings listing which events were added or edited.
	 */
	events_edited?: string[]
	/**
	 * How the tracking plan was updated (Options: api | app)
	 */
	origin?: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * The type of Tracking Plan (because Tracking Plans can also be Libraries).
	 */
	type?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TrackingPlanDeleted {
	/**
	 * How the tracking plan was updated (Options: api | app)
	 */
	origin?: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * The type of Tracking Plan (because Tracking Plans can also be Libraries).
	 */
	type?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TrackingPlanEventVersionAdded {
	/**
	 * The id of the resource (tracking plan) if it was updated.
	 */
	resource_updated?: string | null
	/**
	 * key for the rule that the user added a version to
	 */
	rule_key: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * version number that was created
	 */
	version_number: number
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TrackingPlanInferred {
	/**
	 * An array of strings listing which events were added or edited.
	 */
	events_edited?: string[]
	/**
	 * how the tracking plan was inferred. Use source for infer from source, and spec for infer from spec.
	 */
	infer_type?: string
	/**
	 * Source ID of the interred source.
	 */
	source_id?: string
	/**
	 * The name of the inferred source
	 */
	source_name?: string
	/**
	 * The name of the inferred spec.
	 */
	spec_name?: string
	/**
	 * The length of time that events were inferred from.
	 */
	timeframe?: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * The type of this Tracking Plan.
	 */
	type?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TrackingPlanSaved {
	/**
	 * An array of ids of events that were edited.
	 */
	events_edited?: string[]
	/**
	 * The count of unique events edited on Tracking Plan Save.
	 */
	events_edited_count?: number
	/**
	 * How the tracking plan was updated (Options: api | app)
	 */
	origin?: string
	/**
	 * The id of the resource (tracking plan) if it was updated.
	 */
	resource_updated?: string | null
	/**
	 * An array of ids of rules that were deleted
	 */
	rules_deleted?: string[]
	/**
	 * The count of unique rules that were deleted.
	 */
	rules_deleted_count?: number
	/**
	 * An array of keys of rules that were edited
	 */
	rules_edited?: string[]
	/**
	 * The count of unique rules that were edited
	 */
	rules_edited_count?: number
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * The type of Tracking Plan (because Tracking Plans can also be Libraries).
	 */
	type?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TrackingPlanTipInteracted {
	/**
	 * Indicates which action the user took with the tip - can be Opened, Ignored or Accepted
	 */
	interaction: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TrackingSpecsSelected {
	/**
	 * Code snippets that correspond to track events a user has selected in the What to Track step of the onboarding flow
	 */
	specs: string[]
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface TransactionalError {
	appTrace?: any | null
	/**
	 * The set of categories of errors (Access Denied, etc.)
	 */
	categories: string[]
	/**
	 * A string-ified version of category, for Destination Filters usage.
	 */
	categoryString: string
	displayName: string
	extra?: string
	failedGraphQLQueries?: any[]
	feature?: string
	fullStory?: string | null
	/**
	 * A string-ified version of messages, for Destination Filters usage.
	 */
	messageString: string
	/**
	 * A list of the error messages
	 */
	messages: string[]
	path: string
	route: string | null
	sentryId?: any | null
	timezone: string
	transactionTitle: string
}
export interface ActionsItem {
	/**
	 * Events selected to transform
	 */
	event_names?: string
	/**
	 * Properties being transformed, if any
	 */
	property_names?: string
	/**
	 * Type of transformation applied. Options: Map, hash, filter, etc.
	 */
	type?: string
}
export interface TransformationCreated {
	/**
	 * List of tsub actions to perform.
	 */
	actions: ActionsItem[]
	/**
	 * Whether the transformation is enabled.
	 */
	enabled: boolean
	/**
	 * Name entered by customer to describe transformation
	 */
	name: string
	/**
	 * Array of sourceIds for sources selected to apply the transformation. Currently limited to 1.
	 */
	selected_source_id: string[]
	/**
	 * Unique id created for each transformation
	 */
	transformation_id: string
	/**
	 * Where the transformation is applied. Options: source or destination
	 */
	transformation_scope: string
	/**
	 * The ID of the workspace where the Transformations overview was opened.
	 */
	workspace_id: string
	/**
	 * The slug of the workspace where the Transformations overview was opened.
	 */
	workspace_slug: string
}
export interface TransformationDeleted {
	/**
	 * Unique id created for each transformation
	 */
	transformation_id: string
	/**
	 * The ID of the workspace where the Transformations overview was opened.
	 */
	workspace_id: string
	/**
	 * The slug of the workspace where the Transformations overview was opened.
	 */
	workspace_slug: string
}
export interface TriggerTypeReSelected {
	new_trigger?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface UrlFieldEdited {
	default_url?: any | null
	new_url?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface UnreadNotificationCountDisplayed {
	workspace_id: string
	workspace_slug: string
}
export interface UpdateOnboardingStepState {
	/**
	 * State of the step after update
	 */
	new_state: string
	/**
	 * State of the step prior to update
	 */
	previous_state: string
	/**
	 * Unique identifier for the step
	 */
	step_id: string
	/**
	 * Title of the step
	 */
	step_title: string
	user_id: string
	/**
	 * ="Yes" if w. VT; ="No" if w.o VT
	 */
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
	/**
	 * ID of the workspace step; optional since the event may create the step on the backend
	 */
	workspace_step_id: number
}
export interface UpdateProfileClicked {
	email_new: string
	email_old: string
	full_name_new: string
	full_name_old: string
}
export interface UpdatedComponents {
	destination_slug: string
	source?: string
}
export interface UpdatedContacts {
	destination_slug: string
	source?: string
}
export interface UpgradeCtaClicked {
	billing_tier: string
	current_url: string
	/**
	 * This field should describe the position of the CTA in the workspace when the user clicks it. This will help us test performance of various locations for this button.
	 */
	position?: string
	workspace_id: string
	workspace_slug: string
}
export interface UpvotedWishlistIntegrationRequest {
	/**
	 * source or a destination
	 */
	integration_type: string
	/**
	 * reason for upvoting/requesting the integration
	 */
	reason?: any | null
	requested_integration_id?: string
	/**
	 * name of the tool requested
	 */
	tool_name: string
	/**
	 * website/url of the tool
	 */
	tool_url: string
}
export interface UserCreated {
	email: string
	name: string
	source: string
	traits: string
	type: string
	workspace_plan: string
}
export interface UserImpersonated {
	impersonated_method: string
	impersonated_user_email: string
	impersonated_workspace?: string
}
export interface UserSignedUp {
	/**
	 * The selected billing plan that will be applied to this user's first workspace.
	 */
	billing_plan?: string
	email: string | null
	enable_signup?: boolean
	/**
	 * Whether the user signed up with an invite token that was found to be invalid.
	 */
	has_invalid_invite_token?: boolean
	/**
	 * Whether the user signed up with an invite token.
	 */
	has_invite_token?: boolean
	partner_signup?: boolean
	startup?: boolean | null
	strong_signup: boolean | null
	type: string | null
}
export interface VtGetStartedButtonClicked {
	billing_plan_id?: any | null
	billing_tier?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface VtLegalModalInstallButtonClicked {
	billing_plan_id?: any | null
	billing_tier?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface VtViewDebuggerClicked {
	/**
	 * The number of visual events in the spec at the time that the user clicks this button
	 */
	num_visual_events?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ValidateDataClicked {
	/**
	 * specifies where the user clicked from. "Tracking Plan List" if clicking from TP list view. "Source Schema" if clicking from schema.
	 */
	location?: string
	tracking_plan_id?: string
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ViewChangelogClicked {
	/**
	 * The ID of the Tracking Plan.
	 */
	tracking_plan_id: string
	/**
	 * The ID of the workspace that the Tracking Plan belongs to.
	 */
	workspace_id: string
	/**
	 * The slug of the workspace that the Tracking Plan belongs to.
	 */
	workspace_slug: string
}
export interface ViewDebuggerClicked {
	/**
	 * ie "workspace checklist"
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
}
export interface ViewLibrariesClicked {
	/**
	 * The location in the app where the activity took place.
	 */
	location: string
	/**
	 * The ID of the workspace where the Libraries overview was opened.
	 */
	workspace_id: string
	/**
	 * The slug of the workspace where the Libraries overview was opened.
	 */
	workspace_slug: string
}
export interface ViewSchemaConfigurationClicked {
	/**
	 * specifies where the user is clicking from (schema tab or tp list)
	 */
	location: string
}
export interface ViewSourceSchemaClicked {
	/**
	 * specifies where the user is clicking from (tp list or data validation)
	 */
	location: string
}
export interface ViewTrackingPlanClicked {
	/**
	 * specifies where the user was when clicking to view violations
	 */
	location: string
	/**
	 * resource id for the tracking plan
	 */
	tracking_plan_id: string
	/**
	 * The type of Tracking Plan (because Tracking Plans can also be Libraries).
	 */
	type?: string
	/**
	 * workspace id associated with tracking plan
	 */
	workspace_id: string
	/**
	 * workspace slug associated with tracking plan
	 */
	workspace_slug: string
}
export interface ViewTransformationsClicked {
	/**
	 * The location in the app where the activity took place.
	 */
	location: string
	/**
	 * The ID of the workspace where the Transformations overview was opened.
	 */
	workspace_id: string
	/**
	 * The slug of the workspace where the Transformations overview was opened.
	 */
	workspace_slug: string
}
export interface ViewViolationsClicked {
	/**
	 * event id
	 */
	event_id?: string
	/**
	 * specifies where the user was when clicking to view violations
	 */
	location: string
	/**
	 * segment source id
	 */
	source_id?: string
	/**
	 * segment source slug
	 */
	source_slug?: string
	/**
	 * specifies what level of violations the user wants to see. Source when clicking from Schema. Event when clicking into event detail. Property when clicking into property detail.
	 */
	type: string
	/**
	 * segment workspace id
	 */
	workspace_id: string
	/**
	 * segment workspace slug
	 */
	workspace_slug?: string
}
export interface ViewedFeaturedDestinations {
	workspace_slug: string
}
export interface ViewedIntegration {
	projectId: string
	projectSlug: string
	workspaceId: string
	workspaceLogin: string
}
export interface ViewedLockout {
	user_email?: string
	user_id?: string
	workspace_id?: string
}
export interface ViolationsDeleted {
	source_id?: string
	source_slug: string
	workspace_id?: string
	workspace_slug: string
}
export interface VisitedIntegrationDocs {
	name: string
}
export interface VisualEventCreated {
	event_handler?: any | null
	event_name?: any | null
	properties?: any[]
	selector?: any | null
	/**
	 * ID of the customer's source that this event will be created for
	 */
	source_id?: any | null
	/**
	 * Slug of the customer's source that this event will be created for
	 */
	source_slug?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface VisualTaggerAddPropertyClicked {
	event_name?: string
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerAdvancedOptionsClicked {
	event_name?: string
	properties?: any | null
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerCopySnippetClicked {
	/**
	 * so that we know the event is fired from VT
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerCreateEventClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerCreateEventsClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerCreateNewClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerDeleteClicked {
	events: any[]
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerDocClicked {
	/**
	 * ="VT Home Page"
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerEditClicked {
	events: any[]
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerEnterValueClicked {
	event_name?: any | null
	property?: any | null
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerEventCreated {
	event_name: string
	properties?: any | null
	selector?: any | null
	source_id: string
	source_slug: string
	/**
	 * the url of the webpage that has been entered to create tagging
	 */
	url?: any | null
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerEventSaved {
	event_name?: any | null
	properties?: any | null
	source_id?: string
	source_slug?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface VisualTaggerEventTested {
	event_name: string
	properties?: any | null
	source_id: string
	source_slug: string
	/**
	 * true if test is successful, false if not.
	 */
	test_result: boolean
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerExitClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerGetStartedButtonClicked {
	source_id: string
	source_slug: string
	user_id?: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerGuideClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerIntegrationToggled {
	/**
	 * Enabled = true, Disabled = false
	 */
	enabled: boolean
	/**
	 * Source ID of the project this is toggled on
	 */
	source_id?: string
	/**
	 * Workspace of the project this is toggled on.
	 */
	workspace_id?: string
}
export interface VisualTaggerLearnBestPracticeClicked {
	event_name?: string
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerPublishClicked {
	number_of_events: number
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerSelectValueFromPageClicked {
	event_name?: any | null
	property?: any | null
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerSetupStepsContinueClicked {
	source_id?: string
	source_slug?: string
	user_id?: string
	workspace_id?: string
	workspace_slug?: string
}
export interface VisualTaggerTemplateClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerTestEventsClicked {
	number_of_events: number
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerTrackAnyClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerTrackButtonsClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerTrackFormsClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerVideoClicked {
	source_id: string
	source_slug: string
	/**
	 * ='Introduction" or "How-to'
	 */
	type: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerViewAgreementClicked {
	source_id: string
	source_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface VisualTaggerViewExtensionClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseConnectionFailed {
	error: string
	warehouse_type: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseConnectionTested {
	status: boolean
	warehouse_type: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseConnectionUpdated {
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseCreated {
	warehouse_id: string
	warehouse_slug: string
	warehouse_type: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface WarehouseDeleteClicked {
	warehouse_id: string
	warehouse_slug?: string
	workspace_id: string
	workspace_name: string
}
export interface WarehouseDeleted {
	warehouse_id: string
	warehouse_slug: string
	warehouse_type: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface WarehouseDisabled {
	warehouse_id: string
	warehouse_slug: string
	warehouse_type: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface WarehouseEnabled {
	warehouse_id: string
	warehouse_slug: string
	warehouse_type: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface WarehouseNicknameChanged {
	warehouse_id: string
	warehouse_name: string
	warehouse_old_name: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseSchemaUpdated {
	/**
	 * Number of changes made to collections syncing to a Warehouse
	 */
	num_changes_collections: number
	/**
	 * Number of changes that are disabling property/source/collection
	 */
	num_changes_disabled: number
	/**
	 * Number of changes that are enabling property/source/collection
	 */
	num_changes_enabled: number
	/**
	 * Number of changes made to properties syncing to a Warehouse
	 */
	num_changes_properties: number
	/**
	 * Number of changes made to sources syncing to Warehouse
	 */
	num_changes_sources?: number
	/**
	 * Number of total changes made to source/collection/property
	 */
	num_changes_total: number
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseSettingsSaved {
	warehouse_id: string
	warehouse_slug: string
	warehouse_type: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface WarehouseSimulatorQueryExecuted {
	execution_error?: any | null
	/**
	 * The SQL query executed
	 */
	sql?: any | null
}
export interface WarehouseSourceEnableToggled {
	/**
	 * Whether the warehouse/source is being enabled or disabled
	 */
	enabled: boolean
	source_id: string
	source_slug: string
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseSyncScheduleDisabled {
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseSyncScheduleEnabled {
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WarehouseSyncScheduleSaved {
	sync_times: string
	sync_times_count: number
	sync_timezone: string
	warehouse_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceCreated {
	bucket: string
	email: string
	startup: boolean
	workspace_count: string
	workspace_id: string
	workspace_name: string
	workspace_plan: string
	workspace_slug: string
}
export interface WorkspaceDeleted {
	workspace_created_date: string
	workspace_id: string
	workspace_name: string
	workspace_slug: string
}
export interface WorkspaceHomeAddVisualTaggerClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceHomeEditDestinationSettings {
	destination_id: string
	destination_slug: string
	/**
	 * ="Yes" if w. VT, ="No" if without
	 */
	flag_on_vt: boolean
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceHomeViewCatalogClicked {
	/**
	 * workspace home checklist
	 */
	location: string
	source_id: string
	source_slug: string
	user_id: string
	/**
	 * ='Yes" for VT;="No" if without VT
	 */
	vt_flag_on: boolean
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceHomeViewCodeDocsClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceHomeVisualTaggerCopySnippetClicked {
	source_id: string
	source_slug: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceInsightsCsvDownloaded {
	period: string
	type?: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceInsightsPeriodChanged {
	period: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceSettingsTabClicked {
	tab: string
}
export interface WorkspaceUsageMetricCsvDownloaded {
	/**
	 * The current usage metric
	 */
	metric: string
	/**
	 * The selected invoice period's end date
	 */
	period_end: string
	/**
	 * The selected invoice period's start date
	 */
	period_start: string
	/**
	 * The id of the workspace
	 */
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceUsageMetricOverviewDetailsExpanded {
	metric: string
	period_end: string
	period_start: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceUsageMetricTabSelected {
	metric: string
	period_end: string
	period_start: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceUsageMetricTooltipViewed {
	metric: string
	period_end: string
	period_start: string
	/**
	 * The attribute name linked to the tooltip
	 */
	tooltip_parent_attribute: string
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceUsagePeriodChanged {
	metric?: string | null
	/**
	 * The select invoice period's end date.
	 */
	period_end: string
	/**
	 * The selected invoice period's start date.
	 */
	period_start: string
	/**
	 * The id of the workspace
	 */
	workspace_id: string
	workspace_slug: string
}
export interface WorkspaceUsageUpgradeCtaClicked {
	metric?: string | null
	period_end: string
	period_start: string
	workspace_id: string
	workspace_slug: string
}
export interface OriginalFlag {
	name: string
	value: boolean
}
export interface PrototypedFlag {
	name: string
	value: boolean
}
export interface WorkspacesFlagsComparison {
	are_equal: boolean
	original_flag: OriginalFlag
	prototyped_flag: PrototypedFlag
	used_original_value: boolean
	workspace_id: string
}
export interface OriginalQuota {
	is_valid: boolean
	name: string
	value: any | null
}
export interface PrototypedQuota {
	is_valid: boolean
	name: string
	value: any | null
}
export interface WorkspacesQuotaComparison {
	are_equal: boolean
	original_quota: OriginalQuota
	prototyped_quota: PrototypedQuota
	used_original_value: boolean
	workspace_id: string
}
export interface WriteKeyChangeClicked {
	source_enabled: string
	source_has_sent_data?: boolean
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface WriteKeyChanged {
	source_enabled: string
	source_has_sent_data?: boolean
	source_id: string
	source_slug: string
	workspace_id: string
	workspace_slug: string
}
export interface WritekeyRetryClicked {
	/**
	 * URL that the user is currently on when they click this button
	 */
	URL?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface DoNotAddYetWorkspaceHomeSetupGuideDocsClicked {
	billing_plan_id?: any | null
	billing_tier?: any | null
	user_id?: any | null
	workspace_id?: any | null
	workspace_slug?: any | null
}
export interface ClickedConnectPaneLink {
	link: string
	link_text: string
	tool_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}
export interface ViewedConnectPane {
	tool_name: string
	user_id: string
	workspace_id: string
	workspace_slug: string
}

export type ViolationHandler = (
	message: Record<string, any>,
	violations: any[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (
	message,
	violations
) => {
	const msg = JSON.stringify(
		{
			type: 'Typewriter JSON Schema Validation Error',
			description:
				`You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
				'Tracking Plan spec.',
			errors: violations,
		},
		undefined,
		2
	)

	console.warn(msg)
}

let analytics: () => SegmentAnalytics.AnalyticsJS | undefined = () => {
	return window.analytics
}

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
	/**
	 * Underlying analytics instance where analytics calls are forwarded on to.
	 * Defaults to window.analytics.
	 */
	analytics?: SegmentAnalytics.AnalyticsJS
	/**
	 * Handler fired when if an event does not match its spec. This handler
	 * does not fire in production mode, because it requires inlining the full
	 * JSON Schema spec for each event in your Tracking Plan.
	 *
	 * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
	 * if a message does not match the spec. Otherwise, errors will be logged to stderr.
	 */
	onViolation?: ViolationHandler
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
	analytics = options.analytics
		? () => options.analytics || window.analytics
		: analytics
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Segment.Options = {}): Segment.Options {
	return {
		...message,
		context: {
			...(message.context || {}),
			typewriter: {
				language: 'typescript',
				version: '7.0.0',
			},
		},
	}
}

/**
 * @typedef AccessDeniedError
 * @property {string} appVersion -
 * @property {any[]} [failedGraphQLQueries] -
 * @property {string | null} [fullStory] -
 * @property {string} reason - The reason access was denied is a hint that describes whether you couldn't access the workspace or thing you were trying to do because the workspace requires SSO and you aren't auth'd with SSO, or MFA is required, or you are logged in with a different SSO connection than required.
 * @property {string | null} route -
 * @property {string} team -
 * @property {string} timezone -
 * @property {string} [workspaceId] -
 * @property {string} [workspaceSlug] -
 */
/**
 * @typedef ActivityFeedFiltered
 * @property {string} Activity Type -
 * @property {string} Workspace Slug -
 * @property {string} workspace_id - Segment workspace id
 * @property {string} workspace_slug - Segment workspace slug
 */
/**
 * @typedef ActivityFeedSearched
 * @property {string} Search Term -
 * @property {string} Workspace Slug -
 */
/**
 * @typedef AdCampaignClicked
 * @property {string} ad_position -
 * @property {string} adgroup_id -
 * @property {string} campaign_id -
 * @property {string} creative -
 * @property {string} device -
 * @property {string} extension_id -
 * @property {string} keyword -
 * @property {string} landingpage -
 * @property {string} match_type -
 * @property {string} network -
 * @property {string} physical_location -
 * @property {string} placement -
 * @property {string} target_id -
 */
/**
 * @typedef AddDestinationClicked
 * @property {string} location - ie "workspace checklist"
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - ='Yes" for VT;="No" if without VT
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AddDestinationCompleted
 * @property {string} destination_id -
 * @property {string} destination_slug -
 * @property {string} location - ie "workspace checklist"
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - ='Yes" for VT;="No" if without VT
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AddPageviewsCloseButtonClicked
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef AddPageviewsCopySnippetClickedCopy
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - ="Yes" if VT Flag On, ="No" otherwise
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AddPageviewsGetStartedClicked
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef AddSourceButtonClicked
 * @property {string} location - Where the button is located. (ie. workspace checklist)
 * @property {any | null} user_id -
 * @property {boolean} vt_flag_on - ="Yes" if VT Flag On, ="No" otherwise
 * @property {any | null} workspace_id -
 * @property {any | null} workspace_slug -
 */
/**
 * @typedef AddSourceNextButtonClicked
 * @property {string} current_step - "source selection", "mobile library selection", "source setup", or "confirmation screen"
 * @property {string} [source_id] -
 * @property {string} [source_name] -
 * @property {string} [source_slug] -
 * @property {string} [source_type] - ="javascript" if vt_flag_on='Yes'; ='javascript'/'mobile' when vt_ flag_on='no'
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - ="Yes" if VT Flag On, ="No" otherwise
 * @property {string} website_url - the website url entered in the "Source setup" step; Null for other steps.
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AgreementDownloadedSignedCopy
 * @property {string} agreement_id -
 * @property {string} agreement_name -
 * @property {string} agreement_version -
 * @property {string} user_id -
 * @property {string} user_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AgreementDownloadedUnsignedCopy
 * @property {string} agreement_id -
 * @property {string} agreement_name -
 * @property {string} agreement_version -
 * @property {string} user_id -
 * @property {string} user_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AgreementSigned
 * @property {string} agreement_id -
 * @property {string} agreement_name -
 * @property {string} agreement_version -
 * @property {string} user_id -
 * @property {string} user_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AppTimingMetric
 * @property {any | null} [browser] -
 * @property {string | null} [component_name] - (Optional) name of the component associated with a timing metric
 * @property {number} duration - The value of the web metric
 * @property {string} metric - The name of the web metric.
 * @property {string | null} route - The current route of the user when the metric was tracked.
 * @property {string} [team] - (Optional) The team that owns the route
 */
/**
 * @typedef AssignLabelsClicked
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef AuditTrailFiltered
 * @property {string} filter_type -
 * @property {string} filter_value -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef BetaTermsAccepted
 * @property {string} [source_id] - Source id, if relevant
 * @property {string} [source_slug] - Source slug, if relevant
 * @property {string} type - The type of Beta Agreement that was accepted.
 * @property {string} workspace_id - Unique id of the workspace that has accepted the terms
 * @property {string} workspace_slug - Workspace slug of the workspace that has accepted the terms
 */
/**
 * @typedef BrazeMiddlewareToggled
 * @property {string} account_tier - Tier of the account this is toggled on
 * @property {boolean} enabled - Enabled = true, Disabled = false
 * @property {string} source_id - Source ID of the project this is toggled on
 * @property {string} workspace_slug - Workspace slug of the account this is toggled on
 */
/**
 * @typedef BulkAssignLabelSaved
 * @property {string} label -
 * @property {string} resource_name -
 * @property {string} resource_type -
 */
/**
 * @typedef CsvDownloaded
 * @property {string} usage_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef CancelButtonBulkAssignEnvironmentsClickCopy
 * @property {string} workspace_slug -
 */
/**
 * @typedef CatalogCategoryClicked
 * @property {string} catalog_category -
 * @property {string} type -
 */
/**
 * @typedef CatalogRecommendationCategoryClicked
 * @property {string} catalog_category -
 * @property {string} type -
 */
/**
 * @typedef CatalogRecommendationClicked
 * @property {string} recommendation_slug -
 * @property {string} type -
 */
/**
 * @typedef CatalogSidebarCategoryClicked
 * @property {string} catalog_category -
 * @property {string} type -
 */
/**
 * @typedef CatalogSidebarSearched
 * @property {string} current_category - Currently selected category in the left nav.
 * @property {string} search_query - Text searched for by the user.
 * @property {string} title - Whether the user is viewing the Sources or Destinations catalog.
 * @property {string} workspace_id - ID of the workspace.
 */
/**
 * @typedef CatalogSidebarTabClicked
 * @property {string} layout -
 * @property {string} platforms -
 * @property {string} repo -
 * @property {string} tool_types_displayed -
 * @property {string} tools -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef CatalogSortBy
 * @property {string | null} category_name -
 * @property {any | null} [integration_type] -
 * @property {string | null} search_term -
 * @property {string} sort_by -
 */
/**
 * @typedef CatalogSortByClicked
 * @property {string} layout -
 * @property {string} platforms -
 * @property {string} repo -
 * @property {string} tool_types_displayed -
 * @property {string} tools -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef CatalogTileClicked
 * @property {string} layout -
 * @property {string} platforms -
 * @property {string} repo -
 * @property {string} tile -
 * @property {string} tool_types_displayed -
 * @property {string} tools -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef CensorDestinationSettings
 * @property {string | null} [metadata_id] -
 * @property {string} method_name -
 * @property {boolean} should_censor_flag -
 * @property {string | null} [source_id] -
 * @property {string | null} [user_id] -
 * @property {string | null} [workspace_id] -
 */
/**
 * @typedef ChangeWorkspaceClicked
 * @property {string} target -
 */
/**
 * @typedef ChangeWorkspaceClickedFromAccountSettings
 * @property {string} [target] -
 */
/**
 * @typedef ChangeWorkspaceClickedFromWorkspaceSettings
 * @property {string} [target] -
 */
/**
 * @typedef ChecklistCompletedAppcues
 * @property {string} checklistId -
 * @property {string} checklistName -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef ChecklistCompletedItemLinkClicked
 * @property {string} [destination_id] -
 * @property {string} [destination_slug] -
 * @property {string} [item_type] - step name or row name
 * @property {string} [source_id] -
 * @property {any | null} [source_slug] - If it's a Source, then list the Source slug
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ChecklistDismissedAppcues
 * @property {string} checklistId -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef ChecklistItemCompletedAppcues
 * @property {string} checklistId -
 * @property {string} checklistName -
 * @property {string} itemId -
 * @property {string} itemIndex -
 * @property {string} itemLabel -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef ChecklistItemExpanded
 * @property {any | null} item_type - The step name or row name
 * @property {any | null} user_id -
 * @property {boolean} vt_flag_on - =Yes if w. VT, =No if w/o VT
 * @property {any | null} workspace_id -
 * @property {any | null} workspace_slug -
 */
/**
 * @typedef ChecklistShownAppcues
 * @property {string} checklistId -
 * @property {string} checklistName -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef ClassificationApplied
 * @property {string} color - The color of the classification the user applied
 * @property {string} workspace_id -
 */
/**
 * @typedef ClickedAddDestination
 * @property {string} [user_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ClickedAddSource
 * @property {string} [user_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ClickedCta
 * @property {string} location -
 * @property {string} type -
 */
/**
 * @typedef ClickedCatalogIntegration
 * @property {string | null} [category_name] -
 * @property {string} destination_slug -
 * @property {string | null} destination_type - direct v1 or direct v2 or
 * @property {string | null} integration_type - sources vs. destinations vs. warehouses
 * @property {boolean} [is_featured_banner] - tells you if a tile was the featured banner
 * @property {boolean} [is_featured_tile] - tells you if a tile was from the featured section
 * @property {string | null} [search_term] -
 */
/**
 * @typedef ClickedCatalogInterestedInBuilding
 * @property {string} workspace_slug -
 */
/**
 * @typedef ClickedCatalogViewAll
 * @property {string} category_name -
 * @property {string | null} integration_type - source, destination, or warehouse
 */
/**
 * @typedef ClickedConfigureDestination
 * @property {string} button_position - is it the top or bottom button
 * @property {string} destination_definition_id -
 * @property {string} destination_slug -
 * @property {string | null} destination_type - direct v1 or direct v2
 * @property {string | null} source_slug -
 */
/**
 * @typedef ClickedSqlIntegration
 * @property {string} partner_name -
 * @property {string} workspace_id -
 */
/**
 * @typedef ClickedWishlistIntegrationRequestLogo
 * @property {string} integration_type - source or a destination
 * @property {string} [requested_integration_id] -
 * @property {string} tool_name - name of the tool requested
 * @property {string} tool_url - website/url of the tool
 */
/**
 * @typedef ClickedWishlistUpvoteButton
 * @property {string} integration_type - source or a destination
 * @property {string} [requested_integration_id] -
 * @property {string} tool_name - name of the tool requested
 * @property {string} tool_url - website/url of the tool
 */
/**
 * @typedef CodeSnippetCopied
 * @property {string} [code_language] - specifies which language they selected
 * @property {string} location - specifies where user copied the code snippet Options: Tracking Plan, Sign Up Flow, Docs, etc.
 */
/**
 * @typedef ConnectionHealthDeleteCancelled
 * @property {string} connection_type -
 * @property {string} [destination_id] -
 * @property {string} [error_type] -
 * @property {string} [source_id] -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ConnectionHealthDeleteClicked
 * @property {string} connection_type -
 * @property {string} [destination_id] -
 * @property {string} [error_type] -
 * @property {string} [source_id] -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ConnectionHealthDeleteCompleted
 * @property {string} connection_type -
 * @property {string} [destination_id] -
 * @property {string} [error_type] -
 * @property {string} [source_id] -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ConnectionHealthDisableClicked
 * @property {string} connection_type -
 * @property {string} [destination_id] -
 * @property {string} [error_type] -
 * @property {string} [source_id] -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ConnectionHealthErrorClicked
 * @property {string} connection_type -
 * @property {string} [destination_id] -
 * @property {any | null} error_type -
 * @property {string} [source_id] -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ConnectionHealthResolveErrorClicked
 * @property {string} connection_type -
 * @property {string} [destination_id] -
 * @property {string} [error_type] -
 * @property {string} [source_id] -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 */
/**
 * @typedef ConnectionPolicyEdited
 * @property {any[]} new_setting - should display names of labels if "Only sources with specific labels"
 * @property {any[]} old_setting - should display names of labels if "Only sources with specific labels"
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef CreateLabelClicked
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef CreatedPlugin
 * @property {string} [plugin_id] -
 * @property {string} [plugin_slug] -
 * @property {string} [source_id] -
 */
/**
 * @typedef CreditCardAdded
 * @property {string} [credit_card_brand] -
 */
/**
 * @typedef CreditCardEditClicked
 * @property {string} credit_card_brand -
 */
/**
 * @typedef CreditCardErrored
 * @property {string} [credit_card_brand] -
 * @property {Record<string, any>} [credit_card_error] -
 */
/**
 * @typedef Language
 * @property {string} [name] -
 * @property {string} [version] -
 */
/**
 * @typedef Event
 * @property {boolean} [has_errors] -
 * @property {string} [integration_errors] -
 * @property {Language} [language] -
 * @property {string} [method] -
 * @property {string} [name] -
 */
/**
 * @typedef Project
 * @property {string} [id] - Source ID
 * @property {string} [name] - Name of the Source
 * @property {string} project - Slug of the Source
 */
/**
 * @typedef Workspace
 * @property {string} [email] - Billing email for the workspace
 * @property {string} [id] - Workspace id
 * @property {string} [name] - Workspace name
 * @property {string} workspace - Workspace slug
 */
/**
 * @typedef DebuggerCallClicked
 * @property {Event} [event] - Clicked Event Metadata
 * @property {boolean} [historic_event] - Is this a historic event or a live event?
 * @property {Project} project - Source Metadata
 * @property {boolean} [search] - Is a search applied?
 * @property {Workspace} workspace - Workspace metadata
 */
/**
 * @typedef Project1
 * @property {string} [id] - Source ID
 * @property {string} [name] - Name of the Source
 * @property {string} project - Slug of the Source
 */
/**
 * @typedef Workspace1
 * @property {string} [email] - Billing email for the workspace
 * @property {string} [id] - Workspace id
 * @property {string} [name] - Workspace name
 * @property {string} workspace - Workspace slug
 */
/**
 * @typedef DebuggerSearched
 * @property {boolean} full_payload -
 * @property {boolean} include_alias -
 * @property {boolean} include_allowed -
 * @property {boolean} include_blocked -
 * @property {boolean} include_group -
 * @property {boolean} include_identify -
 * @property {boolean} include_page -
 * @property {boolean} include_screen -
 * @property {boolean} include_track -
 * @property {string} keywords -
 * @property {Project1} project - Source Metadata
 * @property {string} terms - Search term entered
 * @property {Workspace1} workspace - Workspace metadata
 */
/**
 * @typedef DemoRequested
 * @property {string} [feature] -
 * @property {string} [user_email] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef DestinationAuthorizeClicked
 * @property {string} destination_id -
 * @property {string} destination_metadata_category -
 * @property {string} destination_metadata_slug -
 * @property {string} destination_name -
 * @property {string} destination_slug -
 * @property {string} [destination_type] -
 * @property {string} funnel_step -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationAuthorizeFailed
 * @property {string} destination_id -
 * @property {string} destination_metadata_slug -
 * @property {string} destination_name -
 * @property {string} destination_slug -
 * @property {string} error -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationAuthorized
 * @property {string} destination_id -
 * @property {string} destination_metadata_slug -
 * @property {string} destination_name -
 * @property {string} destination_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationCredentialsAdded
 * @property {string} [billing_plan_id] -
 * @property {string} [destination_name] - destination_name
 * @property {any[]} [destination_setting_names] - destination_setting_names
 * @property {string} [destination_slug] -
 * @property {string} [source_id] - source_id
 * @property {string} [source_slug] -
 * @property {string} [user_email] - user_email
 * @property {string} [user_id] - user_id
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef DestinationDeliverabilityPeriodUpdated
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} period -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationDeliverabilityViewed
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationErrorPayloadCopied
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationErrorPayloadTabChanged
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} tab_name -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationErrorViewed
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} error_type -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationFilterCreated
 * @property {any[]} actions - List of tsub actions to perform.
 * @property {string} description - Description of destination filter.
 * @property {boolean} enabled - Whether this destination filter is enabled.
 * @property {string} fql - FQL condition string.
 * @property {string} target - Identifier for destination filter.
 * @property {string} title - Title of destination filter.
 */
/**
 * @typedef DestinationFilterFeedbackSubmitted
 * @property {string} [destination] - slug
 * @property {string} message -
 * @property {string} [source] - slug
 * @property {string} [workspace] - slug
 */
/**
 * @typedef DestinationFiltersFqlTested
 * @property {boolean} [failed] - Whether the test diff call to gateway-api failed.
 * @property {string} [fql] - The FQL condition string.
 * @property {string} selected_filter_type - The selected action for this filter.
 */
/**
 * @typedef DestinationFiltersListViewed
 * @property {number} numFilters -
 */
/**
 * @typedef DestinationOverviewPeriodUpdated
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} period -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationOverviewSearched
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} search_query -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationOverviewViewed
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationSimulatorBuilderType
 * @property {string} eventBuilderType -
 */
/**
 * @typedef DestinationSimulatorDismissedSourceDebuggerDialog
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationSimulatorEventPayloadCopied
 * @property {string} viewResultType -
 */
/**
 * @typedef DestinationSimulatorEventSent
 * @property {string} error -
 * @property {string} eventBuilderType -
 * @property {string} eventErrorCode -
 * @property {string} eventErrorMessage -
 * @property {string} eventResponseStatusCode -
 * @property {string} integration_id -
 * @property {string} integration_slug -
 * @property {string} numEventResponses -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationSimulatorNavigatedFromSourceDebugger
 * @property {string} integration_slug -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef DestinationSimulatorResultViewToggled
 * @property {string} viewResultType -
 */
/**
 * @typedef DestinationsSettingsReverted
 * @property {string} [destination_metadata_name] - destination_metadata_name
 * @property {string} [destination_metadata_slug] - destination_metadata_slug
 * @property {string} [destination_name] - destination_name
 * @property {string} [destination_slug] - destination_slug
 * @property {Record<string, any>} [source_slug] - source_slug
 * @property {string} [workspace_id] - workspace_id
 * @property {string} [workspace_slug] - workspace_slug
 */
/**
 * @typedef DisableTaggerClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef DocsLinkClicked
 * @property {string} link - The docs link they clicked on.
 * @property {string} location - Where the user was when they clicked on this link.
 * @property {string} [source_id] - Segment source id
 * @property {string} [source_slug] - Segment source slug
 * @property {string} workspace_id - Segment workspace id
 * @property {string} workspace_slug - Segment workspace slug
 */
/**
 * @typedef EditTrackingPlanClicked
 * @property {string} location - specifies where the user was when clicking to view violations
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} [type] - The type of Tracking Plan (because Tracking Plans can also be Libraries).
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef ElementsTreeDropdownClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ElementsTreeElementClicked
 * @property {any | null} [selector_selected] - The selector that the user clicks on
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef EmailCaptured
 * @property {string} email -
 * @property {string} form -
 */
/**
 * @typedef EmailDelivered
 * @property {string} campaign_id -
 * @property {string} email_body -
 * @property {string} email_recipient -
 * @property {string} email_sender -
 * @property {string} email_subject -
 */
/**
 * @typedef EnableDestinationClicked
 * @property {string} destination_id -
 * @property {string} destination_slug -
 * @property {string} location - ie "workspace checklist"
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - =Yes if w. VT, =No if w/o VT
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef EnableFlowStarted
 * @property {string} experiment_name -
 * @property {string} integration -
 * @property {string} location -
 * @property {string} url -
 * @property {string} variation_name -
 */
/**
 * @typedef EnableTaggerClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef EnforcementNotificationClicked
 * @property {string} feature -
 * @property {string} target_plan -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef EnforcementNotificationShown
 * @property {string} feature -
 * @property {string} target_plan -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef EnforcementSettingsChanged
 * @property {string} [blocking_type] - specifies what level of blocking is being changed (unplanned event, unplanned property, JSON schema)
 * @property {string} [dropdown_selection] - specifies the user's dropdown selection (allow, block, strip)
 * @property {string} [event_type] - specifies what event type is being changed
 * @property {boolean} [tracking_plan_connected] - true if a Tracking Plan is connected
 */
/**
 * @typedef ErrorWritekeyNotFound
 * @property {boolean} [is_timeout] -
 */
/**
 * @typedef ErrorSummaryToggled
 * @property {string} billing_plan_id -
 * @property {string} destination_slug -
 * @property {string} type -
 * @property {string} user_email -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef EventDisabled
 * @property {string} event_name -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef EventEdited
 * @property {Record<string, any>} [event_name_after] -
 * @property {Record<string, any>} [event_name_before] -
 * @property {Record<string, any>} [selector_after] -
 * @property {Record<string, any>} [selector_before] -
 * @property {Record<string, any>} [trigger_after] -
 * @property {Record<string, any>} [trigger_before] -
 * @property {Record<string, any>} [user_id] -
 * @property {Record<string, any>} [workspace_id] -
 * @property {Record<string, any>} [workspace_slug] -
 */
/**
 * @typedef EventEnabled
 * @property {string} event_name -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef EventInferred
 * @property {string} [event_name] - name of event being inferred
 * @property {string} [event_type] - The type of event being inferred
 * @property {string[]} [property_names] - Array of properties being added (selected by customer in modal)
 * @property {any | null} [source_id] - Id of segment source
 * @property {any | null} [source_name] - Name of Segment source
 * @property {string} [source_slug] - Slug of Segment source
 * @property {string} [tracking_plan_id] - Tracking plan Resource id
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef LabelObject
 * @property {string} [key] - key of the label that is added to this event
 * @property {any | null} [value] - value of the label that is added to this event
 */
/**
 * @typedef EventLabelsEdited
 * @property {string} [event_id] - ID of event that label is added to
 * @property {string} event_name - name of event that label is added to
 * @property {LabelObject} label_object - label object state on save
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} workspace_id - Segment workspace id
 * @property {string} [workspace_slug] - Segment workspace slug
 */
/**
 * @typedef EventStreamTabClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef EventTaggerClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ExtensionActivated
 * @property {any | null} [user_email] -
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ExtensionInstalled
 * @property {any | null} [user_email] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ExtensionLogin
 * @property {string} [user_email] -
 */
/**
 * @typedef ExtensionUninstalled
 * @property {any | null} [user_email] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef FeatureRequested
 * @property {string} feature_name -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef FeedbackSubmitted
 * @property {string} [app_location] - Location of the feedback form in the app.
 * @property {string} feedback_text - The feedback!
 * @property {string} team - The team the feedback belongs to.
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef FilterApplied
 * @property {string} [filtered_app_version] - When type==App Version, pass through app versions selected by user
 * @property {string} [filtered_category] - When type==Category, pass through the selected category.
 * @property {Record<string, any>} [filtered_label_keys] - When type==Tag, pass through tag keys selected by user
 * @property {string} [filtered_string] - When type==Search, pass through tag keys selected by user
 * @property {string} [filtered_timeframe] - When type==Time Range, pass through time range selected by user
 * @property {string} location - specifies where the user is entering and applying the filter
 * @property {string} [source_id] - Segment source id
 * @property {string} [source_slug] - Segment source slug
 * @property {string} [sublocation] - specifies sublocation where the user is entering and applying the filter. (ex. when filtering in the Tracking Plan Editor, use to specify if user is on the Track, Identify, etc tab)
 * @property {string} [tracking_plan_id] - The ID of the Tracking Plan, if applied within the scope of a Tracking Plan.
 * @property {string} type - specifies what type of filter is being applied
 * @property {string} workspace_id - Segment workspace id
 * @property {string} workspace_slug - Segment workspace slug
 */
/**
 * @typedef FilterByEnvironmentSelectboxChanged
 * @property {string} workspace_billing_plan -
 * @property {string} workspace_slug -
 */
/**
 * @typedef FirstContentfulPaint
 * @property {any | null} [browser] -
 * @property {number} duration - The value of the web metric
 * @property {string | null} route - The current route of the user when the metric was tracked.
 */
/**
 * @typedef FirstInputDelay
 * @property {any | null} [browser] -
 * @property {number} duration - The value of the web metric
 * @property {string | null} route - The current route of the user when the metric was tracked.
 */
/**
 * @typedef FirstPaint
 * @property {any | null} [browser] -
 * @property {number} duration - The value of the web metric
 * @property {string | null} route - The current route of the user when the metric was tracked.
 */
/**
 * @typedef FlowCompletedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef FlowSkippedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} stepId -
 * @property {string} stepNumber -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef FlowStartedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef ForwardingSettingsChanged
 * @property {string} forwarding_status - specifies if the setting is changed to enabled or disabled
 * @property {string} selected_source_id - specified the source id
 * @property {string} [selected_source_slug] - specifies the source slug
 * @property {string} type - specifies what type forwarding settings have been changed (blocked event, violations or workspace events)
 */
/**
 * @typedef FunctionAttachedToSource
 * @property {string} [source_id] - the ID of the source that the function has been attached to.
 */
/**
 * @typedef GdprBetaRequested
 * @property {string} workspace_slug -
 */
/**
 * @typedef GateViewed
 * @property {string} [feature] - Which Segment product gate the customer is viewing (Personas, Protocols, etc)
 * @property {string} [workspace_id] - Id of workspace
 * @property {string} [workspace_slug] - Slug of workspace
 */
/**
 * @typedef GraphQlError
 * @property {string[]} categories - The set of categories of errors (Access Denied, etc.)
 * @property {string} categoryString - A string-ified version of category, for Destination Filters usage.
 * @property {string | null} [fullStory] -
 * @property {any[]} graphqlErrors -
 * @property {string} messageString - A string-ified version of messages, for Destination Filters usage.
 * @property {string[]} messages - A list of the error messages
 * @property {string | null} route -
 * @property {any | null} [sentryId] -
 * @property {string} timezone -
 */
/**
 * @typedef IdentityResolutionBlockedValueUpdated
 * @property {any[]} blocked_values -
 * @property {string} identifier_name -
 * @property {string} space_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IdentityResolutionEditStateEnabled
 * @property {string} space_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IdentityResolutionIdentifierCreated
 * @property {string} identifier_name -
 * @property {string} space_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IdentityResolutionLimitBehaviorUpgraded
 * @property {string} identifier_name -
 * @property {string} space_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IdentityResolutionLimitUpdated
 * @property {string} identifier_name -
 * @property {number} new_value -
 * @property {number} old_value -
 * @property {string} space_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IdentityResolutionPageClicked
 * @property {string} space_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IdentityResolutionPriorityUpdated
 * @property {any[]} new_order -
 * @property {any[]} old_order -
 * @property {string} space_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IncidentContactsChanged
 * @property {number} contacts_added_count -
 * @property {number} contacts_removed_count -
 * @property {string} workspace_id -
 */
/**
 * @typedef IncidentContactsSaved
 * @property {number} contacts_added_count -
 * @property {number} contacts_removed_count -
 * @property {string} workspace_id -
 */
/**
 * @typedef IncidentContactsWarningDialogCanceled
 * @property {string} workspace_id -
 */
/**
 * @typedef IncidentContactsWarningDialogConfirmed
 * @property {string} workspace_id -
 */
/**
 * @typedef IncidentContactsWarningDialogDisplayed
 * @property {string} workspace_id -
 */
/**
 * @typedef IntegrationDisabled
 * @property {string | null} [destination_type] -
 * @property {string} integration_metadata_slug -
 * @property {string} integration_name -
 * @property {string} partner_enable_flow -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef IntegrationEnabled
 * @property {string | null} [destination_type] - direct v1 or v2 or other
 * @property {string} integration_metadata_slug -
 * @property {string} integration_name -
 * @property {boolean} partner_enable_flow -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef InvalidDestinationEnableAttempted
 * @property {string} destination_slug -
 */
/**
 * @typedef InventoryCsvDownloaded
 * @property {string} workspace_id -
 */
/**
 * @typedef InventorySidesheetViewed
 * @property {string} [tab] -
 */
/**
 * @typedef InvestorProgramHandshakeMade
 * @property {string} [email] -
 * @property {string} [first_name] -
 * @property {string} [initial_handshake_ts] -
 * @property {string} [investor_name] -
 * @property {string} [last_name] -
 */
/**
 * @typedef InviteATeammateClicked
 * @property {string} location - location where the action was triggered from (ie "workspace checklist")
 * @property {any | null} user_id -
 * @property {boolean} vt_flag_on - ="Yes" if with VT; ="No" if w. VT
 * @property {any | null} workspace_id -
 * @property {any | null} workspace_slug -
 */
/**
 * @typedef JsonSchemaEdited
 * @property {string} type - specifies which json schema is being edited (common rules or event)
 */
/**
 * @typedef JavaScriptError
 * @property {string} [appTrace] -
 * @property {string[]} categories - The set of categories of errors (Access Denied, etc.)
 * @property {string} categoryString - A string-ified version of category, for Destination Filters usage.
 * @property {string} [extra] -
 * @property {any[]} [failedGraphQLQueries] -
 * @property {string} [feature] -
 * @property {string} [filename] -
 * @property {string | null} [fullStory] -
 * @property {string} [functionName] -
 * @property {any[]} [graphQLQueries] -
 * @property {string} messageString - A string-ified version of messages, for Destination Filters usage.
 * @property {string[]} messages - A list of the error messages
 * @property {string | null} [route] -
 * @property {any | null} [sentryId] -
 * @property {string} [timezone] -
 */
/**
 * @typedef LabelAsEnvironmentDropdownSelected
 * @property {string} environment_selected -
 * @property {any[]} [sources] -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelAssignedToPermissions
 * @property {any[]} labels -
 * @property {string} role_type - source admin, source read-only, personas admin, etc
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelCreationSuccessful
 * @property {string} label_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelCreationUnsuccessful
 * @property {any[]} error_message -
 * @property {string} label_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelResourcesSaved
 * @property {any[]} labeled_resources -
 * @property {string} resource_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelTabClicked
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelAssignedToPermission
 * @property {string} environment - the environment under which all sources are selected
 * @property {string} role - the role being applied to the user
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabelYourSourcesButtonClicked
 * @property {string} workspace_billing_plan -
 * @property {string} workspace_slug -
 */
/**
 * @typedef LabsFeatureTermsAccepted
 * @property {string} feature_id -
 * @property {string} [feature_name] - human readable name of the feature
 * @property {string} workspace_id -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef LeadCaptured
 * @property {string} email -
 * @property {string} [event_date] -
 * @property {string} [event_location] -
 * @property {string} [event_speaker] -
 * @property {string} [event_topic] -
 * @property {string} [event_type] -
 * @property {string} [lead_capture_action] -
 * @property {string} [lead_capture_campaign] -
 * @property {string} [lead_capture_method] -
 * @property {string} [lead_capture_type] -
 * @property {string} [lead_source] -
 * @property {string} location -
 * @property {boolean} [startup] -
 * @property {string} url -
 */
/**
 * @typedef LibraryItemsImported
 * @property {string} item_type - The kind of items being imported. Could be Properties or Rules.
 * @property {any[]} items_imported - A list of item keys imported.
 * @property {number} items_imported_count - Count of items imported.
 * @property {any[]} library_ids - A list of the IDs of the Libraries being imported from.
 * @property {any[]} [rules_edited] - A list of Rules receiving imported Properties (when item_type = Property)
 * @property {number} [rules_edited_count] - Count of Rules receiving imported Properties (when item_type = Property)
 * @property {string} tracking_plan_id - The ID of the Tracking Plan receiving the imported items.
 * @property {string} workspace_id - The ID of the Workspace.
 * @property {string} workspace_slug - The slug of the Workspace.
 */
/**
 * @typedef LocalStorageToggled
 * @property {boolean} enabled - Enabled = true, Disabled = False
 * @property {string} source_id - Source ID of the project this is toggled on.
 * @property {string} workspace_id - Workspace of the project this is toggled on.
 */
/**
 * @typedef LockoutModalShown
 * @property {string} current_plan -
 * @property {string} lockout_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef MfaVerificationFailure
 * @property {string} [type] -
 */
/**
 * @typedef MfaCtaClicked
 * @property {string} user_id - The user that performed the action
 */
/**
 * @typedef MfaCtaDismissed
 * @property {string} user_id - The user that performed the action
 */
/**
 * @typedef MfaCtaSidesheetClosed
 * @property {string} user_id - The user that performed the action
 */
/**
 * @typedef NavSearchResultClicked
 * @property {string} [nav_category] - The category for this search result - likely 'source', 'destination', or 'catalog'
 * @property {string} [plan_id] - The billing plan for the current workspace
 * @property {number} [search_index] - The index indicating how far down the search results the current search result is
 * @property {string} [search_term] - The search term entered into Omnisearch
 * @property {string} [user_email] - The current user's email
 * @property {string} [user_id] - The current user's id
 * @property {string} [workspace_id] - The current workspace's id
 * @property {string} [workspace_slug] - The current workspace's slug
 */
/**
 * @typedef NavSearchResultsEmpty
 * @property {string} [plan_id] - The workspace billing plan
 * @property {string} [search_term] - The search term entered into Omnisearch that produced empty results
 * @property {string} [user_email] - The current user's email
 * @property {string} [user_id] - The current user's id
 * @property {string} [workspace_id] - The current workspace's id
 * @property {string} [workspace_slug] - The current workspace's slug
 */
/**
 * @typedef NavSearchTermEntered
 * @property {string} [plan_id] - The workspace billing plan
 * @property {string} [search_term] - The search term entered into Omnisearch
 * @property {string} [user_email] - The current user's email
 * @property {string} [user_id] - The current user's id
 * @property {string} [workspace_id] - The current workspace id
 * @property {string} [workspace_slug] - The current workspace slug
 */
/**
 * @typedef NavigateClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef NetworkError
 * @property {string} [appTrace] -
 * @property {string[]} categories - The set of categories of errors (Access Denied, etc.)
 * @property {string} categoryString - A string-ified version of category, for Destination Filters usage.
 * @property {any[]} [failedGraphQLQueries] -
 * @property {string} [filename] -
 * @property {string | null} [fullStory] -
 * @property {string} [functionName] -
 * @property {string} messageString - A string-ified version of messages, for Destination Filters usage.
 * @property {string[]} messages - A list of the error messages
 * @property {string} [operation] -
 * @property {string | null} [route] -
 * @property {any | null} [sentryId] -
 * @property {number | null} [statusCode] -
 * @property {string} [timezone] -
 */
/**
 * @typedef NewPasswordStrength
 * @property {number} [new_pwned] -
 * @property {number} [new_score] -
 */
/**
 * @typedef NewTransformationClicked
 * @property {string} workspace_id - Segment workspace id
 * @property {string} workspace_slug - Segment workspace slug
 */
/**
 * @typedef NotificationBannerClicked
 * @property {string} cta -
 * @property {string} importance -
 * @property {string} violation -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationBannerShown
 * @property {string} cta -
 * @property {string} importance -
 * @property {string} violation -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationCenterLoadMoreClicked
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationCenterOpened
 * @property {boolean} [has_unread_notifications] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationClicked
 * @property {boolean} is_unread -
 * @property {string} template_key -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationsSettingsCategoryClick
 * @property {string} category - The category for the notification
 * @property {boolean} expanded - Indicates whether it was expanded or collapsed
 * @property {string} [workspace_id] - The workspace Id
 * @property {string} workspace_slug - The worksapce slug
 */
/**
 * @typedef NotificationsSettingsChanged
 * @property {string} [category] - The category for the notification
 * @property {boolean} [enabled] - Whether the notification was enabled or disabled
 * @property {string} [resource_type] - The type of the resource the setting refers to (e.g. ware
house, destination, cloud-source)
 * @property {string} [type] - The type of notification (web or email)
 * @property {string} [workspace_id] - 
 * @property {string} [workspace_slug] - 
 */
/**
 * @typedef NotificationsSettingsSidesheetCustomCategoryClick
 * @property {string} resource_type -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationsSettingsSidesheetLinkClick
 * @property {string} integration_name -
 * @property {string} resource_type -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationsSettingsSidesheetOpenClick
 * @property {string} category -
 * @property {string} workspace_slug -
 */
/**
 * @typedef NotificationsSettingsSliderInteraction
 * @property {number} threshold -
 * @property {string} workspace_slug -
 */
/**
 * @typedef OAuthConsentAllowClicked
 * @property {string} domain - Referring domain
 * @property {string} scope - OAuth scope, e.g. `workspace:read` or `destination/myapp`
 */
/**
 * @typedef OAuthConsentLogoutClicked
 * @property {string} domain - Referring domain
 * @property {string} scope - OAuth scope, e.g. `workspace:read` or `destination/myapp`
 */
/**
 * @typedef OAuthConsentPageViewed
 * @property {string} domain - Referring domain
 * @property {string} scope - OAuth scope, e.g. `workspace:read` or `destination/myapp`
 */
/**
 * @typedef OAuthConsentStarted
 * @property {string} domain - Referring domain
 * @property {string} scope - OAuth scope, e.g. `workspace:read` or `destination/myapp`
 */
/**
 * @typedef OneClickDestinationsIntegrationsConfigured
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_url] -
 * @property {string} [job_status] - Whether job succeeded or failed
 * @property {number} [num_results_configured] - Number of integration results successfully configured for the workspace
 * @property {number} [num_results_returned] - Number of integration results returned by the job
 * @property {number} [num_results_selected] - Number of integration results selected by the user to auto-configure
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {any[]} [results_configured] - Array of the integration names successfully auto-configured
 * @property {any[]} [results_returned] - Array of the integration names that were returned as results by Snoop Lion service
 * @property {any[]} [results_selected] - Array of the integration names that the user opted to auto-configure
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [website_url] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef OneClickDestinationsJobCompleted
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_url] -
 * @property {string} [job_status] - Whether job succeeded or failed
 * @property {number} [num_results_returned] - Number of integration results returned by the job
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {any[]} [results_returned] - Array of the integration names that were returned as results by Snoop Lion service
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [website_url] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef OneClickDestinationsSearchOptedIn
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_url] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [website_url] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PageCallDuplicated
 * @property {string} [route] - The generic route matcher
 * @property {string} [url] - The url that was possibly tracked more than once.
 */
/**
 * @typedef PageViewed
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {boolean} [autotracked] - Whether or not this page view was autotracked via the router
 * @property {string} [category] -
 * @property {string} [destination_slug] -
 * @property {string} [event_name] -
 * @property {string} [last_run_collection_nb] -
 * @property {string} [metadata_slug] -
 * @property {string} [metadata_type] -
 * @property {string} [name] -
 * @property {string} path -
 * @property {string} [referrer] -
 * @property {string | null} [route] - The generic route matcher associated with this page view.
 * @property {Record<string, any>} [route_params] - The values that make up the route matcher placeholder parameters.
 * @property {string} [schema_collection] -
 * @property {string} [schema_object] -
 * @property {string} [search] -
 * @property {string} [slug] -
 * @property {string} [source_collaborators] -
 * @property {string} [source_enabled] -
 * @property {string} [source_id] -
 * @property {string} [source_metadata_slug] -
 * @property {string} [source_name] -
 * @property {string} [source_nb] -
 * @property {string} [source_slug] -
 * @property {string} [source_type] -
 * @property {string} [title] -
 * @property {string} url -
 * @property {string} [user_id] -
 * @property {any | null} [version] - The version of autotracking.
 * @property {string} [viewport] -
 * @property {string} [warehouse_enabled] -
 * @property {string} [warehouse_id] -
 * @property {string} [warehouse_needs_upgrade] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_name] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PasswordChanged
 * @property {number} [current_pwned] -
 * @property {number} [current_score] -
 * @property {number} [new_pwned] -
 * @property {number} [new_score] -
 */
/**
 * @typedef PasswordSubmitted
 * @property {number} [hipb] -
 * @property {number} [score] -
 */
/**
 * @typedef PersonasAudienceCreated
 * @property {string} audience_id -
 * @property {string} audience_name -
 * @property {number} destination_count -
 * @property {string[]} destinations -
 * @property {boolean} is_audience_realtime -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceDeleted
 * @property {string} audience_id -
 * @property {string} audience_name -
 * @property {boolean} is_audience_realtime -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceDestinationAdded
 * @property {string} audience_id -
 * @property {string} audience_name -
 * @property {number} destination_count -
 * @property {string[]} destinations -
 * @property {boolean} is_audience_realtime -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceDestinationRemoved
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {string} [destination_name] -
 * @property {boolean} [is_audience_realtime] -
 * @property {string} [space_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasAudienceDestinationUpdated
 * @property {string} audience_id -
 * @property {string} audience_name -
 * @property {string} destination_name -
 * @property {boolean} is_audience_realtime -
 * @property {string} [space_id] -
 * @property {string} type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceDisabled
 * @property {string} audience_id -
 * @property {string} audience_name -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceInsightsViewed
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceOverlapFailed
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {string} compared_audience_id -
 * @property {string} compared_audience_name -
 * @property {boolean} [is_personas_preview] -
 * @property {string} run_id -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceOverlapSucceeded
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {string} compared_audience_id -
 * @property {string} compared_audience_name -
 * @property {boolean} [is_personas_preview] -
 * @property {string} run_id -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudiencePreviewFailed
 * @property {string} ast_definition -
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {string} [error_message] -
 * @property {boolean} is_audience_realtime -
 * @property {string} run_id -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudiencePreviewSucceeded
 * @property {string} ast_definition -
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {boolean} is_audience_realtime -
 * @property {string} run_id -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceRunFailed
 * @property {string} [audience_id] -
 * @property {string} [audience_name] -
 * @property {string} [error_message] -
 * @property {boolean} [is_sql] -
 * @property {string} [space_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasAudienceTemplateRequested
 * @property {string} description -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasAudienceTemplateViewed
 * @property {string} [template_id] -
 * @property {string} [template_name] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasAudienceTemplatesViewed
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasAudienceUpdated
 * @property {string} audience_id -
 * @property {string} audience_name -
 * @property {boolean} is_audience_realtime -
 * @property {string} [space_id] -
 * @property {string} status -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasClickedConnectDestination
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasClickedSetupDestination
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasComputationSidesheetViewed
 * @property {string} computation_id -
 * @property {string} computation_type -
 * @property {string} space_id -
 * @property {string} space_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasConnectedDestinations
 * @property {string[]} destinations -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasContactAboutTrial
 * @property {string} [email] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasEnabled
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasExplorerSearched
 * @property {boolean} [is_personas_preview] -
 * @property {boolean} match_found -
 * @property {string} search_string -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasGeneratedAccessToken
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasOnboardingTourStepCompleted
 * @property {boolean} [is_personas_preview] -
 * @property {string} step -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasProfileEventsLoadedMore
 * @property {boolean} [is_personas_preview] -
 * @property {string} profile_id -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasProfileTabViewed
 * @property {string} profile_id -
 * @property {string} [space_id] -
 * @property {string} type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasProfileViewed
 * @property {string} profile_id -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasSpaceCreated
 * @property {string} space_id -
 * @property {string} space_name -
 * @property {string} space_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasSpaceLabelEdited
 * @property {any[]} new_labels -
 * @property {any[]} old_labels -
 * @property {string} [space_name] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasSpaceRenamed
 * @property {string} space_id -
 * @property {string} space_name -
 * @property {string} space_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasSpaceSwitched
 * @property {string} space_id -
 * @property {string} space_name -
 * @property {string} space_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasSpacesSettingsViewed
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasSpacesViewed
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasToggledImportDestination
 * @property {string} destination -
 * @property {string} [space_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitCreated
 * @property {number} destination_count -
 * @property {string[]} destinations -
 * @property {boolean} is_trait_realtime -
 * @property {string} [space_id] -
 * @property {string} trait_id -
 * @property {string} trait_name -
 * @property {string} trait_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitDeleted
 * @property {boolean} is_trait_realtime -
 * @property {string} [space_id] -
 * @property {string} trait_id -
 * @property {string} trait_name -
 * @property {string} trait_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitDestinationAdded
 * @property {number} destination_count -
 * @property {string[]} destinations -
 * @property {boolean} is_trait_realtime -
 * @property {string} [space_id] -
 * @property {string} trait_id -
 * @property {string} trait_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitDestinationRemoved
 * @property {string} [destination_name] -
 * @property {boolean} [is_trait_realtime] -
 * @property {string} [space_id] -
 * @property {string} [trait_id] -
 * @property {string} [trait_name] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasTraitDestinationUpdated
 * @property {string} destination_name -
 * @property {boolean} is_trait_realtime -
 * @property {string} [space_id] -
 * @property {string} trait_id -
 * @property {string} trait_name -
 * @property {string} type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitDisabled
 * @property {string} [space_id] -
 * @property {string} trait_id -
 * @property {string} trait_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitPreviewClicked
 * @property {boolean} is_trait_realtime -
 * @property {string} [space_id] -
 * @property {string} [trait_id] -
 * @property {string} [trait_name] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitPreviewFailed
 * @property {string} ast_definition -
 * @property {string} [error_message] -
 * @property {boolean} is_trait_realtime -
 * @property {boolean} is_trait_sql -
 * @property {string} [run_id] -
 * @property {string} [space_id] -
 * @property {string} [trait_id] -
 * @property {string} [trait_name] -
 * @property {string} trait_type -
 * @property {string} [warehouse_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitPreviewSucceeded
 * @property {string} ast_definition -
 * @property {boolean} is_trait_realtime -
 * @property {boolean} is_trait_sql -
 * @property {string} run_id -
 * @property {string} [space_id] -
 * @property {string} [trait_id] -
 * @property {string} [trait_name] -
 * @property {string} trait_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasTraitRunFailed
 * @property {string} [error_message] -
 * @property {boolean} [is_sql] -
 * @property {string} [space_id] -
 * @property {string} [trait_id] -
 * @property {string} [trait_name] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasTraitUpdated
 * @property {boolean} is_trait_realtime -
 * @property {string} [space_id] -
 * @property {string} status -
 * @property {string} trait_id -
 * @property {string} trait_name -
 * @property {string} trait_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef PersonasViewedApiAccess
 * @property {string} [space_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PersonasViewedDestinations
 * @property {string} [space_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef PluginDisabled
 * @property {string} [plugin_id] -
 * @property {string} [plugin_slug] -
 * @property {string} [source_id] -
 */
/**
 * @typedef PluginEnabled
 * @property {string} [plugin_id] -
 * @property {string} [plugin_slug] -
 * @property {string} [source_id] -
 */
/**
 * @typedef PrivacyAlertsEnabled
 * @property {string} type - The type of alert that was enabled by the user
 * @property {string} workspace_id -
 */
/**
 * @typedef PrivacyControlApplied
 * @property {string} [action] - Control action taken
 * @property {string} [classification] - Control classification type: either red or yellow
 * @property {string} [control_type] - Either Standard or Advanced controls
 * @property {string} [integration_type] - Either Source-level or Destination level control type
 */
/**
 * @typedef PrivacyDemoRequested
 * @property {string} email - Email of user that has requested a privacy demo.
 * @property {string} workspace_id - ID of workspace that has requested a privacy demo.
 * @property {string} workspace_slug - Slug of workspace that has requested a privacy demo.
 */
/**
 * @typedef QuickStartAdditionalIntegrationsSelected
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [number_of_integrations] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartCredentialsAdded
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [destination_id] -
 * @property {string} [destination_slug] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartCredentialsSkipped
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [destination_id] -
 * @property {string} [destination_slug] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartDestinationSelected
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [destination_id] -
 * @property {string} [destination_slug] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_slug] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartFinishedButtonClicked
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [destination_id] -
 * @property {string} [destination_slug] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_email] -
 * @property {string} [workspace_id] -
 */
/**
 * @typedef QuickStartFlowExited
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [destination_id] -
 * @property {string} [destination_slug] -
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartNextButtonClicked
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartPathSelected
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [qs_step] -
 * @property {string} [qs_track] - Which path the user selected in the flow (exploring/ int setup)
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartPreviousButtonClicked
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef QuickStartSourceSelected
 * @property {string} [billing_plan_id] -
 * @property {string} [billing_tier] -
 * @property {string} [current_path] - URL or path that the user is currently on when they trigger the event
 * @property {string} [qs_step] -
 * @property {string} [qs_track] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef RedundantDestinationEnableAttempted
 * @property {string} destination_slug -
 */
/**
 * @typedef ResetPassword
 * @property {string} user -
 */
/**
 * @typedef RetriesToggled
 * @property {boolean} enabled - Enabled = true, Disabled = false
 * @property {string} [source_id] - Source ID of the project this is toggled on.
 * @property {string} [workspace_id] - Workspace of the project this is toggled on.
 */
/**
 * @typedef RunHistoryViewed
 * @property {string} runId -
 * @property {string} source -
 * @property {string} status -
 * @property {string} warehouseId -
 * @property {string} workspaceId -
 * @property {string} workspaceSlug -
 */
/**
 * @typedef SsoConnectionCreated
 * @property {string} sso_connection_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SsoConnectionDefaultChanged
 * @property {string} sso_connection_id -
 */
/**
 * @typedef SsoConnectionDeleted
 * @property {string} sso_connection_id -
 */
/**
 * @typedef SsoConnectionToggled
 * @property {string} sso_connection_id -
 */
/**
 * @typedef SsoConnectionUpdated
 * @property {string} sso_connection_id -
 */
/**
 * @typedef SsoDomainAdded
 * @property {string} sso_domain_name -
 */
/**
 * @typedef SsoDomainRemoved
 * @property {string} sso_domain_name -
 */
/**
 * @typedef SsoDomainVerified
 * @property {string} sso_domain_name -
 */
/**
 * @typedef SsoForced
 * @property {boolean} sso_forced -
 */
/**
 * @typedef SaveButtonBulkAssignEnvironmentsClick
 * @property {any[]} [sourceEnvironments] - A list of SourceEnvironments object. ie [ { source: 'app', environment: 'prod' }]
 * @property {string} workspace_slug -
 */
/**
 * @typedef ScheduledVacuumingDisabled
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef ScheduledVacuumingEnabled
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef ScheduledVacuumingUpdated
 * @property {string} vacuum_interval -
 * @property {number} vacuum_interval_count -
 * @property {string} vacuum_timezone -
 * @property {string} vacuum_timezone_hour -
 * @property {string} vacuum_utc_hour -
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SchemaDefaultToggle
 * @property {boolean} new_value -
 * @property {string} setting_key -
 * @property {string} setting_name -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SchemaDefaultsRequested
 * @property {string} source_id - Segment source id
 * @property {string} source_slug - Segment source slug
 * @property {string} user_email - The currently logged in user's email.
 * @property {string} user_id - The currently logged in user's Segment id.
 * @property {string} user_name - The currently logged in user's full name.
 * @property {string} workspace_id - Segment workspace id
 * @property {string} workspace_slug - Segment workspace slug
 */
/**
 * @typedef SchemaDestinationToggle
 * @property {string} integration_slug -
 * @property {string} new_setting -
 * @property {string} object_name -
 * @property {string} schema_collection -
 * @property {string} schema_object -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SchemaEventPropertiesConditionalSave
 * @property {string} allow_null -
 * @property {string} category -
 * @property {string} data_type -
 * @property {string} event_name -
 * @property {string} property_name -
 * @property {string} regex -
 * @property {string} schema_collection -
 * @property {string} schema_object -
 * @property {string} source_slug -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SchemaToggle
 * @property {string} new_setting -
 * @property {string} object_name -
 * @property {string} schema_collection -
 * @property {string} schema_object -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SetEnvPermissionsOnSourceAdmin
 * @property {string} environment_type -
 * @property {string} user_email_address - user that the permission was set on, not the user setting the permission
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SetEnvPermissionsOnSourceReadOnly
 * @property {string} environment_type -
 * @property {string} user_email_address -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClicked
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedCatalog
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedDestinations
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedDocs
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedHealth
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedOverview
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedPersonas
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedProtocols
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedSettings
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SideNavClickedSources
 * @property {string} target -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SidepanelMoveClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef SignupDemoRequestSubmitted
 * @property {any | null} [business_type] -
 * @property {any | null} [company] -
 * @property {any | null} [company_size] -
 * @property {any | null} [email] -
 * @property {any | null} [name] -
 * @property {any | null} [phone] -
 * @property {any | null} [role] -
 */
/**
 * @typedef SignupNextClicked
 * @property {string} email -
 * @property {boolean} [enable_signup] -
 * @property {boolean} [partner_signup] -
 * @property {string} plan -
 * @property {string} step -
 * @property {boolean} [strong_signup] -
 */
/**
 * @typedef SignupPageViewed
 * @property {string} [email] -
 * @property {boolean} [enable_signup] - Signups from the OAuth / Enable With Segment flow.
 * @property {boolean} [has_invalid_invite_token] - Whether the user has landed on the signup page with an incorrectly formatted token.
 * @property {boolean} [has_invite_token] - Whether the user has landed on the signup page with an invite token.
 * @property {boolean} [partner_signup] - These are partner sign-ups for Dev Center.
 * @property {boolean} [startup] -
 * @property {string} [step] - which step the user is on (first = user details; second = business details)
 * @property {boolean} [strong_signup] - whether or not the user is served the password strength validation feature
 */
/**
 * @typedef SignupPasswordStrengthValidated
 * @property {string} [email] - Email address inputted by the user
 * @property {any | null} [hibp] - how many times a password has been breached according to the HIBP database
 * @property {number} [score] - Password strength score returned
 * @property {boolean} [success] - Whether or not the user is able to sign up with that password
 */
/**
 * @typedef SiteExited
 * @property {string} link_location -
 * @property {string} link_target -
 * @property {string} link_text -
 * @property {string} name -
 */
/**
 * @typedef SlothOfDeath
 * @property {string} appTrace -
 * @property {string[]} categories - The set of categories of errors (Access Denied, etc.)
 * @property {string} categoryString - A string-ified version of category, for Destination Filters usage.
 * @property {any[]} [failedGraphQLQueries] -
 * @property {string} filename -
 * @property {string | null} [fullStory] -
 * @property {string} functionName -
 * @property {string} messageString - A string-ified version of messages, for Destination Filters usage.
 * @property {string[]} messages - A list of the error messages
 * @property {string | null} route -
 * @property {any | null} [sentryId] -
 * @property {string} timezone -
 */
/**
 * @typedef SortApplied
 * @property {string} [direction] - The direction of the sort, either asc or desc.
 * @property {string} [field] - The field that was sorted on.
 * @property {string} location -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [sublocation] - specifies sublocation where the user is entering and applying the filter. (ex. when filtering in the Tracking Plan Editor, use to specify if user is on the Track, Identify, etc tab)
 * @property {string} [workspace_id] -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceAuthorizeClicked
 * @property {string} funnel_step -
 * @property {string} [source_id] -
 * @property {string} source_metadata_category -
 * @property {string} source_metadata_slug -
 * @property {string} [source_name] -
 * @property {string} [source_slug] -
 * @property {string} [source_type] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceAuthorized
 * @property {string} source_id -
 * @property {string} source_metadata_slug -
 * @property {string} source_name -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceAuthorizedFailed
 * @property {string} error -
 */
/**
 * @typedef SourceBasicSettingsChanged
 * @property {boolean} source_enabled -
 * @property {string} source_id -
 * @property {string} source_name -
 * @property {string} source_old_name -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceCollaboratorInvitedLegacy
 * @property {any | null} [plan] -
 * @property {any | null} [source_id] -
 * @property {any | null} [source_slug] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef SourceCreated
 * @property {string} source_count -
 * @property {string} source_id -
 * @property {string} source_metadata_category -
 * @property {string} source_metadata_slug -
 * @property {string} source_name -
 * @property {string} source_slug -
 * @property {string} source_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceDeleteClicked
 * @property {string} source_count -
 * @property {boolean} source_enabled -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceDeleted
 * @property {string} source_count -
 * @property {string} source_id -
 * @property {string} source_metadata_category -
 * @property {string} source_metadata_slug -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceDisabled
 * @property {string} source_count -
 * @property {string} source_id -
 * @property {string} source_metadata_category -
 * @property {string} source_metadata_slug -
 * @property {string} source_name -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceEnabled
 * @property {string} source_count -
 * @property {string} source_id -
 * @property {string} source_metadata_category -
 * @property {string} source_metadata_slug -
 * @property {string} source_name -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceLabelEdited
 * @property {any[]} new_labels -
 * @property {any[]} old_labels -
 * @property {string} source_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceMoved
 * @property {string} source_enabled -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_old_slug -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceOverviewAccordionToggled
 * @property {string} accordion -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceOverviewLinkClicked
 * @property {string} link -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceSqlSettingsChanged
 * @property {string} source_enabled -
 * @property {string} source_id -
 * @property {string} source_old_slug -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceSchemaCleared
 * @property {string} [source_id] -
 * @property {string} source_slug -
 * @property {string} [workspace_id] -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceSchemaRefreshClicked
 * @property {string} source_enabled -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceSchemaRefreshed
 * @property {string} source_enabled -
 * @property {string} source_has_sent_data -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceSetupFunnelStepCompleted
 * @property {string} cta_text -
 * @property {string} [error_level] -
 * @property {string} [error_message] -
 * @property {string} [error_reason] -
 * @property {string} funnel_step -
 * @property {string} source_metadata_category -
 * @property {string} source_metadata_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourceWriteKeyGenerated
 * @property {string} source_id -
 * @property {string} workspace_id -
 */
/**
 * @typedef SourceWriteKeyRevoked
 * @property {string} source_id -
 * @property {string} workspace_id -
 */
/**
 * @typedef SourceSearchedOnBulkAssignEnvironments
 * @property {string} search_term -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SourcesCollectionToggled
 * @property {string} [collection_id] - The ID of the collection
 * @property {string} [collection_name] - The name of the collection
 * @property {boolean} [enabled] - True/False
 * @property {string} [source_id] - The ID of the Source
 */
/**
 * @typedef SourcesFieldToggled
 * @property {string} [collection_id] - The ID of the collection the field is nested under
 * @property {boolean} [enabled] - True or False
 * @property {string} [field_id] - The ID of the field
 * @property {string} [field_name] - The name of the field
 * @property {string} [source_id] - The ID of the Source
 */
/**
 * @typedef SourcesLinkClicked
 * @property {any | null} [] -
 * @property {string} [source_metadata_slug] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SplitAccountButtonClicked
 * @property {string} workspace - slug
 */
/**
 * @typedef SplitAccountButtonViewed
 * @property {string} workspace - slug
 */
/**
 * @typedef StarterTrackingPlanCreated
 * @property {any | null} business_type -
 * @property {any[]} events - Array of all the event names (including Page, Screen, Identify, Track events) that are selected when the user submits the Starter Tracking Plan form
 * @property {any | null} source_slug -
 * @property {any | null} user_email -
 * @property {any | null} user_id -
 * @property {any | null} workspace_id -
 * @property {any | null} workspace_slug -
 */
/**
 * @typedef StartupApplicationCompleted
 * @property {string} [company_address] - The mailing address for a company
 * @property {string} [company_industry] -
 * @property {string} company_name -
 * @property {string} company_website -
 * @property {string} crunchbase_profile - The URL for a company's profile on Crunchbase
 * @property {string} date_founded -
 * @property {number} employee_count - Number of employees at the company
 * @property {string} experience_with_segment -
 * @property {string} funding_raised - The total funding raised (USD)
 * @property {string} funding_round -
 * @property {boolean} [is_partner_affiliated] - Is the company affiliated with one of our partners?
 * @property {string} personal_linkedin_profile -
 * @property {string} segment_usage - How will the customer be looking to use Segment
 */
/**
 * @typedef StepCompletedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} stepId -
 * @property {string} stepType -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef StepInteractedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} interaction -
 * @property {string} interactionType -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} stepChildId -
 * @property {string} stepChildNumber -
 * @property {string} stepId -
 * @property {string} stepType -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef StepSkippedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} stepChildId -
 * @property {string} stepChildNumber -
 * @property {string} stepId -
 * @property {string} stepType -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef StepStartedAppcues
 * @property {string} flowId -
 * @property {string} flowName -
 * @property {string} flowType -
 * @property {string} flowVersion -
 * @property {string} name -
 * @property {string} sessionId -
 * @property {string} stepId -
 * @property {string} stepType -
 * @property {string} timestamp -
 * @property {string} user -
 */
/**
 * @typedef SubmittedWishlistIntegrationRequest
 * @property {string} integration_type - source or a destination
 * @property {string} reason - use-case for the request
 * @property {string} requested_integration_id -
 * @property {string} tool_name - name of the tool requested
 * @property {string} tool_url - website/url of the tool
 */
/**
 * @typedef SubscriptionPlanChangeError
 * @property {string} newPlan -
 * @property {string} previousPlan -
 * @property {string} workspaceId -
 * @property {string} workspaceSlug -
 */
/**
 * @typedef SubscriptionPlanChanged
 * @property {string} newPlan -
 * @property {string} [newPlanLevel] -
 * @property {string} previousPlan -
 * @property {string} [version] -
 * @property {string} workspaceId -
 * @property {string} [workspaceSlug] -
 */
/**
 * @typedef SubscriptionPlanFailed
 * @property {string} newPlan -
 * @property {string} [newPlanLevel] -
 * @property {string} previousPlan -
 * @property {string} workspaceId -
 * @property {string} [workspaceSlug] -
 */
/**
 * @typedef SupportAccessGrantCreated
 * @property {string} [email] -
 * @property {string} [token_expires_at] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef SupportAccessGrantRevoked
 * @property {string} [email] -
 * @property {string} [token_expires_at] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef SurveyClosed
 * @property {string} plan_type -
 * @property {string} [survey_id] - This is never provided in the app.
 * @property {string} survey_medium -
 * @property {string} survey_name -
 * @property {string} survey_other_feedback -
 * @property {string} [survey_primary_label] -
 * @property {string} [survey_primary_value] -
 * @property {string} [survey_secondary_label] -
 * @property {string} [survey_secondary_value] -
 * @property {number} survey_time_elapsed -
 * @property {string} survey_tool -
 * @property {string} survey_type -
 * @property {string} workspace_created_date -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SurveyCompleted
 * @property {string} plan_type -
 * @property {string} [survey_id] - This is never provided in the app.
 * @property {string} survey_medium -
 * @property {string} survey_name -
 * @property {string} survey_other_feedback -
 * @property {string} survey_primary_label -
 * @property {string} survey_primary_value -
 * @property {string} survey_secondary_label -
 * @property {string} survey_secondary_value -
 * @property {number} survey_time_elapsed -
 * @property {string} survey_tool -
 * @property {string} survey_type -
 * @property {string} workspace_created_date -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef SurveyViewed
 * @property {string} survey_medium -
 * @property {string} survey_name -
 * @property {string} survey_tool -
 * @property {string} survey_type -
 * @property {string} workspace_created_date -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef TagAnEventClicked
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef RolesItem
 * @property {boolean} [all] -
 * @property {string} [name] -
 * @property {string[]} [resources] -
 */
/**
 * @typedef TeamMemberDetailViewClosed
 * @property {number} [current_member_count] - Current number of users in the workspace excl this invite
 * @property {RolesItem[]} [roles] -
 * @property {any | null} [team_member_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef RolesItem1
 * @property {boolean} [all] -
 * @property {string} [name] -
 * @property {string[]} [resources] -
 */
/**
 * @typedef TeamMemberDetailViewed
 * @property {number} [current_member_count] - Current number of users in the workspace excl this invite
 * @property {RolesItem1[]} [roles] -
 * @property {any | null} [team_member_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef RolesItem2
 * @property {boolean} [all] -
 * @property {string} [name] -
 * @property {string[]} [resources] -
 */
/**
 * @typedef TeamMemberInvited
 * @property {number} [current_member_count] - Current number of users in the workspace excl this invite
 * @property {string} [invitee_email] - The email of the invited member
 * @property {any | null} [plan] - Developer,Team,BT
 * @property {RolesItem2[]} [roles] -
 * @property {any | null} [team_member_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef TeamMemberInvitedLegacy
 * @property {any | null} [plan] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef RolesItem3
 * @property {boolean} [all] -
 * @property {string} [name] -
 * @property {string[]} [resources] -
 */
/**
 * @typedef TeamMemberRemoved
 * @property {number} [current_member_count] - Current number of users in the workspace excl this invite
 * @property {RolesItem3[]} [roles] -
 * @property {any | null} [team_member_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef RolesItem4
 * @property {boolean} [all] -
 * @property {string} [name] -
 * @property {string[]} [resources] -
 */
/**
 * @typedef TeamMemberSaved
 * @property {string[]} [added_roles] - The roles added to this user
 * @property {number} [current_member_count] - Current number of users in the workspace excl this invite
 * @property {string[]} [removed_roles] - The roles removed from this user
 * @property {RolesItem4[]} [roles] -
 * @property {any | null} [team_member_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ToolRequestFormSubmitted
 * @property {string} company -
 * @property {string} email -
 * @property {string} layout -
 * @property {string} name -
 * @property {string} platforms -
 * @property {string} reason -
 * @property {string} repo -
 * @property {string} tool -
 * @property {string} tool_requested_name -
 * @property {string} tool_requested_type -
 * @property {string} tool_types_displayed -
 * @property {string} tools -
 * @property {string} type -
 * @property {string} use_case -
 * @property {string} workspaceSlug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef TrackingPlanConnectionChanged
 * @property {boolean} connected - true if source connected to TP, false if disconnected
 * @property {string} connected_source_id - project_id of the source being connected
 * @property {string} [connected_source_slug] - slug of source being connected
 * @property {string} [origin] - How the tracking plan was updated (Options: api | app)
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} workspace_id - segment workspace id
 * @property {string} [workspace_slug] - segment workspace slug
 */
/**
 * @typedef TrackingPlanCreated
 * @property {string[]} [events_edited] - An array of strings listing which events were added or edited.
 * @property {string} [origin] - How the tracking plan was updated (Options: api | app)
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} [type] - The type of Tracking Plan (because Tracking Plans can also be Libraries).
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TrackingPlanDeleted
 * @property {string} [origin] - How the tracking plan was updated (Options: api | app)
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} [type] - The type of Tracking Plan (because Tracking Plans can also be Libraries).
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TrackingPlanEventVersionAdded
 * @property {string | null} [resource_updated] - The id of the resource (tracking plan) if it was updated.
 * @property {string} rule_key - key for the rule that the user added a version to
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {number} version_number - version number that was created
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TrackingPlanInferred
 * @property {string[]} [events_edited] - An array of strings listing which events were added or edited.
 * @property {string} [infer_type] - how the tracking plan was inferred. Use source for infer from source, and spec for infer from spec.
 * @property {string} [source_id] - Source ID of the interred source.
 * @property {string} [source_name] - The name of the inferred source
 * @property {string} [spec_name] - The name of the inferred spec.
 * @property {string} [timeframe] - The length of time that events were inferred from.
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} [type] - The type of this Tracking Plan.
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TrackingPlanSaved
 * @property {string[]} [events_edited] - An array of ids of events that were edited.
 * @property {number} [events_edited_count] - The count of unique events edited on Tracking Plan Save.
 * @property {string} [origin] - How the tracking plan was updated (Options: api | app)
 * @property {string | null} [resource_updated] - The id of the resource (tracking plan) if it was updated.
 * @property {string[]} [rules_deleted] - An array of ids of rules that were deleted
 * @property {number} [rules_deleted_count] - The count of unique rules that were deleted.
 * @property {string[]} [rules_edited] - An array of keys of rules that were edited
 * @property {number} [rules_edited_count] - The count of unique rules that were edited
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} [type] - The type of Tracking Plan (because Tracking Plans can also be Libraries).
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TrackingPlanTipInteracted
 * @property {string} interaction - Indicates which action the user took with the tip - can be Opened, Ignored or Accepted
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TrackingSpecsSelected
 * @property {string[]} specs - Code snippets that correspond to track events a user has selected in the What to Track step of the onboarding flow
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef TransactionalError
 * @property {any | null} [appTrace] -
 * @property {string[]} categories - The set of categories of errors (Access Denied, etc.)
 * @property {string} categoryString - A string-ified version of category, for Destination Filters usage.
 * @property {string} displayName -
 * @property {string} [extra] -
 * @property {any[]} [failedGraphQLQueries] -
 * @property {string} [feature] -
 * @property {string | null} [fullStory] -
 * @property {string} messageString - A string-ified version of messages, for Destination Filters usage.
 * @property {string[]} messages - A list of the error messages
 * @property {string} path -
 * @property {string | null} route -
 * @property {any | null} [sentryId] -
 * @property {string} timezone -
 * @property {string} transactionTitle -
 */
/**
 * @typedef ActionsItem
 * @property {string} [event_names] - Events selected to transform
 * @property {string} [property_names] - Properties being transformed, if any
 * @property {string} [type] - Type of transformation applied. Options: Map, hash, filter, etc.
 */
/**
 * @typedef TransformationCreated
 * @property {ActionsItem[]} actions - List of tsub actions to perform.
 * @property {boolean} enabled - Whether the transformation is enabled.
 * @property {string} name - Name entered by customer to describe transformation
 * @property {string[]} selected_source_id - Array of sourceIds for sources selected to apply the transformation. Currently limited to 1.
 * @property {string} transformation_id - Unique id created for each transformation
 * @property {string} transformation_scope - Where the transformation is applied. Options: source or destination
 * @property {string} workspace_id - The ID of the workspace where the Transformations overview was opened.
 * @property {string} workspace_slug - The slug of the workspace where the Transformations overview was opened.
 */
/**
 * @typedef TransformationDeleted
 * @property {string} transformation_id - Unique id created for each transformation
 * @property {string} workspace_id - The ID of the workspace where the Transformations overview was opened.
 * @property {string} workspace_slug - The slug of the workspace where the Transformations overview was opened.
 */
/**
 * @typedef TriggerTypeReSelected
 * @property {any | null} [new_trigger] -
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef UrlFieldEdited
 * @property {any | null} [default_url] -
 * @property {any | null} [new_url] -
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef UnreadNotificationCountDisplayed
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef UpdateOnboardingStepState
 * @property {string} new_state - State of the step after update
 * @property {string} previous_state - State of the step prior to update
 * @property {string} step_id - Unique identifier for the step
 * @property {string} step_title - Title of the step
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - ="Yes" if w. VT; ="No" if w.o VT
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 * @property {number} workspace_step_id - ID of the workspace step; optional since the event may create the step on the backend
 */
/**
 * @typedef UpdateProfileClicked
 * @property {string} email_new -
 * @property {string} email_old -
 * @property {string} full_name_new -
 * @property {string} full_name_old -
 */
/**
 * @typedef UpdatedComponents
 * @property {string} destination_slug -
 * @property {string} [source] -
 */
/**
 * @typedef UpdatedContacts
 * @property {string} destination_slug -
 * @property {string} [source] -
 */
/**
 * @typedef UpgradeCtaClicked
 * @property {string} billing_tier -
 * @property {string} current_url -
 * @property {string} [position] - This field should describe the position of the CTA in the workspace when the user clicks it. This will help us test performance of various locations for this button.
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef UpvotedWishlistIntegrationRequest
 * @property {string} integration_type - source or a destination
 * @property {any | null} [reason] - reason for upvoting/requesting the integration
 * @property {string} [requested_integration_id] -
 * @property {string} tool_name - name of the tool requested
 * @property {string} tool_url - website/url of the tool
 */
/**
 * @typedef UserCreated
 * @property {string} email -
 * @property {string} name -
 * @property {string} source -
 * @property {string} traits -
 * @property {string} type -
 * @property {string} workspace_plan -
 */
/**
 * @typedef UserImpersonated
 * @property {string} impersonated_method -
 * @property {string} impersonated_user_email -
 * @property {string} [impersonated_workspace] -
 */
/**
 * @typedef UserSignedUp
 * @property {string} [billing_plan] - The selected billing plan that will be applied to this user's first workspace.
 * @property {string | null} email -
 * @property {boolean} [enable_signup] -
 * @property {boolean} [has_invalid_invite_token] - Whether the user signed up with an invite token that was found to be invalid.
 * @property {boolean} [has_invite_token] - Whether the user signed up with an invite token.
 * @property {boolean} [partner_signup] -
 * @property {boolean | null} [startup] -
 * @property {boolean | null} strong_signup -
 * @property {string | null} type -
 */
/**
 * @typedef VtGetStartedButtonClicked
 * @property {any | null} [billing_plan_id] -
 * @property {any | null} [billing_tier] -
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef VtLegalModalInstallButtonClicked
 * @property {any | null} [billing_plan_id] -
 * @property {any | null} [billing_tier] -
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef VtViewDebuggerClicked
 * @property {any | null} [num_visual_events] - The number of visual events in the spec at the time that the user clicks this button
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ValidateDataClicked
 * @property {string} [location] - specifies where the user clicked from. "Tracking Plan List" if clicking from TP list view. "Source Schema" if clicking from schema.
 * @property {string} [tracking_plan_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ViewChangelogClicked
 * @property {string} tracking_plan_id - The ID of the Tracking Plan.
 * @property {string} workspace_id - The ID of the workspace that the Tracking Plan belongs to.
 * @property {string} workspace_slug - The slug of the workspace that the Tracking Plan belongs to.
 */
/**
 * @typedef ViewDebuggerClicked
 * @property {string} location - ie "workspace checklist"
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {boolean} vt_flag_on -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef ViewLibrariesClicked
 * @property {string} location - The location in the app where the activity took place.
 * @property {string} workspace_id - The ID of the workspace where the Libraries overview was opened.
 * @property {string} workspace_slug - The slug of the workspace where the Libraries overview was opened.
 */
/**
 * @typedef ViewSchemaConfigurationClicked
 * @property {string} location - specifies where the user is clicking from (schema tab or tp list)
 */
/**
 * @typedef ViewSourceSchemaClicked
 * @property {string} location - specifies where the user is clicking from (tp list or data validation)
 */
/**
 * @typedef ViewTrackingPlanClicked
 * @property {string} location - specifies where the user was when clicking to view violations
 * @property {string} tracking_plan_id - resource id for the tracking plan
 * @property {string} [type] - The type of Tracking Plan (because Tracking Plans can also be Libraries).
 * @property {string} workspace_id - workspace id associated with tracking plan
 * @property {string} workspace_slug - workspace slug associated with tracking plan
 */
/**
 * @typedef ViewTransformationsClicked
 * @property {string} location - The location in the app where the activity took place.
 * @property {string} workspace_id - The ID of the workspace where the Transformations overview was opened.
 * @property {string} workspace_slug - The slug of the workspace where the Transformations overview was opened.
 */
/**
 * @typedef ViewViolationsClicked
 * @property {string} [event_id] - event id
 * @property {string} location - specifies where the user was when clicking to view violations
 * @property {string} [source_id] - segment source id
 * @property {string} [source_slug] - segment source slug
 * @property {string} type - specifies what level of violations the user wants to see. Source when clicking from Schema. Event when clicking into event detail. Property when clicking into property detail.
 * @property {string} workspace_id - segment workspace id
 * @property {string} [workspace_slug] - segment workspace slug
 */
/**
 * @typedef ViewedFeaturedDestinations
 * @property {string} workspace_slug -
 */
/**
 * @typedef ViewedIntegration
 * @property {string} projectId -
 * @property {string} projectSlug -
 * @property {string} workspaceId -
 * @property {string} workspaceLogin -
 */
/**
 * @typedef ViewedLockout
 * @property {string} [user_email] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 */
/**
 * @typedef ViolationsDeleted
 * @property {string} [source_id] -
 * @property {string} source_slug -
 * @property {string} [workspace_id] -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisitedIntegrationDocs
 * @property {string} name -
 */
/**
 * @typedef VisualEventCreated
 * @property {any | null} [event_handler] -
 * @property {any | null} [event_name] -
 * @property {any[]} [properties] -
 * @property {any | null} [selector] -
 * @property {any | null} [source_id] - ID of the customer's source that this event will be created for
 * @property {any | null} [source_slug] - Slug of the customer's source that this event will be created for
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef VisualTaggerAddPropertyClicked
 * @property {string} [event_name] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerAdvancedOptionsClicked
 * @property {string} [event_name] -
 * @property {any | null} [properties] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerCopySnippetClicked
 * @property {string} location - so that we know the event is fired from VT
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerCreateEventClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerCreateEventsClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerCreateNewClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerDeleteClicked
 * @property {any[]} events -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerDocClicked
 * @property {string} location - ="VT Home Page"
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerEditClicked
 * @property {any[]} events -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerEnterValueClicked
 * @property {any | null} [event_name] -
 * @property {any | null} [property] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerEventCreated
 * @property {string} event_name -
 * @property {any | null} [properties] -
 * @property {any | null} [selector] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {any | null} [url] - the url of the webpage that has been entered to create tagging
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerEventSaved
 * @property {any | null} [event_name] -
 * @property {any | null} [properties] -
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef VisualTaggerEventTested
 * @property {string} event_name -
 * @property {any | null} [properties] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {boolean} test_result - true if test is successful, false if not.
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerExitClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerGetStartedButtonClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} [user_id] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerGuideClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerIntegrationToggled
 * @property {boolean} enabled - Enabled = true, Disabled = false
 * @property {string} [source_id] - Source ID of the project this is toggled on
 * @property {string} [workspace_id] - Workspace of the project this is toggled on.
 */
/**
 * @typedef VisualTaggerLearnBestPracticeClicked
 * @property {string} [event_name] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerPublishClicked
 * @property {number} number_of_events -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerSelectValueFromPageClicked
 * @property {any | null} [event_name] -
 * @property {any | null} [property] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerSetupStepsContinueClicked
 * @property {string} [source_id] -
 * @property {string} [source_slug] -
 * @property {string} [user_id] -
 * @property {string} [workspace_id] -
 * @property {string} [workspace_slug] -
 */
/**
 * @typedef VisualTaggerTemplateClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerTestEventsClicked
 * @property {number} number_of_events -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerTrackAnyClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerTrackButtonsClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerTrackFormsClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerVideoClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} type - ='Introduction" or "How-to'
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerViewAgreementClicked
 * @property {string} source_id -
 * @property {string} source_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef VisualTaggerViewExtensionClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseConnectionFailed
 * @property {string} error -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseConnectionTested
 * @property {boolean} status -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseConnectionUpdated
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseCreated
 * @property {string} warehouse_id -
 * @property {string} warehouse_slug -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseDeleteClicked
 * @property {string} warehouse_id -
 * @property {string} [warehouse_slug] -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 */
/**
 * @typedef WarehouseDeleted
 * @property {string} warehouse_id -
 * @property {string} warehouse_slug -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseDisabled
 * @property {string} warehouse_id -
 * @property {string} warehouse_slug -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseEnabled
 * @property {string} warehouse_id -
 * @property {string} warehouse_slug -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseNicknameChanged
 * @property {string} warehouse_id -
 * @property {string} warehouse_name -
 * @property {string} warehouse_old_name -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseSchemaUpdated
 * @property {number} num_changes_collections - Number of changes made to collections syncing to a Warehouse
 * @property {number} num_changes_disabled - Number of changes that are disabling property/source/collection
 * @property {number} num_changes_enabled - Number of changes that are enabling property/source/collection
 * @property {number} num_changes_properties - Number of changes made to properties syncing to a Warehouse
 * @property {number} [num_changes_sources] - Number of changes made to sources syncing to Warehouse
 * @property {number} num_changes_total - Number of total changes made to source/collection/property
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseSettingsSaved
 * @property {string} warehouse_id -
 * @property {string} warehouse_slug -
 * @property {string} warehouse_type -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseSimulatorQueryExecuted
 * @property {any | null} [execution_error] -
 * @property {any | null} [sql] - The SQL query executed
 */
/**
 * @typedef WarehouseSourceEnableToggled
 * @property {boolean} enabled - Whether the warehouse/source is being enabled or disabled
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseSyncScheduleDisabled
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseSyncScheduleEnabled
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WarehouseSyncScheduleSaved
 * @property {string} sync_times -
 * @property {number} sync_times_count -
 * @property {string} sync_timezone -
 * @property {string} warehouse_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceCreated
 * @property {string} bucket -
 * @property {string} email -
 * @property {boolean} startup -
 * @property {string} workspace_count -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_plan -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceDeleted
 * @property {string} workspace_created_date -
 * @property {string} workspace_id -
 * @property {string} workspace_name -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceHomeAddVisualTaggerClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceHomeEditDestinationSettings
 * @property {string} destination_id -
 * @property {string} destination_slug -
 * @property {boolean} flag_on_vt - ="Yes" if w. VT, ="No" if without
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceHomeViewCatalogClicked
 * @property {string} location - workspace home checklist
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {boolean} vt_flag_on - ='Yes" for VT;="No" if without VT
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceHomeViewCodeDocsClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceHomeVisualTaggerCopySnippetClicked
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceInsightsCsvDownloaded
 * @property {string} period -
 * @property {string} [type] -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceInsightsPeriodChanged
 * @property {string} period -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceSettingsTabClicked
 * @property {string} tab -
 */
/**
 * @typedef WorkspaceUsageMetricCsvDownloaded
 * @property {string} metric - The current usage metric
 * @property {string} period_end - The selected invoice period's end date
 * @property {string} period_start - The selected invoice period's start date
 * @property {string} workspace_id - The id of the workspace
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceUsageMetricOverviewDetailsExpanded
 * @property {string} metric -
 * @property {string} period_end -
 * @property {string} period_start -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceUsageMetricTabSelected
 * @property {string} metric -
 * @property {string} period_end -
 * @property {string} period_start -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceUsageMetricTooltipViewed
 * @property {string} metric -
 * @property {string} period_end -
 * @property {string} period_start -
 * @property {string} tooltip_parent_attribute - The attribute name linked to the tooltip
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceUsagePeriodChanged
 * @property {string | null} [metric] -
 * @property {string} period_end - The select invoice period's end date.
 * @property {string} period_start - The selected invoice period's start date.
 * @property {string} workspace_id - The id of the workspace
 * @property {string} workspace_slug -
 */
/**
 * @typedef WorkspaceUsageUpgradeCtaClicked
 * @property {string | null} [metric] -
 * @property {string} period_end -
 * @property {string} period_start -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef OriginalFlag
 * @property {string} name -
 * @property {boolean} value -
 */
/**
 * @typedef PrototypedFlag
 * @property {string} name -
 * @property {boolean} value -
 */
/**
 * @typedef WorkspacesFlagsComparison
 * @property {boolean} are_equal -
 * @property {OriginalFlag} original_flag -
 * @property {PrototypedFlag} prototyped_flag -
 * @property {boolean} used_original_value -
 * @property {string} workspace_id -
 */
/**
 * @typedef OriginalQuota
 * @property {boolean} is_valid -
 * @property {string} name -
 * @property {any | null} value -
 */
/**
 * @typedef PrototypedQuota
 * @property {boolean} is_valid -
 * @property {string} name -
 * @property {any | null} value -
 */
/**
 * @typedef WorkspacesQuotaComparison
 * @property {boolean} are_equal -
 * @property {OriginalQuota} original_quota -
 * @property {PrototypedQuota} prototyped_quota -
 * @property {boolean} used_original_value -
 * @property {string} workspace_id -
 */
/**
 * @typedef WriteKeyChangeClicked
 * @property {string} source_enabled -
 * @property {boolean} [source_has_sent_data] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WriteKeyChanged
 * @property {string} source_enabled -
 * @property {boolean} [source_has_sent_data] -
 * @property {string} source_id -
 * @property {string} source_slug -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef WritekeyRetryClicked
 * @property {any | null} [URL] - URL that the user is currently on when they click this button
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef DoNotAddYetWorkspaceHomeSetupGuideDocsClicked
 * @property {any | null} [billing_plan_id] -
 * @property {any | null} [billing_tier] -
 * @property {any | null} [user_id] -
 * @property {any | null} [workspace_id] -
 * @property {any | null} [workspace_slug] -
 */
/**
 * @typedef ClickedConnectPaneLink
 * @property {string} link -
 * @property {string} link_text -
 * @property {string} tool_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */
/**
 * @typedef ViewedConnectPane
 * @property {string} tool_name -
 * @property {string} user_id -
 * @property {string} workspace_id -
 * @property {string} workspace_slug -
 */

/**
 * Fires a 'Access Denied Error' track call.
 *
 * @param {AccessDeniedError} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accessDeniedError(
	props: AccessDeniedError,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Access Denied Error',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Activity Feed Filtered' track call.
 *
 * @param {ActivityFeedFiltered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function activityFeedFiltered(
	props: ActivityFeedFiltered,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Activity Feed Filtered',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Activity Feed Searched' track call.
 *
 * @param {ActivityFeedSearched} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function activityFeedSearched(
	props: ActivityFeedSearched,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Activity Feed Searched',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Ad Campaign Clicked' track call.
 *
 * @param {AdCampaignClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function adCampaignClicked(
	props: AdCampaignClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Ad Campaign Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Add Destination"
 *
 * @param {AddDestinationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addDestinationClicked(
	props: AddDestinationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Destination Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user completes "Add Destination" flow
 *
 * @param {AddDestinationCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addDestinationCompleted(
	props: AddDestinationCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Destination Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Close" on sending pageview data flow
 *
 * @param {AddPageviewsCloseButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addPageviewsCloseButtonClicked(
	props?: AddPageviewsCloseButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Pageviews Close Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Copy Snippet" on sending pageview data
 *
 * @param {AddPageviewsCopySnippetClickedCopy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addPageviewsCopySnippetClickedCopy(
	props: AddPageviewsCopySnippetClickedCopy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Pageviews Copy Snippet Clicked Copy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Get Started" on sending pageview data
 *
 * @param {AddPageviewsGetStartedClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addPageviewsGetStartedClicked(
	props?: AddPageviewsGetStartedClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Pageviews Get Started Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Add Source" button from the checklist
 *
 * @param {AddSourceButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addSourceButtonClicked(
	props: AddSourceButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Source Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks the "Next" or "Finish" button in the Add Source flow
 *
 * @param {AddSourceNextButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addSourceNextButtonClicked(
	props: AddSourceNextButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Add Source Next Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'AdminTOS Acknowledged' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function adminTosAcknowledged(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'AdminTOS Acknowledged',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Advanced Usage Tab Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function advancedUsageTabClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Advanced Usage Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Agreement Downloaded Signed Copy' track call.
 *
 * @param {AgreementDownloadedSignedCopy} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agreementDownloadedSignedCopy(
	props?: AgreementDownloadedSignedCopy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Agreement Downloaded Signed Copy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Agreement Downloaded Unsigned Copy' track call.
 *
 * @param {AgreementDownloadedUnsignedCopy} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agreementDownloadedUnsignedCopy(
	props?: AgreementDownloadedUnsignedCopy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Agreement Downloaded Unsigned Copy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Agreement Signed' track call.
 *
 * @param {AgreementSigned} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agreementSigned(
	props?: AgreementSigned,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Agreement Signed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * App timing metrics from real users in our app.
 *
 * @param {AppTimingMetric} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function appTimingMetric(
	props: AppTimingMetric,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'App Timing Metric',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user clicks "Assign Labels" in the Label Management console
 *
 * @param {AssignLabelsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function assignLabelsClicked(
	props: AssignLabelsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Assign Labels Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Audit Trail Filtered' track call.
 *
 * @param {AuditTrailFiltered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function auditTrailFiltered(
	props: AuditTrailFiltered,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Audit Trail Filtered',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User accepted beta terms of service
 *
 * @param {BetaTermsAccepted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function betaTermsAccepted(
	props: BetaTermsAccepted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Beta Terms Accepted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user toggles "Braze Debounce Identify" in their analytics.js settings
 *
 * @param {BrazeMiddlewareToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function brazeMiddlewareToggled(
	props: BrazeMiddlewareToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Braze Middleware Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when the "Save Changes" button is clicked for bulk assigning labels in the label management console
 *
 * @param {BulkAssignLabelSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bulkAssignLabelSaved(
	props: BulkAssignLabelSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Bulk Assign Label Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'CSV Downloaded' track call.
 *
 * @param {CsvDownloaded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function csvDownloaded(
	props?: CsvDownloaded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'CSV Downloaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when user clicks the "Cancel" button on the bulk assign environments dialog
 *
 * @param {CancelButtonBulkAssignEnvironmentsClickCopy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function cancelButtonBulkAssignEnvironmentsClickCopy(
	props: CancelButtonBulkAssignEnvironmentsClickCopy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Cancel button bulk assign environments click Copy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Category Clicked' track call.
 *
 * @param {CatalogCategoryClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogCategoryClicked(
	props?: CatalogCategoryClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Category Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Recommendation Category Clicked' track call.
 *
 * @param {CatalogRecommendationCategoryClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogRecommendationCategoryClicked(
	props?: CatalogRecommendationCategoryClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Recommendation Category Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Recommendation Clicked' track call.
 *
 * @param {CatalogRecommendationClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogRecommendationClicked(
	props?: CatalogRecommendationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Recommendation Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Sidebar Category Clicked' track call.
 *
 * @param {CatalogSidebarCategoryClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogSidebarCategoryClicked(
	props?: CatalogSidebarCategoryClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Sidebar Category Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User searched the catalog using the sidebar in the left nav.
 *
 * @param {CatalogSidebarSearched} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogSidebarSearched(
	props: CatalogSidebarSearched,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Sidebar Searched',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Sidebar Tab Clicked' track call.
 *
 * @param {CatalogSidebarTabClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogSidebarTabClicked(
	props?: CatalogSidebarTabClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Sidebar Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Sort By' track call.
 *
 * @param {CatalogSortBy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogSortBy(
	props: CatalogSortBy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Sort By',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Sort By Clicked' track call.
 *
 * @param {CatalogSortByClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogSortByClicked(
	props?: CatalogSortByClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Sort By Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Catalog Tile Clicked' track call.
 *
 * @param {CatalogTileClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function catalogTileClicked(
	props?: CatalogTileClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Catalog Tile Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * In gateway-api, start censoring settings going to the app.

 *
 * @param {CensorDestinationSettings} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function censorDestinationSettings(
	props: CensorDestinationSettings,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Censor Destination Settings',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Change Password link clicked on the User Settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function changePasswordClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Change Password Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Change Workspace Clicked' track call.
 *
 * @param {ChangeWorkspaceClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function changeWorkspaceClicked(
	props: ChangeWorkspaceClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Change Workspace Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Change Workspace Clicked from Account settings' track call.
 *
 * @param {ChangeWorkspaceClickedFromAccountSettings} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function changeWorkspaceClickedFromAccountSettings(
	props?: ChangeWorkspaceClickedFromAccountSettings,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Change Workspace Clicked from Account settings',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Change Workspace Clicked from Workspace settings' track call.
 *
 * @param {ChangeWorkspaceClickedFromWorkspaceSettings} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function changeWorkspaceClickedFromWorkspaceSettings(
	props?: ChangeWorkspaceClickedFromWorkspaceSettings,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Change Workspace Clicked from Workspace settings',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Checklist Completed (Appcues)' track call.
 *
 * @param {ChecklistCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checklistCompletedAppcues(
	props?: ChecklistCompletedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checklist Completed (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks on the "View Source" link once Source has been created
 *
 * @param {ChecklistCompletedItemLinkClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checklistCompletedItemLinkClicked(
	props?: ChecklistCompletedItemLinkClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checklist Completed Item Link Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Checklist Dismissed (Appcues)' track call.
 *
 * @param {ChecklistDismissedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checklistDismissedAppcues(
	props?: ChecklistDismissedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checklist Dismissed (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Checklist Item Completed (Appcues)' track call.
 *
 * @param {ChecklistItemCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checklistItemCompletedAppcues(
	props?: ChecklistItemCompletedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checklist Item Completed (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user expands one of the Checklist items. Does not fire if the user collapses the Checklist item.
 *
 * @param {ChecklistItemExpanded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checklistItemExpanded(
	props: ChecklistItemExpanded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checklist Item Expanded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Checklist Shown (Appcues)' track call.
 *
 * @param {ChecklistShownAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checklistShownAppcues(
	props?: ChecklistShownAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checklist Shown (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user applies a classification on the Inbox
 *
 * @param {ClassificationApplied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function classificationApplied(
	props: ClassificationApplied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Classification Applied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Add Destination' track call.
 *
 * @param {ClickedAddDestination} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedAddDestination(
	props: ClickedAddDestination,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Add Destination',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Add Source' track call.
 *
 * @param {ClickedAddSource} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedAddSource(
	props: ClickedAddSource,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Add Source',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked CTA' track call.
 *
 * @param {ClickedCta} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedCta(
	props?: ClickedCta,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked CTA',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Catalog Integration' track call.
 *
 * @param {ClickedCatalogIntegration} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedCatalogIntegration(
	props: ClickedCatalogIntegration,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Catalog Integration',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Catalog Interested In Building' track call.
 *
 * @param {ClickedCatalogInterestedInBuilding} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedCatalogInterestedInBuilding(
	props: ClickedCatalogInterestedInBuilding,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Catalog Interested In Building',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Catalog View All' track call.
 *
 * @param {ClickedCatalogViewAll} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedCatalogViewAll(
	props: ClickedCatalogViewAll,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Catalog View All',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Configure Destination' track call.
 *
 * @param {ClickedConfigureDestination} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedConfigureDestination(
	props: ClickedConfigureDestination,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Configure Destination',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked SQL Integration' track call.
 *
 * @param {ClickedSqlIntegration} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedSqlIntegration(
	props?: ClickedSqlIntegration,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked SQL Integration',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Wishlist Integration Request Logo' track call.
 *
 * @param {ClickedWishlistIntegrationRequestLogo} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedWishlistIntegrationRequestLogo(
	props: ClickedWishlistIntegrationRequestLogo,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Wishlist Integration Request Logo',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Clicked Wishlist Upvote Button' track call.
 *
 * @param {ClickedWishlistUpvoteButton} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedWishlistUpvoteButton(
	props: ClickedWishlistUpvoteButton,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Clicked Wishlist Upvote Button',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user copies the code snipped for an event
 *
 * @param {CodeSnippetCopied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function codeSnippetCopied(
	props: CodeSnippetCopied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Code Snippet Copied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Track of delete confirmation of an integration (source, destination or warehouse) in connection health
 *
 * @param {ConnectionHealthDeleteCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionHealthDeleteCancelled(
	props: ConnectionHealthDeleteCancelled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Health Delete Cancelled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Track of click when deleting an integration (source, destination or warehouse) in connection health
 *
 * @param {ConnectionHealthDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionHealthDeleteClicked(
	props: ConnectionHealthDeleteClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Health Delete Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Track of delete confirmation of an integration (source, destination or warehouse) in connection health
 *
 * @param {ConnectionHealthDeleteCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionHealthDeleteCompleted(
	props: ConnectionHealthDeleteCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Health Delete Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Track of click when disabling an integration (source, destination or warehouse) in connection health
 *
 * @param {ConnectionHealthDisableClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionHealthDisableClicked(
	props: ConnectionHealthDisableClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Health Disable Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Connection Health Error Clicked' track call.
 *
 * @param {ConnectionHealthErrorClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionHealthErrorClicked(
	props: ConnectionHealthErrorClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Health Error Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Track of click for the action button in connection health
 *
 * @param {ConnectionHealthResolveErrorClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionHealthResolveErrorClicked(
	props: ConnectionHealthResolveErrorClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Health Resolve Error Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user edits a connection policy in Personas Space
 *
 * @param {ConnectionPolicyEdited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function connectionPolicyEdited(
	props: ConnectionPolicyEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Connection Policy Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user creates a new label in the Label Management console
 *
 * @param {CreateLabelClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function createLabelClicked(
	props: CreateLabelClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Create Label Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Created Plugin' track call.
 *
 * @param {CreatedPlugin} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function createdPlugin(
	props?: CreatedPlugin,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Created Plugin',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Credit Card Added' track call.
 *
 * @param {CreditCardAdded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function creditCardAdded(
	props?: CreditCardAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Credit Card Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Credit Card Edit Clicked' track call.
 *
 * @param {CreditCardEditClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function creditCardEditClicked(
	props?: CreditCardEditClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Credit Card Edit Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Credit Card Errored' track call.
 *
 * @param {CreditCardErrored} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function creditCardErrored(
	props?: CreditCardErrored,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Credit Card Errored',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Debugger Call Clicked' track call.
 *
 * @param {DebuggerCallClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function debuggerCallClicked(
	props: DebuggerCallClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Debugger Call Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Debugger Paused' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function debuggerPaused(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Debugger Paused',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Debugger Resumed' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function debuggerResumed(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Debugger Resumed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Debugger Searched' track call.
 *
 * @param {DebuggerSearched} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function debuggerSearched(
	props: DebuggerSearched,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Debugger Searched',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Demo Requested' track call.
 *
 * @param {DemoRequested} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function demoRequested(
	props?: DemoRequested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Demo Requested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Authorize Clicked' track call.
 *
 * @param {DestinationAuthorizeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationAuthorizeClicked(
	props: DestinationAuthorizeClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Authorize Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Authorize Failed' track call.
 *
 * @param {DestinationAuthorizeFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationAuthorizeFailed(
	props: DestinationAuthorizeFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Authorize Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Destination authorized successfully
 *
 * @param {DestinationAuthorized} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationAuthorized(
	props: DestinationAuthorized,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Authorized',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user saves a setting in a Destination.
 *
 * @param {DestinationCredentialsAdded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationCredentialsAdded(
	props?: DestinationCredentialsAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Credentials Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Deliverability Period Updated' track call.
 *
 * @param {DestinationDeliverabilityPeriodUpdated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationDeliverabilityPeriodUpdated(
	props?: DestinationDeliverabilityPeriodUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Deliverability Period Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Deliverability Viewed' track call.
 *
 * @param {DestinationDeliverabilityViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationDeliverabilityViewed(
	props?: DestinationDeliverabilityViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Deliverability Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Error Payload Copied' track call.
 *
 * @param {DestinationErrorPayloadCopied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationErrorPayloadCopied(
	props: DestinationErrorPayloadCopied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Error Payload Copied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Error Payload Tab Changed' track call.
 *
 * @param {DestinationErrorPayloadTabChanged} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationErrorPayloadTabChanged(
	props?: DestinationErrorPayloadTabChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Error Payload Tab Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Error Viewed' track call.
 *
 * @param {DestinationErrorViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationErrorViewed(
	props?: DestinationErrorViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Error Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Feedback Submitted' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFeedbackSubmitted(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Feedback Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User created a Destination Filter in the Destination Filters UI.
 *
 * @param {DestinationFilterCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFilterCreated(
	props: DestinationFilterCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filter Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User deleted a filter in the Destination Filters UI.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFilterDeleted(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filter Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * A user has filled out our feedback form on Routing UI
 *
 * @param {DestinationFilterFeedbackSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFilterFeedbackSubmitted(
	props: DestinationFilterFeedbackSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filter Feedback Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User reached the “Configure Rules” step of the Destination Filter wizard. This means they clicked on the “New Filter” button, and also clicked “Accept” on the “Public Beta” agreement dialog.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFiltersConfigureRulesStepReached(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filters Configure Rules Step Reached',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User tested an event against an FQL condition in the Destination Filters UI.
 *
 * @param {DestinationFiltersFqlTested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFiltersFqlTested(
	props: DestinationFiltersFqlTested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filters FQL Tested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User viewed “home” page for Destination Filters UI.
 *
 * @param {DestinationFiltersListViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFiltersListViewed(
	props: DestinationFiltersListViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filters List Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User reached the “Name and Save” step of the Destination Filter wizard.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFiltersNameAndSaveStepReached(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filters Name and Save Step Reached',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User (without Destination Filters access) clicked on the “Upgrade to Business Tier” button in the Destination Filters UI.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationFiltersUpgradeButtonClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Filters Upgrade Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Overview Period Updated' track call.
 *
 * @param {DestinationOverviewPeriodUpdated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationOverviewPeriodUpdated(
	props?: DestinationOverviewPeriodUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Overview Period Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Overview Searched' track call.
 *
 * @param {DestinationOverviewSearched} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationOverviewSearched(
	props?: DestinationOverviewSearched,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Overview Searched',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Overview Viewed' track call.
 *
 * @param {DestinationOverviewViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationOverviewViewed(
	props?: DestinationOverviewViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Overview Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Simulator Builder Type' track call.
 *
 * @param {DestinationSimulatorBuilderType} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationSimulatorBuilderType(
	props?: DestinationSimulatorBuilderType,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Simulator Builder Type',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Simulator Dismissed Source Debugger Dialog' track call.
 *
 * @param {DestinationSimulatorDismissedSourceDebuggerDialog} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationSimulatorDismissedSourceDebuggerDialog(
	props?: DestinationSimulatorDismissedSourceDebuggerDialog,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Simulator Dismissed Source Debugger Dialog',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Simulator Event Payload Copied' track call.
 *
 * @param {DestinationSimulatorEventPayloadCopied} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationSimulatorEventPayloadCopied(
	props?: DestinationSimulatorEventPayloadCopied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Simulator Event Payload Copied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Simulator Event Sent' track call.
 *
 * @param {DestinationSimulatorEventSent} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationSimulatorEventSent(
	props?: DestinationSimulatorEventSent,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Simulator Event Sent',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Simulator Navigated From Source Debugger' track call.
 *
 * @param {DestinationSimulatorNavigatedFromSourceDebugger} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationSimulatorNavigatedFromSourceDebugger(
	props?: DestinationSimulatorNavigatedFromSourceDebugger,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Simulator Navigated From Source Debugger',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Destination Simulator Result View Toggled' track call.
 *
 * @param {DestinationSimulatorResultViewToggled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationSimulatorResultViewToggled(
	props?: DestinationSimulatorResultViewToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destination Simulator Result View Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when customer reverts back to old settings version in a destination
 *
 * @param {DestinationsSettingsReverted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function destinationsSettingsReverted(
	props?: DestinationsSettingsReverted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Destinations Settings Reverted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Disable Tagger Clicked' track call.
 *
 * @param {DisableTaggerClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function disableTaggerClicked(
	props?: DisableTaggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Disable Tagger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a user clicks on a link to view our docs.
 *
 * @param {DocsLinkClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function docsLinkClicked(
	props: DocsLinkClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Docs Link Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user clicks to edit a tracking plan from the readonly view.
 *
 * @param {EditTrackingPlanClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function editTrackingPlanClicked(
	props: EditTrackingPlanClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Edit Tracking Plan Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User clicks on the dropdown that expands the elements tree
 *
 * @param {ElementsTreeDropdownClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function elementsTreeDropdownClicked(
	props?: ElementsTreeDropdownClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Elements Tree Dropdown Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User clicks on one of the elements in the elements tree
 *
 * @param {ElementsTreeElementClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function elementsTreeElementClicked(
	props?: ElementsTreeElementClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Elements Tree Element Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Email Captured' track call.
 *
 * @param {EmailCaptured} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailCaptured(
	props?: EmailCaptured,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Email Captured',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Email Delivered' track call.
 *
 * @param {EmailDelivered} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailDelivered(
	props?: EmailDelivered,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Email Delivered',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Enable Destination"
 *
 * @param {EnableDestinationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enableDestinationClicked(
	props: EnableDestinationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Enable Destination Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Enable Flow Started' track call.
 *
 * @param {EnableFlowStarted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enableFlowStarted(
	props?: EnableFlowStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Enable Flow Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Enable Tagger Clicked' track call.
 *
 * @param {EnableTaggerClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enableTaggerClicked(
	props?: EnableTaggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Enable Tagger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Enforcement Notification Clicked' track call.
 *
 * @param {EnforcementNotificationClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enforcementNotificationClicked(
	props?: EnforcementNotificationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Enforcement Notification Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Enforcement Notification Shown' track call.
 *
 * @param {EnforcementNotificationShown} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enforcementNotificationShown(
	props?: EnforcementNotificationShown,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Enforcement Notification Shown',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user changes the enforcement settings for a source
 *
 * @param {EnforcementSettingsChanged} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function enforcementSettingsChanged(
	props?: EnforcementSettingsChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Enforcement Settings Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Write key was not found on customer's page
 *
 * @param {ErrorWritekeyNotFound} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function errorWritekeyNotFound(
	props?: ErrorWritekeyNotFound,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Error - Writekey Not Found',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Write key didn't match any of the users' sources.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function errorWritekeyNotMatching(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Error - Writekey Not Matching',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Error Summary Toggled' track call.
 *
 * @param {ErrorSummaryToggled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function errorSummaryToggled(
	props?: ErrorSummaryToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Error Summary Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Event Disabled' track call.
 *
 * @param {EventDisabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventDisabled(
	props?: EventDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User edits an existing event and clicks "Save"
 *
 * @param {EventEdited} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventEdited(
	props?: EventEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Event Enabled' track call.
 *
 * @param {EventEnabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventEnabled(
	props?: EventEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user infers an event from the schema to a Tracking Plan
 *
 * @param {EventInferred} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventInferred(
	props: EventInferred,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Inferred',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user edits label(s) associated with a tracking plan event. Fire for separate track call for each amended event on TP save.
 *
 * @param {EventLabelsEdited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventLabelsEdited(
	props: EventLabelsEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Labels Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer clicks the Event Stream Tab in the Visual Tagger
 *
 * @param {EventStreamTabClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventStreamTabClicked(
	props?: EventStreamTabClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Stream Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Event Tagger Clicked' track call.
 *
 * @param {EventTaggerClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function eventTaggerClicked(
	props?: EventTaggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Event Tagger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer opens the Visual Tagger
 *
 * @param {ExtensionActivated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function extensionActivated(
	props?: ExtensionActivated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Extension Activated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer first installs the Visual Tagger
 *
 * @param {ExtensionInstalled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function extensionInstalled(
	props?: ExtensionInstalled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Extension Installed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user logs into extension
 *
 * @param {ExtensionLogin} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function extensionLogin(
	props?: ExtensionLogin,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Extension Login',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer uninstalls the Visual Tagger
 *
 * @param {ExtensionUninstalled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function extensionUninstalled(
	props?: ExtensionUninstalled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Extension Uninstalled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Feature Requested' track call.
 *
 * @param {FeatureRequested} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function featureRequested(
	props?: FeatureRequested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Feature Requested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Generic user submitted feedback
 *
 * @param {FeedbackSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function feedbackSubmitted(
	props: FeedbackSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Feedback Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user applies a filter within protocols views
 *
 * @param {FilterApplied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filterApplied(
	props: FilterApplied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Filter Applied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user changes the environment filter on the sources list page
 *
 * @param {FilterByEnvironmentSelectboxChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function filterByEnvironmentSelectboxChanged(
	props: FilterByEnvironmentSelectboxChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Filter By Environment Selectbox Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * First contentful paint in our app for real users.
 *
 * @param {FirstContentfulPaint} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function firstContentfulPaint(
	props: FirstContentfulPaint,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'First Contentful Paint',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * First input delay of real users.
 *
 * @param {FirstInputDelay} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function firstInputDelay(
	props: FirstInputDelay,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'First Input Delay',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * First paint in our app for real users.
 *
 * @param {FirstPaint} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function firstPaint(
	props: FirstPaint,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'First Paint',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Flow Completed (Appcues)' track call.
 *
 * @param {FlowCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowCompletedAppcues(
	props?: FlowCompletedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Flow Completed (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Flow Skipped (Appcues)' track call.
 *
 * @param {FlowSkippedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowSkippedAppcues(
	props?: FlowSkippedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Flow Skipped (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Flow Started (Appcues)' track call.
 *
 * @param {FlowStartedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowStartedAppcues(
	props?: FlowStartedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Flow Started (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Form Failed' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function formFailed(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Form Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Form Submitted' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function formSubmitted(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Form Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user changes the forwarding settings for blocked events or meta notifications
 *
 * @param {ForwardingSettingsChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function forwardingSettingsChanged(
	props: ForwardingSettingsChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Forwarding Settings Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Found Writekey Match' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function foundWritekeyMatch(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Found Writekey Match',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a function is attached to a source by a customer or internal team member. Specific to Source Functions.
 *
 * @param {FunctionAttachedToSource} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function functionAttachedToSource(
	props?: FunctionAttachedToSource,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Function Attached To Source',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'GDPR Beta Requested' track call.
 *
 * @param {GdprBetaRequested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function gdprBetaRequested(
	props: GdprBetaRequested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'GDPR Beta Requested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user views a product gate page
 *
 * @param {GateViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function gateViewed(
	props?: GateViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Gate Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'GraphQL Error' track call.
 *
 * @param {GraphQlError} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function graphQlError(
	props: GraphQlError,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'GraphQL Error',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a blocked value has been added
 *
 * @param {IdentityResolutionBlockedValueUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionBlockedValueUpdated(
	props: IdentityResolutionBlockedValueUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Blocked Value Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user toggled the Read/Edit state toggle
 *
 * @param {IdentityResolutionEditStateEnabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionEditStateEnabled(
	props: IdentityResolutionEditStateEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Edit State Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a new identifier has been created
 *
 * @param {IdentityResolutionIdentifierCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionIdentifierCreated(
	props: IdentityResolutionIdentifierCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Identifier Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user clicks "Upgrade Behavior"
 *
 * @param {IdentityResolutionLimitBehaviorUpgraded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionLimitBehaviorUpgraded(
	props: IdentityResolutionLimitBehaviorUpgraded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Limit Behavior Upgraded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when the cardinality limit has been added
 *
 * @param {IdentityResolutionLimitUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionLimitUpdated(
	props: IdentityResolutionLimitUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Limit Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when the identity resolution page is opened
 *
 * @param {IdentityResolutionPageClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionPageClicked(
	props: IdentityResolutionPageClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Page Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a setting has been changed
 *
 * @param {IdentityResolutionPriorityUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function identityResolutionPriorityUpdated(
	props: IdentityResolutionPriorityUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Identity Resolution Priority Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Incident Contacts Changed' track call.
 *
 * @param {IncidentContactsChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function incidentContactsChanged(
	props: IncidentContactsChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Incident Contacts Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Incident Contacts Saved' track call.
 *
 * @param {IncidentContactsSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function incidentContactsSaved(
	props: IncidentContactsSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Incident Contacts Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Incident Contacts Warning Dialog Canceled' track call.
 *
 * @param {IncidentContactsWarningDialogCanceled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function incidentContactsWarningDialogCanceled(
	props: IncidentContactsWarningDialogCanceled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Incident Contacts Warning Dialog Canceled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Incident Contacts Warning Dialog Confirmed' track call.
 *
 * @param {IncidentContactsWarningDialogConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function incidentContactsWarningDialogConfirmed(
	props: IncidentContactsWarningDialogConfirmed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Incident Contacts Warning Dialog Confirmed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Incident Contacts Warning Dialog Displayed' track call.
 *
 * @param {IncidentContactsWarningDialogDisplayed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function incidentContactsWarningDialogDisplayed(
	props: IncidentContactsWarningDialogDisplayed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Incident Contacts Warning Dialog Displayed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Integration Disabled' track call.
 *
 * @param {IntegrationDisabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function integrationDisabled(
	props: IntegrationDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Integration Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Integration Enabled' track call.
 *
 * @param {IntegrationEnabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function integrationEnabled(
	props: IntegrationEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Integration Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when enable with segment is used (used to be only for webhooks or s3, which should never happen). Now indicates a partner has not moved off the legacy enable flow to the new enable with OAuth.
 *
 * @param {InvalidDestinationEnableAttempted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function invalidDestinationEnableAttempted(
	props: InvalidDestinationEnableAttempted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Invalid Destination Enable Attempted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Invalid JSON' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function invalidJson(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Invalid JSON',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Invalid SEO Title' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function invalidSeoTitle(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Invalid SEO Title',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user downloads a CSV report of their Inventory
 *
 * @param {InventoryCsvDownloaded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function inventoryCsvDownloaded(
	props: InventoryCsvDownloaded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Inventory CSV Downloaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user clicks into a row and expands the sidesheet
 *
 * @param {InventorySidesheetViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function inventorySidesheetViewed(
	props?: InventorySidesheetViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Inventory Sidesheet Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user download's the CSV from the sidesheet
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function inventoryVolumeCsvDownloaded(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Inventory Volume CSV Downloaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Investor Program Handshake Made' track call.
 *
 * @param {InvestorProgramHandshakeMade} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function investorProgramHandshakeMade(
	props?: InvestorProgramHandshakeMade,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Investor Program Handshake Made',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks the Invite a Teammate link on the Workspace Home
 *
 * @param {InviteATeammateClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function inviteATeammateClicked(
	props: InviteATeammateClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Invite A Teammate Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Invoice History Tab Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function invoiceHistoryTabClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Invoice History Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user manually edits the JSON schema in a tracking plan
 *
 * @param {JsonSchemaEdited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function jsonSchemaEdited(
	props: JsonSchemaEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'JSON Schema Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'JavaScript Error' track call.
 *
 * @param {JavaScriptError} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function javaScriptError(
	props?: JavaScriptError,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'JavaScript Error',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Job CTA Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function jobCtaClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Job CTA Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user selects an environment on the bulk assign environments UI
 *
 * @param {LabelAsEnvironmentDropdownSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelAsEnvironmentDropdownSelected(
	props: LabelAsEnvironmentDropdownSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label As Environment Dropdown Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user is assigned permissions by labels
 *
 * @param {LabelAssignedToPermissions} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelAssignedToPermissions(
	props: LabelAssignedToPermissions,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label Assigned To Permissions',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user tries to create a label and is successful
 *
 * @param {LabelCreationSuccessful} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelCreationSuccessful(
	props: LabelCreationSuccessful,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label Creation Successful',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user tries to create a label and is unsuccessful
 *
 * @param {LabelCreationUnsuccessful} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelCreationUnsuccessful(
	props: LabelCreationUnsuccessful,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label Creation Unsuccessful',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user clicks "save changes" on the assign labels tab
 *
 * @param {LabelResourcesSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelResourcesSaved(
	props: LabelResourcesSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label Resources Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * clicked on the Labels page in Workspace Settings
 *
 * @param {LabelTabClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelTabClicked(
	props: LabelTabClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when environments are assigned to permissions
 *
 * @param {LabelAssignedToPermission} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelAssignedToPermission(
	props: LabelAssignedToPermission,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label assigned to permission',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "Label your sources" button on the sources list page
 *
 * @param {LabelYourSourcesButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labelYourSourcesButtonClicked(
	props: LabelYourSourcesButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Label your sources Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user accepts feature terms of service
 *
 * @param {LabsFeatureTermsAccepted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function labsFeatureTermsAccepted(
	props: LabsFeatureTermsAccepted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Labs Feature Terms Accepted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Lead Captured' track call.
 *
 * @param {LeadCaptured} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function leadCaptured(
	props: LeadCaptured,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Lead Captured',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user imports items from a Library into a Tracking Plan
 *
 * @param {LibraryItemsImported} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function libraryItemsImported(
	props: LibraryItemsImported,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Library Items Imported',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer turns on/off storing anon ids in local storage as well as a cookie
 *
 * @param {LocalStorageToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function localStorageToggled(
	props: LocalStorageToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Local Storage Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Lockout Modal Shown' track call.
 *
 * @param {LockoutModalShown} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function lockoutModalShown(
	props?: LockoutModalShown,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Lockout Modal Shown',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'MFA Verification Failure' track call.
 *
 * @param {MfaVerificationFailure} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mfaVerificationFailure(
	props?: MfaVerificationFailure,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'MFA Verification Failure',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event triggered when the user clicks the CTA on the MFA dialog on the MFA security checkup page
 *
 * @param {MfaCtaClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mfaCtaClicked(
	props: MfaCtaClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Mfa Cta Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event triggered when the user closes the mfa cta sidesheet on the MFA security checkup page
 *
 * @param {MfaCtaDismissed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mfaCtaDismissed(
	props: MfaCtaDismissed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Mfa Cta Dismissed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event triggered when the user clicks the CTA on the MFA dialog on the MFA security checkup page
 *
 * @param {MfaCtaSidesheetClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mfaCtaSidesheetClosed(
	props: MfaCtaSidesheetClosed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Mfa Cta Sidesheet Closed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User clicks through a Omnisearch search result
 *
 * @param {NavSearchResultClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function navSearchResultClicked(
	props?: NavSearchResultClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Nav Search Result Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User enters a string into Omnisearch search bar but no results that match the query are found.
 *
 * @param {NavSearchResultsEmpty} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function navSearchResultsEmpty(
	props?: NavSearchResultsEmpty,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Nav Search Results Empty',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User enters a query into Omnisearch search bar. Debounced.
 *
 * @param {NavSearchTermEntered} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function navSearchTermEntered(
	props?: NavSearchTermEntered,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Nav Search Term Entered',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Navigate Clicked' track call.
 *
 * @param {NavigateClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function navigateClicked(
	props?: NavigateClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Navigate Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Network Error' track call.
 *
 * @param {NetworkError} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function networkError(
	props?: NetworkError,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Network Error',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'New Password Strength' track call.
 *
 * @param {NewPasswordStrength} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function newPasswordStrength(
	props?: NewPasswordStrength,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'New Password Strength',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user clicks button to create new transformation
 *
 * @param {NewTransformationClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function newTransformationClicked(
	props?: NewTransformationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'New Transformation Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Notification Banner Clicked' track call.
 *
 * @param {NotificationBannerClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationBannerClicked(
	props?: NotificationBannerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notification Banner Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Notification Banner Shown' track call.
 *
 * @param {NotificationBannerShown} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationBannerShown(
	props?: NotificationBannerShown,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notification Banner Shown',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Notification Center Load More Clicked' track call.
 *
 * @param {NotificationCenterLoadMoreClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationCenterLoadMoreClicked(
	props: NotificationCenterLoadMoreClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notification Center Load More Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Notification Center Opened' track call.
 *
 * @param {NotificationCenterOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationCenterOpened(
	props: NotificationCenterOpened,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notification Center Opened',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Notification Clicked' track call.
 *
 * @param {NotificationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationClicked(
	props: NotificationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notification Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Notification Recipients Saved' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationRecipientsSaved(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notification Recipients Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when a user expands a category in the notification settings page
 *
 * @param {NotificationsSettingsCategoryClick} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationsSettingsCategoryClick(
	props: NotificationsSettingsCategoryClick,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notifications Settings Category Click',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when a user changes the current view of notification period
 *
 * @param {NotificationsSettingsChanged} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationsSettingsChanged(
	props?: NotificationsSettingsChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notifications Settings Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when a user clicks a category in the sidesheet on the notification settings page
 *
 * @param {NotificationsSettingsSidesheetCustomCategoryClick} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationsSettingsSidesheetCustomCategoryClick(
	props: NotificationsSettingsSidesheetCustomCategoryClick,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notifications Settings Sidesheet Custom Category Click',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when a user clicks in a navigate link in a category in the sidesheet on the notification settings page
 *
 * @param {NotificationsSettingsSidesheetLinkClick} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationsSettingsSidesheetLinkClick(
	props: NotificationsSettingsSidesheetLinkClick,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notifications Settings Sidesheet Link Click',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when a user clicks a category in the sidesheet on the notification settings page
 *
 * @param {NotificationsSettingsSidesheetOpenClick} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationsSettingsSidesheetOpenClick(
	props: NotificationsSettingsSidesheetOpenClick,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notifications Settings Sidesheet Open Click',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when a user interacts with the delivery alert slider
 *
 * @param {NotificationsSettingsSliderInteraction} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationsSettingsSliderInteraction(
	props: NotificationsSettingsSliderInteraction,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Notifications Settings Slider Interaction',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User allowed OAuth consent in app
 *
 * @param {OAuthConsentAllowClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oAuthConsentAllowClicked(
	props: OAuthConsentAllowClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'OAuth Consent Allow Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User did not allow OAuth consent, and instead logged out
 *
 * @param {OAuthConsentLogoutClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oAuthConsentLogoutClicked(
	props: OAuthConsentLogoutClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'OAuth Consent Logout Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User viewed OAuth consent page in app
 *
 * @param {OAuthConsentPageViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oAuthConsentPageViewed(
	props: OAuthConsentPageViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'OAuth Consent Page Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User started an OAuth consent from enable or other app auth flow
 *
 * @param {OAuthConsentStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oAuthConsentStarted(
	props: OAuthConsentStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'OAuth Consent Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user confirms creation and configuration of integrations results returned by Snoop Lion
 *
 * @param {OneClickDestinationsIntegrationsConfigured} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oneClickDestinationsIntegrationsConfigured(
	props: OneClickDestinationsIntegrationsConfigured,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'One Click Destinations Integrations Configured',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a Snoop Lion job triggered by One-Click Destinations opt-in is completed
 *
 * @param {OneClickDestinationsJobCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oneClickDestinationsJobCompleted(
	props: OneClickDestinationsJobCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'One Click Destinations Job Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user opts into using One-Click Destinations by clicking "Search" with a valid URL
 *
 * @param {OneClickDestinationsSearchOptedIn} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function oneClickDestinationsSearchOptedIn(
	props: OneClickDestinationsSearchOptedIn,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'One Click Destinations Search Opted In',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when analytics.page calls are potentially duplicated on a particular url in the app.
 *
 * @param {PageCallDuplicated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageCallDuplicated(
	props?: PageCallDuplicated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Page Call Duplicated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Page Viewed' track call.
 *
 * @param {PageViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageViewed(
	props: PageViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Page Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Password Changed' track call.
 *
 * @param {PasswordChanged} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function passwordChanged(
	props?: PasswordChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Password Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Password Submitted' track call.
 *
 * @param {PasswordSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function passwordSubmitted(
	props?: PasswordSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Password Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Created' track call.
 *
 * @param {PersonasAudienceCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceCreated(
	props: PersonasAudienceCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Deleted' track call.
 *
 * @param {PersonasAudienceDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceDeleted(
	props: PersonasAudienceDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Destination Added' track call.
 *
 * @param {PersonasAudienceDestinationAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceDestinationAdded(
	props: PersonasAudienceDestinationAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Destination Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Destination Removed' track call.
 *
 * @param {PersonasAudienceDestinationRemoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceDestinationRemoved(
	props?: PersonasAudienceDestinationRemoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Destination Removed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Destination Updated' track call.
 *
 * @param {PersonasAudienceDestinationUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceDestinationUpdated(
	props: PersonasAudienceDestinationUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Destination Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Disabled' track call.
 *
 * @param {PersonasAudienceDisabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceDisabled(
	props: PersonasAudienceDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Insights Viewed' track call.
 *
 * @param {PersonasAudienceInsightsViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceInsightsViewed(
	props: PersonasAudienceInsightsViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Insights Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Overlap Failed' track call.
 *
 * @param {PersonasAudienceOverlapFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceOverlapFailed(
	props: PersonasAudienceOverlapFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Overlap Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Overlap Succeeded' track call.
 *
 * @param {PersonasAudienceOverlapSucceeded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceOverlapSucceeded(
	props: PersonasAudienceOverlapSucceeded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Overlap Succeeded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Preview Failed' track call.
 *
 * @param {PersonasAudiencePreviewFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudiencePreviewFailed(
	props: PersonasAudiencePreviewFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Preview Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Preview Succeeded' track call.
 *
 * @param {PersonasAudiencePreviewSucceeded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudiencePreviewSucceeded(
	props: PersonasAudiencePreviewSucceeded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Preview Succeeded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Run Failed' track call.
 *
 * @param {PersonasAudienceRunFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceRunFailed(
	props?: PersonasAudienceRunFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Run Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Template Requested' track call.
 *
 * @param {PersonasAudienceTemplateRequested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceTemplateRequested(
	props: PersonasAudienceTemplateRequested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Template Requested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Template Viewed' track call.
 *
 * @param {PersonasAudienceTemplateViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceTemplateViewed(
	props?: PersonasAudienceTemplateViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Template Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Templates Viewed' track call.
 *
 * @param {PersonasAudienceTemplatesViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceTemplatesViewed(
	props?: PersonasAudienceTemplatesViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Templates Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Audience Updated' track call.
 *
 * @param {PersonasAudienceUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasAudienceUpdated(
	props: PersonasAudienceUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Audience Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Clicked Connect Destination' track call.
 *
 * @param {PersonasClickedConnectDestination} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasClickedConnectDestination(
	props: PersonasClickedConnectDestination,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Clicked Connect Destination',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Clicked Setup Destination' track call.
 *
 * @param {PersonasClickedSetupDestination} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasClickedSetupDestination(
	props: PersonasClickedSetupDestination,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Clicked Setup Destination',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Computation Sidesheet Viewed' track call.
 *
 * @param {PersonasComputationSidesheetViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasComputationSidesheetViewed(
	props: PersonasComputationSidesheetViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Computation Sidesheet Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Connected Destinations' track call.
 *
 * @param {PersonasConnectedDestinations} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasConnectedDestinations(
	props: PersonasConnectedDestinations,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Connected Destinations',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Contact About Trial' track call.
 *
 * @param {PersonasContactAboutTrial} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasContactAboutTrial(
	props?: PersonasContactAboutTrial,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Contact About Trial',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Enabled' track call.
 *
 * @param {PersonasEnabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasEnabled(
	props: PersonasEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Explorer Searched' track call.
 *
 * @param {PersonasExplorerSearched} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasExplorerSearched(
	props: PersonasExplorerSearched,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Explorer Searched',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Generated Access Token' track call.
 *
 * @param {PersonasGeneratedAccessToken} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasGeneratedAccessToken(
	props: PersonasGeneratedAccessToken,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Generated Access Token',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User completed a step in Personas onboarding tour
 *
 * @param {PersonasOnboardingTourStepCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasOnboardingTourStepCompleted(
	props: PersonasOnboardingTourStepCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Onboarding Tour Step Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Profile Events Loaded More' track call.
 *
 * @param {PersonasProfileEventsLoadedMore} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasProfileEventsLoadedMore(
	props: PersonasProfileEventsLoadedMore,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Profile Events Loaded More',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Profile Tab Viewed' track call.
 *
 * @param {PersonasProfileTabViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasProfileTabViewed(
	props: PersonasProfileTabViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Profile Tab Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Profile Viewed' track call.
 *
 * @param {PersonasProfileViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasProfileViewed(
	props: PersonasProfileViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Profile Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Space Created' track call.
 *
 * @param {PersonasSpaceCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasSpaceCreated(
	props: PersonasSpaceCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Space Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user edits the label on an individual space
 *
 * @param {PersonasSpaceLabelEdited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasSpaceLabelEdited(
	props: PersonasSpaceLabelEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Space Label Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Space Renamed' track call.
 *
 * @param {PersonasSpaceRenamed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasSpaceRenamed(
	props: PersonasSpaceRenamed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Space Renamed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Space Switched' track call.
 *
 * @param {PersonasSpaceSwitched} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasSpaceSwitched(
	props: PersonasSpaceSwitched,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Space Switched',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Spaces Settings Viewed' track call.
 *
 * @param {PersonasSpacesSettingsViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasSpacesSettingsViewed(
	props: PersonasSpacesSettingsViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Spaces Settings Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Spaces Viewed' track call.
 *
 * @param {PersonasSpacesViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasSpacesViewed(
	props: PersonasSpacesViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Spaces Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Toggled Import Destination' track call.
 *
 * @param {PersonasToggledImportDestination} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasToggledImportDestination(
	props: PersonasToggledImportDestination,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Toggled Import Destination',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Created' track call.
 *
 * @param {PersonasTraitCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitCreated(
	props: PersonasTraitCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Deleted' track call.
 *
 * @param {PersonasTraitDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitDeleted(
	props: PersonasTraitDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Destination Added' track call.
 *
 * @param {PersonasTraitDestinationAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitDestinationAdded(
	props: PersonasTraitDestinationAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Destination Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Destination Removed' track call.
 *
 * @param {PersonasTraitDestinationRemoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitDestinationRemoved(
	props?: PersonasTraitDestinationRemoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Destination Removed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Destination Updated' track call.
 *
 * @param {PersonasTraitDestinationUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitDestinationUpdated(
	props: PersonasTraitDestinationUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Destination Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Disabled' track call.
 *
 * @param {PersonasTraitDisabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitDisabled(
	props: PersonasTraitDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Preview Clicked' track call.
 *
 * @param {PersonasTraitPreviewClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitPreviewClicked(
	props: PersonasTraitPreviewClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Preview Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Preview Failed' track call.
 *
 * @param {PersonasTraitPreviewFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitPreviewFailed(
	props: PersonasTraitPreviewFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Preview Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Preview Succeeded' track call.
 *
 * @param {PersonasTraitPreviewSucceeded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitPreviewSucceeded(
	props: PersonasTraitPreviewSucceeded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Preview Succeeded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Run Failed' track call.
 *
 * @param {PersonasTraitRunFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitRunFailed(
	props?: PersonasTraitRunFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Run Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Trait Updated' track call.
 *
 * @param {PersonasTraitUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasTraitUpdated(
	props: PersonasTraitUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Trait Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Viewed API Access' track call.
 *
 * @param {PersonasViewedApiAccess} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasViewedApiAccess(
	props?: PersonasViewedApiAccess,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Viewed API Access',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Personas Viewed Destinations' track call.
 *
 * @param {PersonasViewedDestinations} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function personasViewedDestinations(
	props?: PersonasViewedDestinations,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Personas Viewed Destinations',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Plans Tab Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function plansTabClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Plans Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Plugin Disabled' track call.
 *
 * @param {PluginDisabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pluginDisabled(
	props?: PluginDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Plugin Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Plugin Enabled' track call.
 *
 * @param {PluginEnabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pluginEnabled(
	props?: PluginEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Plugin Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user enables forwarding net new properties into an alert channel (Metasource or Slack)
 *
 * @param {PrivacyAlertsEnabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function privacyAlertsEnabled(
	props: PrivacyAlertsEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Privacy Alerts Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user applies a privacy control in Settings > Controls
 *
 * @param {PrivacyControlApplied} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function privacyControlApplied(
	props?: PrivacyControlApplied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Privacy Control Applied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer requests access to the Privacy Portal
 *
 * @param {PrivacyDemoRequested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function privacyDemoRequested(
	props: PrivacyDemoRequested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Privacy Demo Requested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Quick Start Additional Integrations Selected' track call.
 *
 * @param {QuickStartAdditionalIntegrationsSelected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartAdditionalIntegrationsSelected(
	props?: QuickStartAdditionalIntegrationsSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Additional Integrations Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user has filled in all credentials during destination credentials step of flow.
 *
 * @param {QuickStartCredentialsAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartCredentialsAdded(
	props: QuickStartCredentialsAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Credentials Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user chooses to skip adding credentials
 *
 * @param {QuickStartCredentialsSkipped} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartCredentialsSkipped(
	props: QuickStartCredentialsSkipped,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Credentials Skipped',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user selects destination
 *
 * @param {QuickStartDestinationSelected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartDestinationSelected(
	props?: QuickStartDestinationSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Destination Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user clicks "Go to workspace" in final step
 *
 * @param {QuickStartFinishedButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartFinishedButtonClicked(
	props?: QuickStartFinishedButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Finished Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User exits the Quick Start welcome flow for new workspaces at any point in the Quick Start flow
 *
 * @param {QuickStartFlowExited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartFlowExited(
	props: QuickStartFlowExited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Flow Exited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user clicks next through flow ("next" between steps)
 *
 * @param {QuickStartNextButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartNextButtonClicked(
	props?: QuickStartNextButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Next Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user begins the Quick Start flow by choosing a Quick Start path. Why: so we know which path they chose and that they decided to begin. Location: first screen of flow.
 *
 * @param {QuickStartPathSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartPathSelected(
	props: QuickStartPathSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Path Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user clicks previous through flow
 *
 * @param {QuickStartPreviousButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartPreviousButtonClicked(
	props?: QuickStartPreviousButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Previous Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User selects Source during Source selection step of flow. Why: so we kow which source they selected
 *
 * @param {QuickStartSourceSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quickStartSourceSelected(
	props: QuickStartSourceSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Quick Start Source Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'RSS Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function rssClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'RSS Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Enable used on a destination that's already enabled. This should rarely happen.
 *
 * @param {RedundantDestinationEnableAttempted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function redundantDestinationEnableAttempted(
	props: RedundantDestinationEnableAttempted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Redundant Destination Enable Attempted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Reset Password' track call.
 *
 * @param {ResetPassword} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function resetPassword(
	props?: ResetPassword,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Reset Password',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When the customer turns on/off Analytics.js retries the event is triggered.
 *
 * @param {RetriesToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function retriesToggled(
	props: RetriesToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Retries Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Run History Viewed' track call.
 *
 * @param {RunHistoryViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function runHistoryViewed(
	props?: RunHistoryViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Run History Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Connection Created' track call.
 *
 * @param {SsoConnectionCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoConnectionCreated(
	props: SsoConnectionCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Connection Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Connection Default Changed' track call.
 *
 * @param {SsoConnectionDefaultChanged} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoConnectionDefaultChanged(
	props?: SsoConnectionDefaultChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Connection Default Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Connection Deleted' track call.
 *
 * @param {SsoConnectionDeleted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoConnectionDeleted(
	props?: SsoConnectionDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Connection Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Connection Toggled' track call.
 *
 * @param {SsoConnectionToggled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoConnectionToggled(
	props?: SsoConnectionToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Connection Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Connection Updated' track call.
 *
 * @param {SsoConnectionUpdated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoConnectionUpdated(
	props?: SsoConnectionUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Connection Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Domain Added' track call.
 *
 * @param {SsoDomainAdded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoDomainAdded(
	props?: SsoDomainAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Domain Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Domain Removed' track call.
 *
 * @param {SsoDomainRemoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoDomainRemoved(
	props?: SsoDomainRemoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Domain Removed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Domain Verified' track call.
 *
 * @param {SsoDomainVerified} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoDomainVerified(
	props?: SsoDomainVerified,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'SSO Domain Verified',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'SSO Forced' track call.
 *
 * @param {SsoForced} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ssoForced(
	props: SsoForced,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('SSO Forced', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * Fired when user clicks the "Save" button on the bulk assign environments dialog
 *
 * @param {SaveButtonBulkAssignEnvironmentsClick} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function saveButtonBulkAssignEnvironmentsClick(
	props: SaveButtonBulkAssignEnvironmentsClick,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Save button bulk assign environments click',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Scheduled Vacuuming Disabled' track call.
 *
 * @param {ScheduledVacuumingDisabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function scheduledVacuumingDisabled(
	props?: ScheduledVacuumingDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Scheduled Vacuuming Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Scheduled Vacuuming Enabled' track call.
 *
 * @param {ScheduledVacuumingEnabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function scheduledVacuumingEnabled(
	props?: ScheduledVacuumingEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Scheduled Vacuuming Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Scheduled Vacuuming Updated' track call.
 *
 * @param {ScheduledVacuumingUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function scheduledVacuumingUpdated(
	props: ScheduledVacuumingUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Scheduled Vacuuming Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Schema Default Toggle' track call.
 *
 * @param {SchemaDefaultToggle} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function schemaDefaultToggle(
	props: SchemaDefaultToggle,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Schema Default Toggle',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a user clicks "contact us" on the Source Schema page, in regards to enabling Schema Defaults on their account.
 *
 * @param {SchemaDefaultsRequested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function schemaDefaultsRequested(
	props: SchemaDefaultsRequested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Schema Defaults Requested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Schema Destination Toggle' track call.
 *
 * @param {SchemaDestinationToggle} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function schemaDestinationToggle(
	props?: SchemaDestinationToggle,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Schema Destination Toggle',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Schema Event Properties Conditional Save' track call.
 *
 * @param {SchemaEventPropertiesConditionalSave} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function schemaEventPropertiesConditionalSave(
	props?: SchemaEventPropertiesConditionalSave,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Schema Event Properties Conditional Save',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Schema Toggle' track call.
 *
 * @param {SchemaToggle} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function schemaToggle(
	props?: SchemaToggle,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Schema Toggle',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user sets permissions on source admin by environment
 *
 * @param {SetEnvPermissionsOnSourceAdmin} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function setEnvPermissionsOnSourceAdmin(
	props: SetEnvPermissionsOnSourceAdmin,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Set Env Permissions On Source Admin',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Set Env Permissions On Source Read Only' track call.
 *
 * @param {SetEnvPermissionsOnSourceReadOnly} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function setEnvPermissionsOnSourceReadOnly(
	props: SetEnvPermissionsOnSourceReadOnly,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Set Env Permissions On Source Read Only',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a user clicks into a section of the Segment App
 *
 * @param {SideNavClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClicked(
	props: SideNavClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Catalog' track call.
 *
 * @param {SideNavClickedCatalog} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedCatalog(
	props: SideNavClickedCatalog,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Catalog',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Destinations' track call.
 *
 * @param {SideNavClickedDestinations} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedDestinations(
	props: SideNavClickedDestinations,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Destinations',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Docs' track call.
 *
 * @param {SideNavClickedDocs} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedDocs(
	props: SideNavClickedDocs,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Docs',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Health' track call.
 *
 * @param {SideNavClickedHealth} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedHealth(
	props: SideNavClickedHealth,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Health',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Overview' track call.
 *
 * @param {SideNavClickedOverview} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedOverview(
	props: SideNavClickedOverview,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Overview',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Personas' track call.
 *
 * @param {SideNavClickedPersonas} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedPersonas(
	props: SideNavClickedPersonas,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Personas',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Protocols' track call.
 *
 * @param {SideNavClickedProtocols} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedProtocols(
	props: SideNavClickedProtocols,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Protocols',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Settings' track call.
 *
 * @param {SideNavClickedSettings} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedSettings(
	props: SideNavClickedSettings,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Settings',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Side Nav Clicked Sources' track call.
 *
 * @param {SideNavClickedSources} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sideNavClickedSources(
	props: SideNavClickedSources,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Side Nav Clicked Sources',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Sidepanel Move Clicked' track call.
 *
 * @param {SidepanelMoveClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sidepanelMoveClicked(
	props?: SidepanelMoveClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Sidepanel Move Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user submits a demo request via the self-service signup flow
 *
 * @param {SignupDemoRequestSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signupDemoRequestSubmitted(
	props?: SignupDemoRequestSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Signup Demo Request Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Signup Next Clicked' track call.
 *
 * @param {SignupNextClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signupNextClicked(
	props: SignupNextClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Signup Next Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User viewed the self-service signup page
 *
 * @param {SignupPageViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signupPageViewed(
	props?: SignupPageViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Signup Page Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user inputs a password and the password strength is validated
 *
 * @param {SignupPasswordStrengthValidated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signupPasswordStrengthValidated(
	props?: SignupPasswordStrengthValidated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Signup Password Strength Validated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Site Exited' track call.
 *
 * @param {SiteExited} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function siteExited(
	props?: SiteExited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Site Exited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Sloth Of Death' track call.
 *
 * @param {SlothOfDeath} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function slothOfDeath(
	props: SlothOfDeath,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Sloth Of Death',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a view is sorted.
 *
 * @param {SortApplied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sortApplied(
	props: SortApplied,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Sort Applied',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Authorize Clicked' track call.
 *
 * @param {SourceAuthorizeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceAuthorizeClicked(
	props: SourceAuthorizeClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Authorize Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Authorized' track call.
 *
 * @param {SourceAuthorized} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceAuthorized(
	props?: SourceAuthorized,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Authorized',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Authorized Failed' track call.
 *
 * @param {SourceAuthorizedFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceAuthorizedFailed(
	props?: SourceAuthorizedFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Authorized Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Basic Settings Changed' track call.
 *
 * @param {SourceBasicSettingsChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceBasicSettingsChanged(
	props: SourceBasicSettingsChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Basic Settings Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Collaborator Invited Legacy' track call.
 *
 * @param {SourceCollaboratorInvitedLegacy} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceCollaboratorInvitedLegacy(
	props?: SourceCollaboratorInvitedLegacy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Collaborator Invited Legacy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Created' track call.
 *
 * @param {SourceCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceCreated(
	props?: SourceCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Delete Clicked' track call.
 *
 * @param {SourceDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceDeleteClicked(
	props: SourceDeleteClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Delete Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Deleted' track call.
 *
 * @param {SourceDeleted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceDeleted(
	props?: SourceDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Disabled' track call.
 *
 * @param {SourceDisabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceDisabled(
	props?: SourceDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Enabled' track call.
 *
 * @param {SourceEnabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceEnabled(
	props?: SourceEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user edits the label on an individual source
 *
 * @param {SourceLabelEdited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceLabelEdited(
	props: SourceLabelEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Label Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Moved' track call.
 *
 * @param {SourceMoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceMoved(
	props?: SourceMoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Moved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Overview Accordion Toggled' track call.
 *
 * @param {SourceOverviewAccordionToggled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceOverviewAccordionToggled(
	props?: SourceOverviewAccordionToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Overview Accordion Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Overview Link Clicked' track call.
 *
 * @param {SourceOverviewLinkClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceOverviewLinkClicked(
	props?: SourceOverviewLinkClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Overview Link Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source SQL Settings Changed' track call.
 *
 * @param {SourceSqlSettingsChanged} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceSqlSettingsChanged(
	props?: SourceSqlSettingsChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source SQL Settings Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fired when a user clears their source schema.
 *
 * @param {SourceSchemaCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceSchemaCleared(
	props: SourceSchemaCleared,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Schema Cleared',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Schema Refresh Clicked' track call.
 *
 * @param {SourceSchemaRefreshClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceSchemaRefreshClicked(
	props?: SourceSchemaRefreshClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Schema Refresh Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Schema V1
 *
 * @param {SourceSchemaRefreshed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceSchemaRefreshed(
	props?: SourceSchemaRefreshed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Schema Refreshed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Source Setup Funnel Step Completed' track call.
 *
 * @param {SourceSetupFunnelStepCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceSetupFunnelStepCompleted(
	props: SourceSetupFunnelStepCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Setup Funnel Step Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user generates a new Source write key
 *
 * @param {SourceWriteKeyGenerated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceWriteKeyGenerated(
	props: SourceWriteKeyGenerated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Write Key Generated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user revokes an individual Source write key
 *
 * @param {SourceWriteKeyRevoked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceWriteKeyRevoked(
	props: SourceWriteKeyRevoked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source Write Key Revoked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user searches for a source on the bulk assign environments UI
 *
 * @param {SourceSearchedOnBulkAssignEnvironments} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourceSearchedOnBulkAssignEnvironments(
	props: SourceSearchedOnBulkAssignEnvironments,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Source searched on bulk assign environments',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * For Sources Selective Sync when a customer toggles a collection on or off
 *
 * @param {SourcesCollectionToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourcesCollectionToggled(
	props: SourcesCollectionToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Sources Collection Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * For Sources Selective Sync when a customer toggles a field on or off inside of a collection
 *
 * @param {SourcesFieldToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourcesFieldToggled(
	props: SourcesFieldToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Sources Field Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Sources Link Clicked' track call.
 *
 * @param {SourcesLinkClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sourcesLinkClicked(
	props: SourcesLinkClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Sources Link Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * A customer clicked on the create-a-split account button
 *
 * @param {SplitAccountButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function splitAccountButtonClicked(
	props: SplitAccountButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Split Account Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * A customer was in the rollout for seeing a split account button
 *
 * @param {SplitAccountButtonViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function splitAccountButtonViewed(
	props: SplitAccountButtonViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Split Account Button Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Starter Tracking Plan Created' track call.
 *
 * @param {StarterTrackingPlanCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function starterTrackingPlanCreated(
	props: StarterTrackingPlanCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Starter Tracking Plan Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * An event for indicating a user has completed the startup program application
 *
 * @param {StartupApplicationCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function startupApplicationCompleted(
	props: StartupApplicationCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Startup Application Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Step Completed (Appcues)' track call.
 *
 * @param {StepCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function stepCompletedAppcues(
	props?: StepCompletedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Step Completed (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Step Interacted (Appcues)' track call.
 *
 * @param {StepInteractedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function stepInteractedAppcues(
	props?: StepInteractedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Step Interacted (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Step Skipped (Appcues)' track call.
 *
 * @param {StepSkippedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function stepSkippedAppcues(
	props?: StepSkippedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Step Skipped (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Step Started (Appcues)' track call.
 *
 * @param {StepStartedAppcues} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function stepStartedAppcues(
	props?: StepStartedAppcues,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Step Started (Appcues)',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Submitted Wishlist Integration Request' track call.
 *
 * @param {SubmittedWishlistIntegrationRequest} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function submittedWishlistIntegrationRequest(
	props: SubmittedWishlistIntegrationRequest,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Submitted Wishlist Integration Request',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Subscription Plan Change Error' track call.
 *
 * @param {SubscriptionPlanChangeError} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionPlanChangeError(
	props?: SubscriptionPlanChangeError,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Subscription Plan Change Error',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Subscription Plan Changed' track call.
 *
 * @param {SubscriptionPlanChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionPlanChanged(
	props: SubscriptionPlanChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Subscription Plan Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Subscription Plan Failed' track call.
 *
 * @param {SubscriptionPlanFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionPlanFailed(
	props: SubscriptionPlanFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Subscription Plan Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Support Access Grant Created' track call.
 *
 * @param {SupportAccessGrantCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function supportAccessGrantCreated(
	props?: SupportAccessGrantCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Support Access Grant Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Support Access Grant Revoked' track call.
 *
 * @param {SupportAccessGrantRevoked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function supportAccessGrantRevoked(
	props?: SupportAccessGrantRevoked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Support Access Grant Revoked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Survey Closed' track call.
 *
 * @param {SurveyClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function surveyClosed(
	props: SurveyClosed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Survey Closed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Survey Completed' track call.
 *
 * @param {SurveyCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function surveyCompleted(
	props: SurveyCompleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Survey Completed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Survey Viewed' track call.
 *
 * @param {SurveyViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function surveyViewed(
	props?: SurveyViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Survey Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Tag an Event Clicked' track call.
 *
 * @param {TagAnEventClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function tagAnEventClicked(
	props?: TagAnEventClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tag an Event Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Sidesheet closed
 *
 * @param {TeamMemberDetailViewClosed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamMemberDetailViewClosed(
	props?: TeamMemberDetailViewClosed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Team Member Detail View Closed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Sidesheet opened
 *
 * @param {TeamMemberDetailViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamMemberDetailViewed(
	props?: TeamMemberDetailViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Team Member Detail Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * New invitation saved
 *
 * @param {TeamMemberInvited} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamMemberInvited(
	props?: TeamMemberInvited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Team Member Invited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Team Member Invited Legacy' track call.
 *
 * @param {TeamMemberInvitedLegacy} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamMemberInvitedLegacy(
	props?: TeamMemberInvitedLegacy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Team Member Invited Legacy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Team Member Removed' track call.
 *
 * @param {TeamMemberRemoved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamMemberRemoved(
	props?: TeamMemberRemoved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Team Member Removed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Sidesheet saved successfully
 *
 * @param {TeamMemberSaved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamMemberSaved(
	props?: TeamMemberSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Team Member Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Test' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function test(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Test', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * Fires a 'Tool Request Form Submitted' track call.
 *
 * @param {ToolRequestFormSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function toolRequestFormSubmitted(
	props?: ToolRequestFormSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tool Request Form Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires at the end of the connect flow, after reviewing consequences. Cannot fire when source already connected
 *
 * @param {TrackingPlanConnectionChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanConnectionChanged(
	props: TrackingPlanConnectionChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Connection Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire each time tracking plan is created
 *
 * @param {TrackingPlanCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanCreated(
	props: TrackingPlanCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire each time tracking plan is deleted
 *
 * @param {TrackingPlanDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanDeleted(
	props: TrackingPlanDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user clicks 'Add Event Version' on an event.
 *
 * @param {TrackingPlanEventVersionAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanEventVersionAdded(
	props: TrackingPlanEventVersionAdded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Event Version Added',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire each time tracking plan is inferred from a source
 *
 * @param {TrackingPlanInferred} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanInferred(
	props: TrackingPlanInferred,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Inferred',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire each time tracking plan is saved (not at initial create) after Review Changes
 *
 * @param {TrackingPlanSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanSaved(
	props: TrackingPlanSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when user interacts with Tracking Plan Tip (fire when user Opens, Ignores or Accepts)
 *
 * @param {TrackingPlanTipInteracted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingPlanTipInteracted(
	props: TrackingPlanTipInteracted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Plan Tip Interacted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Specs for events to track were selected by a user
 *
 * @param {TrackingSpecsSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function trackingSpecsSelected(
	props: TrackingSpecsSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Tracking Specs Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Transactional Error' track call.
 *
 * @param {TransactionalError} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function transactionalError(
	props: TransactionalError,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Transactional Error',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a user creates a new transformation
 *
 * @param {TransformationCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function transformationCreated(
	props: TransformationCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Transformation Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user deletes a transformation
 *
 * @param {TransformationDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function transformationDeleted(
	props: TransformationDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Transformation Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User selects a different trigger type than the default
 *
 * @param {TriggerTypeReSelected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function triggerTypeReSelected(
	props?: TriggerTypeReSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Trigger Type Re-Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'URL Field Edited' track call.
 *
 * @param {UrlFieldEdited} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function urlFieldEdited(
	props?: UrlFieldEdited,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'URL Field Edited',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Unread Notification Count Displayed' track call.
 *
 * @param {UnreadNotificationCountDisplayed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function unreadNotificationCountDisplayed(
	props: UnreadNotificationCountDisplayed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Unread Notification Count Displayed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user updates the state of an onboarding step, e.g. skipping a step.
 *
 * @param {UpdateOnboardingStepState} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function updateOnboardingStepState(
	props: UpdateOnboardingStepState,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Update Onboarding Step State',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Update Profile button clicked on the User Settings page
 *
 * @param {UpdateProfileClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function updateProfileClicked(
	props: UpdateProfileClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Update Profile Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Updated Components' track call.
 *
 * @param {UpdatedComponents} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function updatedComponents(
	props: UpdatedComponents,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Updated Components',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Updated Contacts' track call.
 *
 * @param {UpdatedContacts} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function updatedContacts(
	props: UpdatedContacts,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Updated Contacts',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Upgrade CTA Clicked' track call.
 *
 * @param {UpgradeCtaClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function upgradeCtaClicked(
	props: UpgradeCtaClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Upgrade CTA Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Upgrade Modal Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function upgradeModalClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Upgrade Modal Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Upvoted Wishlist Integration Request' track call.
 *
 * @param {UpvotedWishlistIntegrationRequest} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function upvotedWishlistIntegrationRequest(
	props: UpvotedWishlistIntegrationRequest,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Upvoted Wishlist Integration Request',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Usage Tab Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function usageTabClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Usage Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'User Created' track call.
 *
 * @param {UserCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userCreated(
	props?: UserCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Delete Account button clicked on the User Settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userDeleteClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Delete Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'User Deleted' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userDeleted(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'User Impersonated' track call.
 *
 * @param {UserImpersonated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userImpersonated(
	props: UserImpersonated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Impersonated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'User Linked to Workspace' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userLinkedToWorkspace(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Linked to Workspace',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'User Logged In' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userLoggedIn(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Logged In',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'User Signed Up' track call.
 *
 * @param {UserSignedUp} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userSignedUp(
	props: UserSignedUp,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'User Signed Up',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'VT Get Started Button Clicked' track call.
 *
 * @param {VtGetStartedButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function vtGetStartedButtonClicked(
	props?: VtGetStartedButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'VT Get Started Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'VT Legal Modal Install Button Clicked' track call.
 *
 * @param {VtLegalModalInstallButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function vtLegalModalInstallButtonClicked(
	props?: VtLegalModalInstallButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'VT Legal Modal Install Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'VT View Debugger Clicked' track call.
 *
 * @param {VtViewDebuggerClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function vtViewDebuggerClicked(
	props?: VtViewDebuggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'VT View Debugger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when user clicks validate data to view the "Data Validation" report
 *
 * @param {ValidateDataClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function validateDataClicked(
	props?: ValidateDataClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Validate Data Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * This event is fired when a user clicks View Changelog for a Tracking Plan.
 *
 * @param {ViewChangelogClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewChangelogClicked(
	props: ViewChangelogClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Changelog Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks "View Debugger"
 *
 * @param {ViewDebuggerClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewDebuggerClicked(
	props: ViewDebuggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Debugger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'View Libraries Clicked' track call.
 *
 * @param {ViewLibrariesClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewLibrariesClicked(
	props: ViewLibrariesClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Libraries Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user clicks to edit protocols schema settings
 *
 * @param {ViewSchemaConfigurationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewSchemaConfigurationClicked(
	props: ViewSchemaConfigurationClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Schema Configuration Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user clicks to view the schema tab for a specific source
 *
 * @param {ViewSourceSchemaClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewSourceSchemaClicked(
	props: ViewSourceSchemaClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Source Schema Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When user clicks to view tracking plan in edit mode
 *
 * @param {ViewTrackingPlanClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewTrackingPlanClicked(
	props: ViewTrackingPlanClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Tracking Plan Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'View Transformations Clicked' track call.
 *
 * @param {ViewTransformationsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewTransformationsClicked(
	props: ViewTransformationsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Transformations Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when user clicks to view violations in either Schema, violation summary or Data Validation views
 *
 * @param {ViewViolationsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewViolationsClicked(
	props: ViewViolationsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'View Violations Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Viewed Featured Destinations' track call.
 *
 * @param {ViewedFeaturedDestinations} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewedFeaturedDestinations(
	props: ViewedFeaturedDestinations,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Viewed Featured Destinations',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Viewed Integration' track call.
 *
 * @param {ViewedIntegration} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewedIntegration(
	props?: ViewedIntegration,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Viewed Integration',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Viewed lockout' track call.
 *
 * @param {ViewedLockout} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewedLockout(
	props?: ViewedLockout,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Viewed lockout',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fire when a user deletes violations.
 *
 * @param {ViolationsDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function violationsDeleted(
	props: ViolationsDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Violations Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Visited Integration Docs' track call.
 *
 * @param {VisitedIntegrationDocs} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visitedIntegrationDocs(
	props?: VisitedIntegrationDocs,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visited Integration Docs',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When a customer creates and saves an Event in the Visual Tagger
 *
 * @param {VisualEventCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualEventCreated(
	props?: VisualEventCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Event Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT build page
 *
 * @param {VisualTaggerAddPropertyClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerAddPropertyClicked(
	props: VisualTaggerAddPropertyClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Add Property Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Visual Tagger Advanced Options Clicked' track call.
 *
 * @param {VisualTaggerAdvancedOptionsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerAdvancedOptionsClicked(
	props: VisualTaggerAdvancedOptionsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Advanced Options Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * "Visual Tagger" Clicked on the Source Page
 *
 * @param {VisualTaggerClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerClicked(
	props: VisualTaggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * This happens when user clicks into the build page, and the source is not correctly configured.
 *
 * @param {VisualTaggerCopySnippetClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerCopySnippetClicked(
	props: VisualTaggerCopySnippetClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Copy Snippet Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the "build" page
 *
 * @param {VisualTaggerCreateEventClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerCreateEventClicked(
	props: VisualTaggerCreateEventClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Create Event Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the VT home page
 *
 * @param {VisualTaggerCreateEventsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerCreateEventsClicked(
	props: VisualTaggerCreateEventsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Create Events Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the published table
 *
 * @param {VisualTaggerCreateNewClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerCreateNewClicked(
	props: VisualTaggerCreateNewClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Create New Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the published table
 *
 * @param {VisualTaggerDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerDeleteClicked(
	props: VisualTaggerDeleteClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Delete Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Visual Tagger Doc Clicked' track call.
 *
 * @param {VisualTaggerDocClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerDocClicked(
	props: VisualTaggerDocClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Doc Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the published table
 *
 * @param {VisualTaggerEditClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerEditClicked(
	props: VisualTaggerEditClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Edit Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Visual Tagger Enter Value Clicked' track call.
 *
 * @param {VisualTaggerEnterValueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerEnterValueClicked(
	props: VisualTaggerEnterValueClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Enter Value Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * triggered when "publish" is clicked
 *
 * @param {VisualTaggerEventCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerEventCreated(
	props: VisualTaggerEventCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Event Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User clicks "save" in the event details editing modal in the iframe view
 *
 * @param {VisualTaggerEventSaved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerEventSaved(
	props?: VisualTaggerEventSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Event Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * after click the "Test Events", user click on the image, and see the test result
 *
 * @param {VisualTaggerEventTested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerEventTested(
	props: VisualTaggerEventTested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Event Tested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT Build Page
 *
 * @param {VisualTaggerExitClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerExitClicked(
	props: VisualTaggerExitClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Exit Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * the click after clicking visual tagger on the Source page
 *
 * @param {VisualTaggerGetStartedButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerGetStartedButtonClicked(
	props: VisualTaggerGetStartedButtonClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Get Started Button Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT Build Page
 *
 * @param {VisualTaggerGuideClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerGuideClicked(
	props: VisualTaggerGuideClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Guide Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * When the customer turns on/off the Visual Tagger integration the event is triggered.
 *
 * @param {VisualTaggerIntegrationToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerIntegrationToggled(
	props: VisualTaggerIntegrationToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Integration Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT Build Page
 *
 * @param {VisualTaggerLearnBestPracticeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerLearnBestPracticeClicked(
	props: VisualTaggerLearnBestPracticeClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Learn Best Practice Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Visual Tagger Publish Clicked' track call.
 *
 * @param {VisualTaggerPublishClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerPublishClicked(
	props: VisualTaggerPublishClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Publish Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Visual Tagger Select Value From Page Clicked' track call.
 *
 * @param {VisualTaggerSelectValueFromPageClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerSelectValueFromPageClicked(
	props: VisualTaggerSelectValueFromPageClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Select Value From Page Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Setup Steps have been completed and user clicks "Continue"
 *
 * @param {VisualTaggerSetupStepsContinueClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerSetupStepsContinueClicked(
	props?: VisualTaggerSetupStepsContinueClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Setup Steps Continue Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the VT home page
 *
 * @param {VisualTaggerTemplateClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerTemplateClicked(
	props: VisualTaggerTemplateClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Template Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * "Tests Events Clicked"
 *
 * @param {VisualTaggerTestEventsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerTestEventsClicked(
	props: VisualTaggerTestEventsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Test Events Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT build page, after click "create event", you can click "buttons", "Forms:, or "Any"
 *
 * @param {VisualTaggerTrackAnyClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerTrackAnyClicked(
	props: VisualTaggerTrackAnyClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Track Any Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT build page, after click "create event", you can click "buttons", "Forms:, or "Any"
 *
 * @param {VisualTaggerTrackButtonsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerTrackButtonsClicked(
	props: VisualTaggerTrackButtonsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Track Buttons Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * VT build page, after click "create event", you can click "buttons", "Forms:, or "Any"
 *
 * @param {VisualTaggerTrackFormsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerTrackFormsClicked(
	props: VisualTaggerTrackFormsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Track Forms Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on the VT home/guide page.
 *
 * @param {VisualTaggerVideoClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerVideoClicked(
	props: VisualTaggerVideoClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger Video Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Intro Page
 *
 * @param {VisualTaggerViewAgreementClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerViewAgreementClicked(
	props: VisualTaggerViewAgreementClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger View Agreement Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Intro Page
 *
 * @param {VisualTaggerViewExtensionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function visualTaggerViewExtensionClicked(
	props: VisualTaggerViewExtensionClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Visual Tagger View Extension Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Connection Failed' track call.
 *
 * @param {WarehouseConnectionFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseConnectionFailed(
	props: WarehouseConnectionFailed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Connection Failed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Connection Tested' track call.
 *
 * @param {WarehouseConnectionTested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseConnectionTested(
	props: WarehouseConnectionTested,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Connection Tested',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Connection Updated' track call.
 *
 * @param {WarehouseConnectionUpdated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseConnectionUpdated(
	props?: WarehouseConnectionUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Connection Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Created' track call.
 *
 * @param {WarehouseCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseCreated(
	props: WarehouseCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Delete Clicked' track call.
 *
 * @param {WarehouseDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseDeleteClicked(
	props: WarehouseDeleteClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Delete Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Deleted' track call.
 *
 * @param {WarehouseDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseDeleted(
	props: WarehouseDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Disabled' track call.
 *
 * @param {WarehouseDisabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseDisabled(
	props: WarehouseDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Enabled' track call.
 *
 * @param {WarehouseEnabled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseEnabled(
	props: WarehouseEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Nickname Changed' track call.
 *
 * @param {WarehouseNicknameChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseNicknameChanged(
	props: WarehouseNicknameChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Nickname Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user updates the Selective Sync Schema for a Warehouse
 *
 * @param {WarehouseSchemaUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSchemaUpdated(
	props: WarehouseSchemaUpdated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Schema Updated',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Settings Saved' track call.
 *
 * @param {WarehouseSettingsSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSettingsSaved(
	props: WarehouseSettingsSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Settings Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Simulator Query Executed' track call.
 *
 * @param {WarehouseSimulatorQueryExecuted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSimulatorQueryExecuted(
	props?: WarehouseSimulatorQueryExecuted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Simulator Query Executed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when a user toggles the Enable/Disable toggle on the Warehouse Source Page
 *
 * @param {WarehouseSourceEnableToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSourceEnableToggled(
	props: WarehouseSourceEnableToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Source Enable Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Sync Schedule Disabled' track call.
 *
 * @param {WarehouseSyncScheduleDisabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSyncScheduleDisabled(
	props?: WarehouseSyncScheduleDisabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Sync Schedule Disabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Sync Schedule Enabled' track call.
 *
 * @param {WarehouseSyncScheduleEnabled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSyncScheduleEnabled(
	props?: WarehouseSyncScheduleEnabled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Sync Schedule Enabled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Warehouse Sync Schedule Saved' track call.
 *
 * @param {WarehouseSyncScheduleSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function warehouseSyncScheduleSaved(
	props: WarehouseSyncScheduleSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Warehouse Sync Schedule Saved',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Workspace Add Clicked' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceAddClicked(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Add Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Workspace Created' track call.
 *
 * @param {WorkspaceCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceCreated(
	props: WorkspaceCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Workspace Deleted' track call.
 *
 * @param {WorkspaceDeleted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceDeleted(
	props?: WorkspaceDeleted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Deleted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Workspace Home Add Visual Tagger Clicked' track call.
 *
 * @param {WorkspaceHomeAddVisualTaggerClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceHomeAddVisualTaggerClicked(
	props: WorkspaceHomeAddVisualTaggerClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Home Add Visual Tagger Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Workspace Home Edit Destination Settings' track call.
 *
 * @param {WorkspaceHomeEditDestinationSettings} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceHomeEditDestinationSettings(
	props: WorkspaceHomeEditDestinationSettings,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Home Edit Destination Settings',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * View Catalog button when setting up the destination
 *
 * @param {WorkspaceHomeViewCatalogClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceHomeViewCatalogClicked(
	props: WorkspaceHomeViewCatalogClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Home View Catalog Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * on workspace home w. VT
 *
 * @param {WorkspaceHomeViewCodeDocsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceHomeViewCodeDocsClicked(
	props: WorkspaceHomeViewCodeDocsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Home View Code Docs Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Copy Snippet button clicked at Workspace Home with VT availabe
 *
 * @param {WorkspaceHomeVisualTaggerCopySnippetClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceHomeVisualTaggerCopySnippetClicked(
	props: WorkspaceHomeVisualTaggerCopySnippetClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Home Visual Tagger Copy Snippet Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users change the period in which they view the sources count and MTU data
 *
 * @param {WorkspaceInsightsCsvDownloaded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceInsightsCsvDownloaded(
	props: WorkspaceInsightsCsvDownloaded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Insights CSV downloaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users change click to download the sources count and MTU data
 *
 * @param {WorkspaceInsightsPeriodChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceInsightsPeriodChanged(
	props: WorkspaceInsightsPeriodChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Insights Period Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Workspace Settings Tab Clicked' track call.
 *
 * @param {WorkspaceSettingsTabClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceSettingsTabClicked(
	props: WorkspaceSettingsTabClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Settings Tab Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users download a CSV report of a usage metric
 *
 * @param {WorkspaceUsageMetricCsvDownloaded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceUsageMetricCsvDownloaded(
	props: WorkspaceUsageMetricCsvDownloaded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Usage Metric CSV Downloaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users expand the metric overview details accordion in the usage page
 *
 * @param {WorkspaceUsageMetricOverviewDetailsExpanded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceUsageMetricOverviewDetailsExpanded(
	props: WorkspaceUsageMetricOverviewDetailsExpanded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Usage Metric Overview Details Expanded ',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users select a metric tab in the usage page
 *
 * @param {WorkspaceUsageMetricTabSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceUsageMetricTabSelected(
	props: WorkspaceUsageMetricTabSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Usage Metric Tab Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users trigger a tooltip render in the usage page
 *
 * @param {WorkspaceUsageMetricTooltipViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceUsageMetricTooltipViewed(
	props: WorkspaceUsageMetricTooltipViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Usage Metric Tooltip Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users change the viewable invoice period for the current workspace usage.
 *
 * @param {WorkspaceUsagePeriodChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceUsagePeriodChanged(
	props: WorkspaceUsagePeriodChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Usage Period Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Tracks when users click on the upgrade plan CTA while viewing usage details
 *
 * @param {WorkspaceUsageUpgradeCtaClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspaceUsageUpgradeCtaClicked(
	props: WorkspaceUsageUpgradeCtaClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspace Usage Upgrade CTA Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event fired when comparing the existing workspace flags and the prototyped ones
 *
 * @param {WorkspacesFlagsComparison} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspacesFlagsComparison(
	props: WorkspacesFlagsComparison,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspaces Flags Comparison',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event fired when comparing the existing workspace quotas and the prototyped ones
 *
 * @param {WorkspacesQuotaComparison} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function workspacesQuotaComparison(
	props: WorkspacesQuotaComparison,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Workspaces Quota Comparison',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Write Key Change Clicked' track call.
 *
 * @param {WriteKeyChangeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function writeKeyChangeClicked(
	props: WriteKeyChangeClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Write Key Change Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Write Key Changed' track call.
 *
 * @param {WriteKeyChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function writeKeyChanged(
	props: WriteKeyChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Write Key Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'Writekey Retry Clicked' track call.
 *
 * @param {WritekeyRetryClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function writekeyRetryClicked(
	props?: WritekeyRetryClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Writekey Retry Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires when user clicks the Setup Guide docs link on the Workspace Home
 *
 * @param {DoNotAddYetWorkspaceHomeSetupGuideDocsClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function doNotAddYetWorkspaceHomeSetupGuideDocsClicked(
	props?: DoNotAddYetWorkspaceHomeSetupGuideDocsClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'[DO NOT ADD YET] Workspace Home Setup Guide Docs Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'clicked connect pane link' track call.
 *
 * @param {ClickedConnectPaneLink} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clickedConnectPaneLink(
	props?: ClickedConnectPaneLink,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'clicked connect pane link',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Fires a 'viewed connect pane' track call.
 *
 * @param {ViewedConnectPane} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewedConnectPane(
	props?: ViewedConnectPane,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'viewed connect pane',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}

const clientAPI = {
	/**
	 * Updates the run-time configuration of this Typewriter client.
	 *
	 * @param {TypewriterOptions} options - the options to upsert
	 *
	 * @typedef {Object} TypewriterOptions
	 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
	 * 		calls are forwarded on to. Defaults to window.analytics.
	 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
	 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
	 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
	 * 		will be logged to stderr.
	 */
	setTypewriterOptions,
	/**
	 * Fires a 'Access Denied Error' track call.
	 *
	 * @param {AccessDeniedError} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accessDeniedError,
	/**
	 * Fires a 'Activity Feed Filtered' track call.
	 *
	 * @param {ActivityFeedFiltered} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	activityFeedFiltered,
	/**
	 * Fires a 'Activity Feed Searched' track call.
	 *
	 * @param {ActivityFeedSearched} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	activityFeedSearched,
	/**
	 * Fires a 'Ad Campaign Clicked' track call.
	 *
	 * @param {AdCampaignClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	adCampaignClicked,
	/**
	 * Fires when user clicks "Add Destination"
	 *
	 * @param {AddDestinationClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addDestinationClicked,
	/**
	 * Fires when user completes "Add Destination" flow
	 *
	 * @param {AddDestinationCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addDestinationCompleted,
	/**
	 * Fires when user clicks "Close" on sending pageview data flow
	 *
	 * @param {AddPageviewsCloseButtonClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addPageviewsCloseButtonClicked,
	/**
	 * Fires when user clicks "Copy Snippet" on sending pageview data
	 *
	 * @param {AddPageviewsCopySnippetClickedCopy} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addPageviewsCopySnippetClickedCopy,
	/**
	 * Fires when user clicks "Get Started" on sending pageview data
	 *
	 * @param {AddPageviewsGetStartedClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addPageviewsGetStartedClicked,
	/**
	 * Fires when user clicks "Add Source" button from the checklist
	 *
	 * @param {AddSourceButtonClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addSourceButtonClicked,
	/**
	 * Fires when user clicks the "Next" or "Finish" button in the Add Source flow
	 *
	 * @param {AddSourceNextButtonClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	addSourceNextButtonClicked,
	/**
	 * Fires a 'AdminTOS Acknowledged' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	adminTosAcknowledged,
	/**
	 * Fires a 'Advanced Usage Tab Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	advancedUsageTabClicked,
	/**
	 * Fires a 'Agreement Downloaded Signed Copy' track call.
	 *
	 * @param {AgreementDownloadedSignedCopy} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	agreementDownloadedSignedCopy,
	/**
	 * Fires a 'Agreement Downloaded Unsigned Copy' track call.
	 *
	 * @param {AgreementDownloadedUnsignedCopy} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	agreementDownloadedUnsignedCopy,
	/**
	 * Fires a 'Agreement Signed' track call.
	 *
	 * @param {AgreementSigned} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	agreementSigned,
	/**
	 * App timing metrics from real users in our app.
	 *
	 * @param {AppTimingMetric} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	appTimingMetric,
	/**
	 * Fires when a user clicks "Assign Labels" in the Label Management console
	 *
	 * @param {AssignLabelsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	assignLabelsClicked,
	/**
	 * Fires a 'Audit Trail Filtered' track call.
	 *
	 * @param {AuditTrailFiltered} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	auditTrailFiltered,
	/**
	 * User accepted beta terms of service
	 *
	 * @param {BetaTermsAccepted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	betaTermsAccepted,
	/**
	 * Fires when user toggles "Braze Debounce Identify" in their analytics.js settings
	 *
	 * @param {BrazeMiddlewareToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	brazeMiddlewareToggled,
	/**
	 * Fires when the "Save Changes" button is clicked for bulk assigning labels in the label management console
	 *
	 * @param {BulkAssignLabelSaved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	bulkAssignLabelSaved,
	/**
	 * Fires a 'CSV Downloaded' track call.
	 *
	 * @param {CsvDownloaded} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	csvDownloaded,
	/**
	 * Fired when user clicks the "Cancel" button on the bulk assign environments dialog
	 *
	 * @param {CancelButtonBulkAssignEnvironmentsClickCopy} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	cancelButtonBulkAssignEnvironmentsClickCopy,
	/**
	 * Fires a 'Catalog Category Clicked' track call.
	 *
	 * @param {CatalogCategoryClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogCategoryClicked,
	/**
	 * Fires a 'Catalog Recommendation Category Clicked' track call.
	 *
	 * @param {CatalogRecommendationCategoryClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogRecommendationCategoryClicked,
	/**
	 * Fires a 'Catalog Recommendation Clicked' track call.
	 *
	 * @param {CatalogRecommendationClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogRecommendationClicked,
	/**
	 * Fires a 'Catalog Sidebar Category Clicked' track call.
	 *
	 * @param {CatalogSidebarCategoryClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogSidebarCategoryClicked,
	/**
	 * User searched the catalog using the sidebar in the left nav.
	 *
	 * @param {CatalogSidebarSearched} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogSidebarSearched,
	/**
	 * Fires a 'Catalog Sidebar Tab Clicked' track call.
	 *
	 * @param {CatalogSidebarTabClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogSidebarTabClicked,
	/**
	 * Fires a 'Catalog Sort By' track call.
	 *
	 * @param {CatalogSortBy} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogSortBy,
	/**
	 * Fires a 'Catalog Sort By Clicked' track call.
	 *
	 * @param {CatalogSortByClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogSortByClicked,
	/**
	 * Fires a 'Catalog Tile Clicked' track call.
	 *
	 * @param {CatalogTileClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	catalogTileClicked,
	/**
	 * In gateway-api, start censoring settings going to the app.
	
	 *
	 * @param {CensorDestinationSettings} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	censorDestinationSettings,
	/**
	 * Change Password link clicked on the User Settings page
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	changePasswordClicked,
	/**
	 * Fires a 'Change Workspace Clicked' track call.
	 *
	 * @param {ChangeWorkspaceClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	changeWorkspaceClicked,
	/**
	 * Fires a 'Change Workspace Clicked from Account settings' track call.
	 *
	 * @param {ChangeWorkspaceClickedFromAccountSettings} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	changeWorkspaceClickedFromAccountSettings,
	/**
	 * Fires a 'Change Workspace Clicked from Workspace settings' track call.
	 *
	 * @param {ChangeWorkspaceClickedFromWorkspaceSettings} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	changeWorkspaceClickedFromWorkspaceSettings,
	/**
	 * Fires a 'Checklist Completed (Appcues)' track call.
	 *
	 * @param {ChecklistCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checklistCompletedAppcues,
	/**
	 * Fires when user clicks on the "View Source" link once Source has been created
	 *
	 * @param {ChecklistCompletedItemLinkClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checklistCompletedItemLinkClicked,
	/**
	 * Fires a 'Checklist Dismissed (Appcues)' track call.
	 *
	 * @param {ChecklistDismissedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checklistDismissedAppcues,
	/**
	 * Fires a 'Checklist Item Completed (Appcues)' track call.
	 *
	 * @param {ChecklistItemCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checklistItemCompletedAppcues,
	/**
	 * Fires when user expands one of the Checklist items. Does not fire if the user collapses the Checklist item.
	 *
	 * @param {ChecklistItemExpanded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checklistItemExpanded,
	/**
	 * Fires a 'Checklist Shown (Appcues)' track call.
	 *
	 * @param {ChecklistShownAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checklistShownAppcues,
	/**
	 * When a user applies a classification on the Inbox
	 *
	 * @param {ClassificationApplied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	classificationApplied,
	/**
	 * Fires a 'Clicked Add Destination' track call.
	 *
	 * @param {ClickedAddDestination} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedAddDestination,
	/**
	 * Fires a 'Clicked Add Source' track call.
	 *
	 * @param {ClickedAddSource} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedAddSource,
	/**
	 * Fires a 'Clicked CTA' track call.
	 *
	 * @param {ClickedCta} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedCta,
	/**
	 * Fires a 'Clicked Catalog Integration' track call.
	 *
	 * @param {ClickedCatalogIntegration} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedCatalogIntegration,
	/**
	 * Fires a 'Clicked Catalog Interested In Building' track call.
	 *
	 * @param {ClickedCatalogInterestedInBuilding} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedCatalogInterestedInBuilding,
	/**
	 * Fires a 'Clicked Catalog View All' track call.
	 *
	 * @param {ClickedCatalogViewAll} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedCatalogViewAll,
	/**
	 * Fires a 'Clicked Configure Destination' track call.
	 *
	 * @param {ClickedConfigureDestination} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedConfigureDestination,
	/**
	 * Fires a 'Clicked SQL Integration' track call.
	 *
	 * @param {ClickedSqlIntegration} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedSqlIntegration,
	/**
	 * Fires a 'Clicked Wishlist Integration Request Logo' track call.
	 *
	 * @param {ClickedWishlistIntegrationRequestLogo} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedWishlistIntegrationRequestLogo,
	/**
	 * Fires a 'Clicked Wishlist Upvote Button' track call.
	 *
	 * @param {ClickedWishlistUpvoteButton} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedWishlistUpvoteButton,
	/**
	 * Fire when a user copies the code snipped for an event
	 *
	 * @param {CodeSnippetCopied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	codeSnippetCopied,
	/**
	 * Track of delete confirmation of an integration (source, destination or warehouse) in connection health
	 *
	 * @param {ConnectionHealthDeleteCancelled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionHealthDeleteCancelled,
	/**
	 * Track of click when deleting an integration (source, destination or warehouse) in connection health
	 *
	 * @param {ConnectionHealthDeleteClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionHealthDeleteClicked,
	/**
	 * Track of delete confirmation of an integration (source, destination or warehouse) in connection health
	 *
	 * @param {ConnectionHealthDeleteCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionHealthDeleteCompleted,
	/**
	 * Track of click when disabling an integration (source, destination or warehouse) in connection health
	 *
	 * @param {ConnectionHealthDisableClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionHealthDisableClicked,
	/**
	 * Fires a 'Connection Health Error Clicked' track call.
	 *
	 * @param {ConnectionHealthErrorClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionHealthErrorClicked,
	/**
	 * Track of click for the action button in connection health
	 *
	 * @param {ConnectionHealthResolveErrorClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionHealthResolveErrorClicked,
	/**
	 * Fires when a user edits a connection policy in Personas Space
	 *
	 * @param {ConnectionPolicyEdited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	connectionPolicyEdited,
	/**
	 * Fires when a user creates a new label in the Label Management console
	 *
	 * @param {CreateLabelClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	createLabelClicked,
	/**
	 * Fires a 'Created Plugin' track call.
	 *
	 * @param {CreatedPlugin} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	createdPlugin,
	/**
	 * Fires a 'Credit Card Added' track call.
	 *
	 * @param {CreditCardAdded} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	creditCardAdded,
	/**
	 * Fires a 'Credit Card Edit Clicked' track call.
	 *
	 * @param {CreditCardEditClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	creditCardEditClicked,
	/**
	 * Fires a 'Credit Card Errored' track call.
	 *
	 * @param {CreditCardErrored} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	creditCardErrored,
	/**
	 * Fires a 'Debugger Call Clicked' track call.
	 *
	 * @param {DebuggerCallClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	debuggerCallClicked,
	/**
	 * Fires a 'Debugger Paused' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	debuggerPaused,
	/**
	 * Fires a 'Debugger Resumed' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	debuggerResumed,
	/**
	 * Fires a 'Debugger Searched' track call.
	 *
	 * @param {DebuggerSearched} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	debuggerSearched,
	/**
	 * Fires a 'Demo Requested' track call.
	 *
	 * @param {DemoRequested} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	demoRequested,
	/**
	 * Fires a 'Destination Authorize Clicked' track call.
	 *
	 * @param {DestinationAuthorizeClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationAuthorizeClicked,
	/**
	 * Fires a 'Destination Authorize Failed' track call.
	 *
	 * @param {DestinationAuthorizeFailed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationAuthorizeFailed,
	/**
	 * Destination authorized successfully
	 *
	 * @param {DestinationAuthorized} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationAuthorized,
	/**
	 * Fires when user saves a setting in a Destination.
	 *
	 * @param {DestinationCredentialsAdded} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationCredentialsAdded,
	/**
	 * Fires a 'Destination Deliverability Period Updated' track call.
	 *
	 * @param {DestinationDeliverabilityPeriodUpdated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationDeliverabilityPeriodUpdated,
	/**
	 * Fires a 'Destination Deliverability Viewed' track call.
	 *
	 * @param {DestinationDeliverabilityViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationDeliverabilityViewed,
	/**
	 * Fires a 'Destination Error Payload Copied' track call.
	 *
	 * @param {DestinationErrorPayloadCopied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationErrorPayloadCopied,
	/**
	 * Fires a 'Destination Error Payload Tab Changed' track call.
	 *
	 * @param {DestinationErrorPayloadTabChanged} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationErrorPayloadTabChanged,
	/**
	 * Fires a 'Destination Error Viewed' track call.
	 *
	 * @param {DestinationErrorViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationErrorViewed,
	/**
	 * Fires a 'Destination Feedback Submitted' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFeedbackSubmitted,
	/**
	 * User created a Destination Filter in the Destination Filters UI.
	 *
	 * @param {DestinationFilterCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFilterCreated,
	/**
	 * User deleted a filter in the Destination Filters UI.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFilterDeleted,
	/**
	 * A user has filled out our feedback form on Routing UI
	 *
	 * @param {DestinationFilterFeedbackSubmitted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFilterFeedbackSubmitted,
	/**
	 * User reached the “Configure Rules” step of the Destination Filter wizard. This means they clicked on the “New Filter” button, and also clicked “Accept” on the “Public Beta” agreement dialog.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFiltersConfigureRulesStepReached,
	/**
	 * User tested an event against an FQL condition in the Destination Filters UI.
	 *
	 * @param {DestinationFiltersFqlTested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFiltersFqlTested,
	/**
	 * User viewed “home” page for Destination Filters UI.
	 *
	 * @param {DestinationFiltersListViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFiltersListViewed,
	/**
	 * User reached the “Name and Save” step of the Destination Filter wizard.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFiltersNameAndSaveStepReached,
	/**
	 * User (without Destination Filters access) clicked on the “Upgrade to Business Tier” button in the Destination Filters UI.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationFiltersUpgradeButtonClicked,
	/**
	 * Fires a 'Destination Overview Period Updated' track call.
	 *
	 * @param {DestinationOverviewPeriodUpdated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationOverviewPeriodUpdated,
	/**
	 * Fires a 'Destination Overview Searched' track call.
	 *
	 * @param {DestinationOverviewSearched} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationOverviewSearched,
	/**
	 * Fires a 'Destination Overview Viewed' track call.
	 *
	 * @param {DestinationOverviewViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationOverviewViewed,
	/**
	 * Fires a 'Destination Simulator Builder Type' track call.
	 *
	 * @param {DestinationSimulatorBuilderType} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationSimulatorBuilderType,
	/**
	 * Fires a 'Destination Simulator Dismissed Source Debugger Dialog' track call.
	 *
	 * @param {DestinationSimulatorDismissedSourceDebuggerDialog} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationSimulatorDismissedSourceDebuggerDialog,
	/**
	 * Fires a 'Destination Simulator Event Payload Copied' track call.
	 *
	 * @param {DestinationSimulatorEventPayloadCopied} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationSimulatorEventPayloadCopied,
	/**
	 * Fires a 'Destination Simulator Event Sent' track call.
	 *
	 * @param {DestinationSimulatorEventSent} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationSimulatorEventSent,
	/**
	 * Fires a 'Destination Simulator Navigated From Source Debugger' track call.
	 *
	 * @param {DestinationSimulatorNavigatedFromSourceDebugger} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationSimulatorNavigatedFromSourceDebugger,
	/**
	 * Fires a 'Destination Simulator Result View Toggled' track call.
	 *
	 * @param {DestinationSimulatorResultViewToggled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationSimulatorResultViewToggled,
	/**
	 * Fires when customer reverts back to old settings version in a destination
	 *
	 * @param {DestinationsSettingsReverted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	destinationsSettingsReverted,
	/**
	 * Fires a 'Disable Tagger Clicked' track call.
	 *
	 * @param {DisableTaggerClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	disableTaggerClicked,
	/**
	 * Fired when a user clicks on a link to view our docs.
	 *
	 * @param {DocsLinkClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	docsLinkClicked,
	/**
	 * When a user clicks to edit a tracking plan from the readonly view.
	 *
	 * @param {EditTrackingPlanClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	editTrackingPlanClicked,
	/**
	 * User clicks on the dropdown that expands the elements tree
	 *
	 * @param {ElementsTreeDropdownClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	elementsTreeDropdownClicked,
	/**
	 * User clicks on one of the elements in the elements tree
	 *
	 * @param {ElementsTreeElementClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	elementsTreeElementClicked,
	/**
	 * Fires a 'Email Captured' track call.
	 *
	 * @param {EmailCaptured} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	emailCaptured,
	/**
	 * Fires a 'Email Delivered' track call.
	 *
	 * @param {EmailDelivered} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	emailDelivered,
	/**
	 * Fires when user clicks "Enable Destination"
	 *
	 * @param {EnableDestinationClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enableDestinationClicked,
	/**
	 * Fires a 'Enable Flow Started' track call.
	 *
	 * @param {EnableFlowStarted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enableFlowStarted,
	/**
	 * Fires a 'Enable Tagger Clicked' track call.
	 *
	 * @param {EnableTaggerClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enableTaggerClicked,
	/**
	 * Fires a 'Enforcement Notification Clicked' track call.
	 *
	 * @param {EnforcementNotificationClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enforcementNotificationClicked,
	/**
	 * Fires a 'Enforcement Notification Shown' track call.
	 *
	 * @param {EnforcementNotificationShown} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enforcementNotificationShown,
	/**
	 * Fire when a user changes the enforcement settings for a source
	 *
	 * @param {EnforcementSettingsChanged} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	enforcementSettingsChanged,
	/**
	 * Write key was not found on customer's page
	 *
	 * @param {ErrorWritekeyNotFound} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	errorWritekeyNotFound,
	/**
	 * Write key didn't match any of the users' sources.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	errorWritekeyNotMatching,
	/**
	 * Fires a 'Error Summary Toggled' track call.
	 *
	 * @param {ErrorSummaryToggled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	errorSummaryToggled,
	/**
	 * Fires a 'Event Disabled' track call.
	 *
	 * @param {EventDisabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventDisabled,
	/**
	 * User edits an existing event and clicks "Save"
	 *
	 * @param {EventEdited} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventEdited,
	/**
	 * Fires a 'Event Enabled' track call.
	 *
	 * @param {EventEnabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventEnabled,
	/**
	 * When a user infers an event from the schema to a Tracking Plan
	 *
	 * @param {EventInferred} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventInferred,
	/**
	 * When a user edits label(s) associated with a tracking plan event. Fire for separate track call for each amended event on TP save.
	 *
	 * @param {EventLabelsEdited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventLabelsEdited,
	/**
	 * When a customer clicks the Event Stream Tab in the Visual Tagger
	 *
	 * @param {EventStreamTabClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventStreamTabClicked,
	/**
	 * Fires a 'Event Tagger Clicked' track call.
	 *
	 * @param {EventTaggerClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	eventTaggerClicked,
	/**
	 * When a customer opens the Visual Tagger
	 *
	 * @param {ExtensionActivated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	extensionActivated,
	/**
	 * When a customer first installs the Visual Tagger
	 *
	 * @param {ExtensionInstalled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	extensionInstalled,
	/**
	 * When user logs into extension
	 *
	 * @param {ExtensionLogin} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	extensionLogin,
	/**
	 * When a customer uninstalls the Visual Tagger
	 *
	 * @param {ExtensionUninstalled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	extensionUninstalled,
	/**
	 * Fires a 'Feature Requested' track call.
	 *
	 * @param {FeatureRequested} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	featureRequested,
	/**
	 * Generic user submitted feedback
	 *
	 * @param {FeedbackSubmitted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	feedbackSubmitted,
	/**
	 * Fire when a user applies a filter within protocols views
	 *
	 * @param {FilterApplied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filterApplied,
	/**
	 * Fires when user changes the environment filter on the sources list page
	 *
	 * @param {FilterByEnvironmentSelectboxChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	filterByEnvironmentSelectboxChanged,
	/**
	 * First contentful paint in our app for real users.
	 *
	 * @param {FirstContentfulPaint} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	firstContentfulPaint,
	/**
	 * First input delay of real users.
	 *
	 * @param {FirstInputDelay} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	firstInputDelay,
	/**
	 * First paint in our app for real users.
	 *
	 * @param {FirstPaint} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	firstPaint,
	/**
	 * Fires a 'Flow Completed (Appcues)' track call.
	 *
	 * @param {FlowCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	flowCompletedAppcues,
	/**
	 * Fires a 'Flow Skipped (Appcues)' track call.
	 *
	 * @param {FlowSkippedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	flowSkippedAppcues,
	/**
	 * Fires a 'Flow Started (Appcues)' track call.
	 *
	 * @param {FlowStartedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	flowStartedAppcues,
	/**
	 * Fires a 'Form Failed' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	formFailed,
	/**
	 * Fires a 'Form Submitted' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	formSubmitted,
	/**
	 * Fire when a user changes the forwarding settings for blocked events or meta notifications
	 *
	 * @param {ForwardingSettingsChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	forwardingSettingsChanged,
	/**
	 * Fires a 'Found Writekey Match' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	foundWritekeyMatch,
	/**
	 * When a function is attached to a source by a customer or internal team member. Specific to Source Functions.
	 *
	 * @param {FunctionAttachedToSource} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	functionAttachedToSource,
	/**
	 * Fires a 'GDPR Beta Requested' track call.
	 *
	 * @param {GdprBetaRequested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	gdprBetaRequested,
	/**
	 * When user views a product gate page
	 *
	 * @param {GateViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	gateViewed,
	/**
	 * Fires a 'GraphQL Error' track call.
	 *
	 * @param {GraphQlError} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	graphQlError,
	/**
	 * Fires when a blocked value has been added
	 *
	 * @param {IdentityResolutionBlockedValueUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionBlockedValueUpdated,
	/**
	 * Fires when a user toggled the Read/Edit state toggle
	 *
	 * @param {IdentityResolutionEditStateEnabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionEditStateEnabled,
	/**
	 * Fires when a new identifier has been created
	 *
	 * @param {IdentityResolutionIdentifierCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionIdentifierCreated,
	/**
	 * Fires when a user clicks "Upgrade Behavior"
	 *
	 * @param {IdentityResolutionLimitBehaviorUpgraded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionLimitBehaviorUpgraded,
	/**
	 * Fires when the cardinality limit has been added
	 *
	 * @param {IdentityResolutionLimitUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionLimitUpdated,
	/**
	 * Fires when the identity resolution page is opened
	 *
	 * @param {IdentityResolutionPageClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionPageClicked,
	/**
	 * Fires when a setting has been changed
	 *
	 * @param {IdentityResolutionPriorityUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	identityResolutionPriorityUpdated,
	/**
	 * Fires a 'Incident Contacts Changed' track call.
	 *
	 * @param {IncidentContactsChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	incidentContactsChanged,
	/**
	 * Fires a 'Incident Contacts Saved' track call.
	 *
	 * @param {IncidentContactsSaved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	incidentContactsSaved,
	/**
	 * Fires a 'Incident Contacts Warning Dialog Canceled' track call.
	 *
	 * @param {IncidentContactsWarningDialogCanceled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	incidentContactsWarningDialogCanceled,
	/**
	 * Fires a 'Incident Contacts Warning Dialog Confirmed' track call.
	 *
	 * @param {IncidentContactsWarningDialogConfirmed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	incidentContactsWarningDialogConfirmed,
	/**
	 * Fires a 'Incident Contacts Warning Dialog Displayed' track call.
	 *
	 * @param {IncidentContactsWarningDialogDisplayed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	incidentContactsWarningDialogDisplayed,
	/**
	 * Fires a 'Integration Disabled' track call.
	 *
	 * @param {IntegrationDisabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	integrationDisabled,
	/**
	 * Fires a 'Integration Enabled' track call.
	 *
	 * @param {IntegrationEnabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	integrationEnabled,
	/**
	 * Fires when enable with segment is used (used to be only for webhooks or s3, which should never happen). Now indicates a partner has not moved off the legacy enable flow to the new enable with OAuth.
	 *
	 * @param {InvalidDestinationEnableAttempted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	invalidDestinationEnableAttempted,
	/**
	 * Fires a 'Invalid JSON' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	invalidJson,
	/**
	 * Fires a 'Invalid SEO Title' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	invalidSeoTitle,
	/**
	 * When a user downloads a CSV report of their Inventory
	 *
	 * @param {InventoryCsvDownloaded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	inventoryCsvDownloaded,
	/**
	 * When a user clicks into a row and expands the sidesheet
	 *
	 * @param {InventorySidesheetViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	inventorySidesheetViewed,
	/**
	 * When a user download's the CSV from the sidesheet
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	inventoryVolumeCsvDownloaded,
	/**
	 * Fires a 'Investor Program Handshake Made' track call.
	 *
	 * @param {InvestorProgramHandshakeMade} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	investorProgramHandshakeMade,
	/**
	 * Fires when user clicks the Invite a Teammate link on the Workspace Home
	 *
	 * @param {InviteATeammateClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	inviteATeammateClicked,
	/**
	 * Fires a 'Invoice History Tab Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	invoiceHistoryTabClicked,
	/**
	 * Fire when a user manually edits the JSON schema in a tracking plan
	 *
	 * @param {JsonSchemaEdited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	jsonSchemaEdited,
	/**
	 * Fires a 'JavaScript Error' track call.
	 *
	 * @param {JavaScriptError} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	javaScriptError,
	/**
	 * Fires a 'Job CTA Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	jobCtaClicked,
	/**
	 * Fires when a user selects an environment on the bulk assign environments UI
	 *
	 * @param {LabelAsEnvironmentDropdownSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelAsEnvironmentDropdownSelected,
	/**
	 * Fires when a user is assigned permissions by labels
	 *
	 * @param {LabelAssignedToPermissions} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelAssignedToPermissions,
	/**
	 * Fires when a user tries to create a label and is successful
	 *
	 * @param {LabelCreationSuccessful} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelCreationSuccessful,
	/**
	 * Fires when a user tries to create a label and is unsuccessful
	 *
	 * @param {LabelCreationUnsuccessful} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelCreationUnsuccessful,
	/**
	 * Fires when a user clicks "save changes" on the assign labels tab
	 *
	 * @param {LabelResourcesSaved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelResourcesSaved,
	/**
	 * clicked on the Labels page in Workspace Settings
	 *
	 * @param {LabelTabClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelTabClicked,
	/**
	 * Fires when environments are assigned to permissions
	 *
	 * @param {LabelAssignedToPermission} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelAssignedToPermission,
	/**
	 * Fires when user clicks "Label your sources" button on the sources list page
	 *
	 * @param {LabelYourSourcesButtonClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labelYourSourcesButtonClicked,
	/**
	 * Fires when user accepts feature terms of service
	 *
	 * @param {LabsFeatureTermsAccepted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	labsFeatureTermsAccepted,
	/**
	 * Fires a 'Lead Captured' track call.
	 *
	 * @param {LeadCaptured} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	leadCaptured,
	/**
	 * When a user imports items from a Library into a Tracking Plan
	 *
	 * @param {LibraryItemsImported} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	libraryItemsImported,
	/**
	 * When a customer turns on/off storing anon ids in local storage as well as a cookie
	 *
	 * @param {LocalStorageToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	localStorageToggled,
	/**
	 * Fires a 'Lockout Modal Shown' track call.
	 *
	 * @param {LockoutModalShown} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	lockoutModalShown,
	/**
	 * Fires a 'MFA Verification Failure' track call.
	 *
	 * @param {MfaVerificationFailure} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	mfaVerificationFailure,
	/**
	 * Event triggered when the user clicks the CTA on the MFA dialog on the MFA security checkup page
	 *
	 * @param {MfaCtaClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	mfaCtaClicked,
	/**
	 * Event triggered when the user closes the mfa cta sidesheet on the MFA security checkup page
	 *
	 * @param {MfaCtaDismissed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	mfaCtaDismissed,
	/**
	 * Event triggered when the user clicks the CTA on the MFA dialog on the MFA security checkup page
	 *
	 * @param {MfaCtaSidesheetClosed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	mfaCtaSidesheetClosed,
	/**
	 * User clicks through a Omnisearch search result
	 *
	 * @param {NavSearchResultClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	navSearchResultClicked,
	/**
	 * User enters a string into Omnisearch search bar but no results that match the query are found.
	 *
	 * @param {NavSearchResultsEmpty} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	navSearchResultsEmpty,
	/**
	 * User enters a query into Omnisearch search bar. Debounced.
	 *
	 * @param {NavSearchTermEntered} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	navSearchTermEntered,
	/**
	 * Fires a 'Navigate Clicked' track call.
	 *
	 * @param {NavigateClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	navigateClicked,
	/**
	 * Fires a 'Network Error' track call.
	 *
	 * @param {NetworkError} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	networkError,
	/**
	 * Fires a 'New Password Strength' track call.
	 *
	 * @param {NewPasswordStrength} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	newPasswordStrength,
	/**
	 * When user clicks button to create new transformation
	 *
	 * @param {NewTransformationClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	newTransformationClicked,
	/**
	 * Fires a 'Notification Banner Clicked' track call.
	 *
	 * @param {NotificationBannerClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationBannerClicked,
	/**
	 * Fires a 'Notification Banner Shown' track call.
	 *
	 * @param {NotificationBannerShown} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationBannerShown,
	/**
	 * Fires a 'Notification Center Load More Clicked' track call.
	 *
	 * @param {NotificationCenterLoadMoreClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationCenterLoadMoreClicked,
	/**
	 * Fires a 'Notification Center Opened' track call.
	 *
	 * @param {NotificationCenterOpened} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationCenterOpened,
	/**
	 * Fires a 'Notification Clicked' track call.
	 *
	 * @param {NotificationClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationClicked,
	/**
	 * Fires a 'Notification Recipients Saved' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationRecipientsSaved,
	/**
	 * Tracks when a user expands a category in the notification settings page
	 *
	 * @param {NotificationsSettingsCategoryClick} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationsSettingsCategoryClick,
	/**
	 * Tracks when a user changes the current view of notification period
	 *
	 * @param {NotificationsSettingsChanged} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationsSettingsChanged,
	/**
	 * Tracks when a user clicks a category in the sidesheet on the notification settings page
	 *
	 * @param {NotificationsSettingsSidesheetCustomCategoryClick} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationsSettingsSidesheetCustomCategoryClick,
	/**
	 * Tracks when a user clicks in a navigate link in a category in the sidesheet on the notification settings page
	 *
	 * @param {NotificationsSettingsSidesheetLinkClick} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationsSettingsSidesheetLinkClick,
	/**
	 * Tracks when a user clicks a category in the sidesheet on the notification settings page
	 *
	 * @param {NotificationsSettingsSidesheetOpenClick} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationsSettingsSidesheetOpenClick,
	/**
	 * Tracks when a user interacts with the delivery alert slider
	 *
	 * @param {NotificationsSettingsSliderInteraction} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	notificationsSettingsSliderInteraction,
	/**
	 * User allowed OAuth consent in app
	 *
	 * @param {OAuthConsentAllowClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oAuthConsentAllowClicked,
	/**
	 * User did not allow OAuth consent, and instead logged out
	 *
	 * @param {OAuthConsentLogoutClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oAuthConsentLogoutClicked,
	/**
	 * User viewed OAuth consent page in app
	 *
	 * @param {OAuthConsentPageViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oAuthConsentPageViewed,
	/**
	 * User started an OAuth consent from enable or other app auth flow
	 *
	 * @param {OAuthConsentStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oAuthConsentStarted,
	/**
	 * When a user confirms creation and configuration of integrations results returned by Snoop Lion
	 *
	 * @param {OneClickDestinationsIntegrationsConfigured} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oneClickDestinationsIntegrationsConfigured,
	/**
	 * When a Snoop Lion job triggered by One-Click Destinations opt-in is completed
	 *
	 * @param {OneClickDestinationsJobCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oneClickDestinationsJobCompleted,
	/**
	 * When a user opts into using One-Click Destinations by clicking "Search" with a valid URL
	 *
	 * @param {OneClickDestinationsSearchOptedIn} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	oneClickDestinationsSearchOptedIn,
	/**
	 * Tracks when analytics.page calls are potentially duplicated on a particular url in the app.
	 *
	 * @param {PageCallDuplicated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pageCallDuplicated,
	/**
	 * Fires a 'Page Viewed' track call.
	 *
	 * @param {PageViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pageViewed,
	/**
	 * Fires a 'Password Changed' track call.
	 *
	 * @param {PasswordChanged} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	passwordChanged,
	/**
	 * Fires a 'Password Submitted' track call.
	 *
	 * @param {PasswordSubmitted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	passwordSubmitted,
	/**
	 * Fires a 'Personas Audience Created' track call.
	 *
	 * @param {PersonasAudienceCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceCreated,
	/**
	 * Fires a 'Personas Audience Deleted' track call.
	 *
	 * @param {PersonasAudienceDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceDeleted,
	/**
	 * Fires a 'Personas Audience Destination Added' track call.
	 *
	 * @param {PersonasAudienceDestinationAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceDestinationAdded,
	/**
	 * Fires a 'Personas Audience Destination Removed' track call.
	 *
	 * @param {PersonasAudienceDestinationRemoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceDestinationRemoved,
	/**
	 * Fires a 'Personas Audience Destination Updated' track call.
	 *
	 * @param {PersonasAudienceDestinationUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceDestinationUpdated,
	/**
	 * Fires a 'Personas Audience Disabled' track call.
	 *
	 * @param {PersonasAudienceDisabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceDisabled,
	/**
	 * Fires a 'Personas Audience Insights Viewed' track call.
	 *
	 * @param {PersonasAudienceInsightsViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceInsightsViewed,
	/**
	 * Fires a 'Personas Audience Overlap Failed' track call.
	 *
	 * @param {PersonasAudienceOverlapFailed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceOverlapFailed,
	/**
	 * Fires a 'Personas Audience Overlap Succeeded' track call.
	 *
	 * @param {PersonasAudienceOverlapSucceeded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceOverlapSucceeded,
	/**
	 * Fires a 'Personas Audience Preview Failed' track call.
	 *
	 * @param {PersonasAudiencePreviewFailed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudiencePreviewFailed,
	/**
	 * Fires a 'Personas Audience Preview Succeeded' track call.
	 *
	 * @param {PersonasAudiencePreviewSucceeded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudiencePreviewSucceeded,
	/**
	 * Fires a 'Personas Audience Run Failed' track call.
	 *
	 * @param {PersonasAudienceRunFailed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceRunFailed,
	/**
	 * Fires a 'Personas Audience Template Requested' track call.
	 *
	 * @param {PersonasAudienceTemplateRequested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceTemplateRequested,
	/**
	 * Fires a 'Personas Audience Template Viewed' track call.
	 *
	 * @param {PersonasAudienceTemplateViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceTemplateViewed,
	/**
	 * Fires a 'Personas Audience Templates Viewed' track call.
	 *
	 * @param {PersonasAudienceTemplatesViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceTemplatesViewed,
	/**
	 * Fires a 'Personas Audience Updated' track call.
	 *
	 * @param {PersonasAudienceUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasAudienceUpdated,
	/**
	 * Fires a 'Personas Clicked Connect Destination' track call.
	 *
	 * @param {PersonasClickedConnectDestination} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasClickedConnectDestination,
	/**
	 * Fires a 'Personas Clicked Setup Destination' track call.
	 *
	 * @param {PersonasClickedSetupDestination} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasClickedSetupDestination,
	/**
	 * Fires a 'Personas Computation Sidesheet Viewed' track call.
	 *
	 * @param {PersonasComputationSidesheetViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasComputationSidesheetViewed,
	/**
	 * Fires a 'Personas Connected Destinations' track call.
	 *
	 * @param {PersonasConnectedDestinations} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasConnectedDestinations,
	/**
	 * Fires a 'Personas Contact About Trial' track call.
	 *
	 * @param {PersonasContactAboutTrial} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasContactAboutTrial,
	/**
	 * Fires a 'Personas Enabled' track call.
	 *
	 * @param {PersonasEnabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasEnabled,
	/**
	 * Fires a 'Personas Explorer Searched' track call.
	 *
	 * @param {PersonasExplorerSearched} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasExplorerSearched,
	/**
	 * Fires a 'Personas Generated Access Token' track call.
	 *
	 * @param {PersonasGeneratedAccessToken} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasGeneratedAccessToken,
	/**
	 * User completed a step in Personas onboarding tour
	 *
	 * @param {PersonasOnboardingTourStepCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasOnboardingTourStepCompleted,
	/**
	 * Fires a 'Personas Profile Events Loaded More' track call.
	 *
	 * @param {PersonasProfileEventsLoadedMore} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasProfileEventsLoadedMore,
	/**
	 * Fires a 'Personas Profile Tab Viewed' track call.
	 *
	 * @param {PersonasProfileTabViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasProfileTabViewed,
	/**
	 * Fires a 'Personas Profile Viewed' track call.
	 *
	 * @param {PersonasProfileViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasProfileViewed,
	/**
	 * Fires a 'Personas Space Created' track call.
	 *
	 * @param {PersonasSpaceCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasSpaceCreated,
	/**
	 * Fires when a user edits the label on an individual space
	 *
	 * @param {PersonasSpaceLabelEdited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasSpaceLabelEdited,
	/**
	 * Fires a 'Personas Space Renamed' track call.
	 *
	 * @param {PersonasSpaceRenamed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasSpaceRenamed,
	/**
	 * Fires a 'Personas Space Switched' track call.
	 *
	 * @param {PersonasSpaceSwitched} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasSpaceSwitched,
	/**
	 * Fires a 'Personas Spaces Settings Viewed' track call.
	 *
	 * @param {PersonasSpacesSettingsViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasSpacesSettingsViewed,
	/**
	 * Fires a 'Personas Spaces Viewed' track call.
	 *
	 * @param {PersonasSpacesViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasSpacesViewed,
	/**
	 * Fires a 'Personas Toggled Import Destination' track call.
	 *
	 * @param {PersonasToggledImportDestination} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasToggledImportDestination,
	/**
	 * Fires a 'Personas Trait Created' track call.
	 *
	 * @param {PersonasTraitCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitCreated,
	/**
	 * Fires a 'Personas Trait Deleted' track call.
	 *
	 * @param {PersonasTraitDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitDeleted,
	/**
	 * Fires a 'Personas Trait Destination Added' track call.
	 *
	 * @param {PersonasTraitDestinationAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitDestinationAdded,
	/**
	 * Fires a 'Personas Trait Destination Removed' track call.
	 *
	 * @param {PersonasTraitDestinationRemoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitDestinationRemoved,
	/**
	 * Fires a 'Personas Trait Destination Updated' track call.
	 *
	 * @param {PersonasTraitDestinationUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitDestinationUpdated,
	/**
	 * Fires a 'Personas Trait Disabled' track call.
	 *
	 * @param {PersonasTraitDisabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitDisabled,
	/**
	 * Fires a 'Personas Trait Preview Clicked' track call.
	 *
	 * @param {PersonasTraitPreviewClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitPreviewClicked,
	/**
	 * Fires a 'Personas Trait Preview Failed' track call.
	 *
	 * @param {PersonasTraitPreviewFailed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitPreviewFailed,
	/**
	 * Fires a 'Personas Trait Preview Succeeded' track call.
	 *
	 * @param {PersonasTraitPreviewSucceeded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitPreviewSucceeded,
	/**
	 * Fires a 'Personas Trait Run Failed' track call.
	 *
	 * @param {PersonasTraitRunFailed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitRunFailed,
	/**
	 * Fires a 'Personas Trait Updated' track call.
	 *
	 * @param {PersonasTraitUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasTraitUpdated,
	/**
	 * Fires a 'Personas Viewed API Access' track call.
	 *
	 * @param {PersonasViewedApiAccess} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasViewedApiAccess,
	/**
	 * Fires a 'Personas Viewed Destinations' track call.
	 *
	 * @param {PersonasViewedDestinations} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	personasViewedDestinations,
	/**
	 * Fires a 'Plans Tab Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	plansTabClicked,
	/**
	 * Fires a 'Plugin Disabled' track call.
	 *
	 * @param {PluginDisabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pluginDisabled,
	/**
	 * Fires a 'Plugin Enabled' track call.
	 *
	 * @param {PluginEnabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pluginEnabled,
	/**
	 * When a user enables forwarding net new properties into an alert channel (Metasource or Slack)
	 *
	 * @param {PrivacyAlertsEnabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	privacyAlertsEnabled,
	/**
	 * When a user applies a privacy control in Settings > Controls
	 *
	 * @param {PrivacyControlApplied} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	privacyControlApplied,
	/**
	 * When a customer requests access to the Privacy Portal
	 *
	 * @param {PrivacyDemoRequested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	privacyDemoRequested,
	/**
	 * Fires a 'Quick Start Additional Integrations Selected' track call.
	 *
	 * @param {QuickStartAdditionalIntegrationsSelected} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartAdditionalIntegrationsSelected,
	/**
	 * When user has filled in all credentials during destination credentials step of flow.
	 *
	 * @param {QuickStartCredentialsAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartCredentialsAdded,
	/**
	 * When user chooses to skip adding credentials
	 *
	 * @param {QuickStartCredentialsSkipped} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartCredentialsSkipped,
	/**
	 * When user selects destination
	 *
	 * @param {QuickStartDestinationSelected} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartDestinationSelected,
	/**
	 * When user clicks "Go to workspace" in final step
	 *
	 * @param {QuickStartFinishedButtonClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartFinishedButtonClicked,
	/**
	 * User exits the Quick Start welcome flow for new workspaces at any point in the Quick Start flow
	 *
	 * @param {QuickStartFlowExited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartFlowExited,
	/**
	 * When user clicks next through flow ("next" between steps)
	 *
	 * @param {QuickStartNextButtonClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartNextButtonClicked,
	/**
	 * When user begins the Quick Start flow by choosing a Quick Start path. Why: so we know which path they chose and that they decided to begin. Location: first screen of flow.
	 *
	 * @param {QuickStartPathSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartPathSelected,
	/**
	 * When user clicks previous through flow
	 *
	 * @param {QuickStartPreviousButtonClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartPreviousButtonClicked,
	/**
	 * User selects Source during Source selection step of flow. Why: so we kow which source they selected
	 *
	 * @param {QuickStartSourceSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	quickStartSourceSelected,
	/**
	 * Fires a 'RSS Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	rssClicked,
	/**
	 * Enable used on a destination that's already enabled. This should rarely happen.
	 *
	 * @param {RedundantDestinationEnableAttempted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	redundantDestinationEnableAttempted,
	/**
	 * Fires a 'Reset Password' track call.
	 *
	 * @param {ResetPassword} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	resetPassword,
	/**
	 * When the customer turns on/off Analytics.js retries the event is triggered.
	 *
	 * @param {RetriesToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	retriesToggled,
	/**
	 * Fires a 'Run History Viewed' track call.
	 *
	 * @param {RunHistoryViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	runHistoryViewed,
	/**
	 * Fires a 'SSO Connection Created' track call.
	 *
	 * @param {SsoConnectionCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoConnectionCreated,
	/**
	 * Fires a 'SSO Connection Default Changed' track call.
	 *
	 * @param {SsoConnectionDefaultChanged} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoConnectionDefaultChanged,
	/**
	 * Fires a 'SSO Connection Deleted' track call.
	 *
	 * @param {SsoConnectionDeleted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoConnectionDeleted,
	/**
	 * Fires a 'SSO Connection Toggled' track call.
	 *
	 * @param {SsoConnectionToggled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoConnectionToggled,
	/**
	 * Fires a 'SSO Connection Updated' track call.
	 *
	 * @param {SsoConnectionUpdated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoConnectionUpdated,
	/**
	 * Fires a 'SSO Domain Added' track call.
	 *
	 * @param {SsoDomainAdded} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoDomainAdded,
	/**
	 * Fires a 'SSO Domain Removed' track call.
	 *
	 * @param {SsoDomainRemoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoDomainRemoved,
	/**
	 * Fires a 'SSO Domain Verified' track call.
	 *
	 * @param {SsoDomainVerified} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoDomainVerified,
	/**
	 * Fires a 'SSO Forced' track call.
	 *
	 * @param {SsoForced} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	ssoForced,
	/**
	 * Fired when user clicks the "Save" button on the bulk assign environments dialog
	 *
	 * @param {SaveButtonBulkAssignEnvironmentsClick} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	saveButtonBulkAssignEnvironmentsClick,
	/**
	 * Fires a 'Scheduled Vacuuming Disabled' track call.
	 *
	 * @param {ScheduledVacuumingDisabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	scheduledVacuumingDisabled,
	/**
	 * Fires a 'Scheduled Vacuuming Enabled' track call.
	 *
	 * @param {ScheduledVacuumingEnabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	scheduledVacuumingEnabled,
	/**
	 * Fires a 'Scheduled Vacuuming Updated' track call.
	 *
	 * @param {ScheduledVacuumingUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	scheduledVacuumingUpdated,
	/**
	 * Fires a 'Schema Default Toggle' track call.
	 *
	 * @param {SchemaDefaultToggle} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	schemaDefaultToggle,
	/**
	 * Fired when a user clicks "contact us" on the Source Schema page, in regards to enabling Schema Defaults on their account.
	 *
	 * @param {SchemaDefaultsRequested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	schemaDefaultsRequested,
	/**
	 * Fires a 'Schema Destination Toggle' track call.
	 *
	 * @param {SchemaDestinationToggle} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	schemaDestinationToggle,
	/**
	 * Fires a 'Schema Event Properties Conditional Save' track call.
	 *
	 * @param {SchemaEventPropertiesConditionalSave} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	schemaEventPropertiesConditionalSave,
	/**
	 * Fires a 'Schema Toggle' track call.
	 *
	 * @param {SchemaToggle} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	schemaToggle,
	/**
	 * Fires when a user sets permissions on source admin by environment
	 *
	 * @param {SetEnvPermissionsOnSourceAdmin} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	setEnvPermissionsOnSourceAdmin,
	/**
	 * Fires a 'Set Env Permissions On Source Read Only' track call.
	 *
	 * @param {SetEnvPermissionsOnSourceReadOnly} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	setEnvPermissionsOnSourceReadOnly,
	/**
	 * Fired when a user clicks into a section of the Segment App
	 *
	 * @param {SideNavClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClicked,
	/**
	 * Fires a 'Side Nav Clicked Catalog' track call.
	 *
	 * @param {SideNavClickedCatalog} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedCatalog,
	/**
	 * Fires a 'Side Nav Clicked Destinations' track call.
	 *
	 * @param {SideNavClickedDestinations} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedDestinations,
	/**
	 * Fires a 'Side Nav Clicked Docs' track call.
	 *
	 * @param {SideNavClickedDocs} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedDocs,
	/**
	 * Fires a 'Side Nav Clicked Health' track call.
	 *
	 * @param {SideNavClickedHealth} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedHealth,
	/**
	 * Fires a 'Side Nav Clicked Overview' track call.
	 *
	 * @param {SideNavClickedOverview} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedOverview,
	/**
	 * Fires a 'Side Nav Clicked Personas' track call.
	 *
	 * @param {SideNavClickedPersonas} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedPersonas,
	/**
	 * Fires a 'Side Nav Clicked Protocols' track call.
	 *
	 * @param {SideNavClickedProtocols} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedProtocols,
	/**
	 * Fires a 'Side Nav Clicked Settings' track call.
	 *
	 * @param {SideNavClickedSettings} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedSettings,
	/**
	 * Fires a 'Side Nav Clicked Sources' track call.
	 *
	 * @param {SideNavClickedSources} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sideNavClickedSources,
	/**
	 * Fires a 'Sidepanel Move Clicked' track call.
	 *
	 * @param {SidepanelMoveClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sidepanelMoveClicked,
	/**
	 * When a user submits a demo request via the self-service signup flow
	 *
	 * @param {SignupDemoRequestSubmitted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	signupDemoRequestSubmitted,
	/**
	 * Fires a 'Signup Next Clicked' track call.
	 *
	 * @param {SignupNextClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	signupNextClicked,
	/**
	 * User viewed the self-service signup page
	 *
	 * @param {SignupPageViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	signupPageViewed,
	/**
	 * When a user inputs a password and the password strength is validated
	 *
	 * @param {SignupPasswordStrengthValidated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	signupPasswordStrengthValidated,
	/**
	 * Fires a 'Site Exited' track call.
	 *
	 * @param {SiteExited} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	siteExited,
	/**
	 * Fires a 'Sloth Of Death' track call.
	 *
	 * @param {SlothOfDeath} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	slothOfDeath,
	/**
	 * Fired when a view is sorted.
	 *
	 * @param {SortApplied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sortApplied,
	/**
	 * Fires a 'Source Authorize Clicked' track call.
	 *
	 * @param {SourceAuthorizeClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceAuthorizeClicked,
	/**
	 * Fires a 'Source Authorized' track call.
	 *
	 * @param {SourceAuthorized} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceAuthorized,
	/**
	 * Fires a 'Source Authorized Failed' track call.
	 *
	 * @param {SourceAuthorizedFailed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceAuthorizedFailed,
	/**
	 * Fires a 'Source Basic Settings Changed' track call.
	 *
	 * @param {SourceBasicSettingsChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceBasicSettingsChanged,
	/**
	 * Fires a 'Source Collaborator Invited Legacy' track call.
	 *
	 * @param {SourceCollaboratorInvitedLegacy} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceCollaboratorInvitedLegacy,
	/**
	 * Fires a 'Source Created' track call.
	 *
	 * @param {SourceCreated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceCreated,
	/**
	 * Fires a 'Source Delete Clicked' track call.
	 *
	 * @param {SourceDeleteClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceDeleteClicked,
	/**
	 * Fires a 'Source Deleted' track call.
	 *
	 * @param {SourceDeleted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceDeleted,
	/**
	 * Fires a 'Source Disabled' track call.
	 *
	 * @param {SourceDisabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceDisabled,
	/**
	 * Fires a 'Source Enabled' track call.
	 *
	 * @param {SourceEnabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceEnabled,
	/**
	 * Fires when a user edits the label on an individual source
	 *
	 * @param {SourceLabelEdited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceLabelEdited,
	/**
	 * Fires a 'Source Moved' track call.
	 *
	 * @param {SourceMoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceMoved,
	/**
	 * Fires a 'Source Overview Accordion Toggled' track call.
	 *
	 * @param {SourceOverviewAccordionToggled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceOverviewAccordionToggled,
	/**
	 * Fires a 'Source Overview Link Clicked' track call.
	 *
	 * @param {SourceOverviewLinkClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceOverviewLinkClicked,
	/**
	 * Fires a 'Source SQL Settings Changed' track call.
	 *
	 * @param {SourceSqlSettingsChanged} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceSqlSettingsChanged,
	/**
	 * Fired when a user clears their source schema.
	 *
	 * @param {SourceSchemaCleared} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceSchemaCleared,
	/**
	 * Fires a 'Source Schema Refresh Clicked' track call.
	 *
	 * @param {SourceSchemaRefreshClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceSchemaRefreshClicked,
	/**
	 * Schema V1
	 *
	 * @param {SourceSchemaRefreshed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceSchemaRefreshed,
	/**
	 * Fires a 'Source Setup Funnel Step Completed' track call.
	 *
	 * @param {SourceSetupFunnelStepCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceSetupFunnelStepCompleted,
	/**
	 * When a user generates a new Source write key
	 *
	 * @param {SourceWriteKeyGenerated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceWriteKeyGenerated,
	/**
	 * When a user revokes an individual Source write key
	 *
	 * @param {SourceWriteKeyRevoked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceWriteKeyRevoked,
	/**
	 * Fires when a user searches for a source on the bulk assign environments UI
	 *
	 * @param {SourceSearchedOnBulkAssignEnvironments} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourceSearchedOnBulkAssignEnvironments,
	/**
	 * For Sources Selective Sync when a customer toggles a collection on or off
	 *
	 * @param {SourcesCollectionToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourcesCollectionToggled,
	/**
	 * For Sources Selective Sync when a customer toggles a field on or off inside of a collection
	 *
	 * @param {SourcesFieldToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourcesFieldToggled,
	/**
	 * Fires a 'Sources Link Clicked' track call.
	 *
	 * @param {SourcesLinkClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sourcesLinkClicked,
	/**
	 * A customer clicked on the create-a-split account button
	 *
	 * @param {SplitAccountButtonClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	splitAccountButtonClicked,
	/**
	 * A customer was in the rollout for seeing a split account button
	 *
	 * @param {SplitAccountButtonViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	splitAccountButtonViewed,
	/**
	 * Fires a 'Starter Tracking Plan Created' track call.
	 *
	 * @param {StarterTrackingPlanCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	starterTrackingPlanCreated,
	/**
	 * An event for indicating a user has completed the startup program application
	 *
	 * @param {StartupApplicationCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	startupApplicationCompleted,
	/**
	 * Fires a 'Step Completed (Appcues)' track call.
	 *
	 * @param {StepCompletedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	stepCompletedAppcues,
	/**
	 * Fires a 'Step Interacted (Appcues)' track call.
	 *
	 * @param {StepInteractedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	stepInteractedAppcues,
	/**
	 * Fires a 'Step Skipped (Appcues)' track call.
	 *
	 * @param {StepSkippedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	stepSkippedAppcues,
	/**
	 * Fires a 'Step Started (Appcues)' track call.
	 *
	 * @param {StepStartedAppcues} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	stepStartedAppcues,
	/**
	 * Fires a 'Submitted Wishlist Integration Request' track call.
	 *
	 * @param {SubmittedWishlistIntegrationRequest} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	submittedWishlistIntegrationRequest,
	/**
	 * Fires a 'Subscription Plan Change Error' track call.
	 *
	 * @param {SubscriptionPlanChangeError} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	subscriptionPlanChangeError,
	/**
	 * Fires a 'Subscription Plan Changed' track call.
	 *
	 * @param {SubscriptionPlanChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	subscriptionPlanChanged,
	/**
	 * Fires a 'Subscription Plan Failed' track call.
	 *
	 * @param {SubscriptionPlanFailed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	subscriptionPlanFailed,
	/**
	 * Fires a 'Support Access Grant Created' track call.
	 *
	 * @param {SupportAccessGrantCreated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	supportAccessGrantCreated,
	/**
	 * Fires a 'Support Access Grant Revoked' track call.
	 *
	 * @param {SupportAccessGrantRevoked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	supportAccessGrantRevoked,
	/**
	 * Fires a 'Survey Closed' track call.
	 *
	 * @param {SurveyClosed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	surveyClosed,
	/**
	 * Fires a 'Survey Completed' track call.
	 *
	 * @param {SurveyCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	surveyCompleted,
	/**
	 * Fires a 'Survey Viewed' track call.
	 *
	 * @param {SurveyViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	surveyViewed,
	/**
	 * Fires a 'Tag an Event Clicked' track call.
	 *
	 * @param {TagAnEventClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	tagAnEventClicked,
	/**
	 * Sidesheet closed
	 *
	 * @param {TeamMemberDetailViewClosed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	teamMemberDetailViewClosed,
	/**
	 * Sidesheet opened
	 *
	 * @param {TeamMemberDetailViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	teamMemberDetailViewed,
	/**
	 * New invitation saved
	 *
	 * @param {TeamMemberInvited} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	teamMemberInvited,
	/**
	 * Fires a 'Team Member Invited Legacy' track call.
	 *
	 * @param {TeamMemberInvitedLegacy} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	teamMemberInvitedLegacy,
	/**
	 * Fires a 'Team Member Removed' track call.
	 *
	 * @param {TeamMemberRemoved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	teamMemberRemoved,
	/**
	 * Sidesheet saved successfully
	 *
	 * @param {TeamMemberSaved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	teamMemberSaved,
	/**
	 * Fires a 'Test' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	test,
	/**
	 * Fires a 'Tool Request Form Submitted' track call.
	 *
	 * @param {ToolRequestFormSubmitted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	toolRequestFormSubmitted,
	/**
	 * Fires at the end of the connect flow, after reviewing consequences. Cannot fire when source already connected
	 *
	 * @param {TrackingPlanConnectionChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanConnectionChanged,
	/**
	 * Fire each time tracking plan is created
	 *
	 * @param {TrackingPlanCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanCreated,
	/**
	 * Fire each time tracking plan is deleted
	 *
	 * @param {TrackingPlanDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanDeleted,
	/**
	 * Fires when a user clicks 'Add Event Version' on an event.
	 *
	 * @param {TrackingPlanEventVersionAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanEventVersionAdded,
	/**
	 * Fire each time tracking plan is inferred from a source
	 *
	 * @param {TrackingPlanInferred} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanInferred,
	/**
	 * Fire each time tracking plan is saved (not at initial create) after Review Changes
	 *
	 * @param {TrackingPlanSaved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanSaved,
	/**
	 * Fire when user interacts with Tracking Plan Tip (fire when user Opens, Ignores or Accepts)
	 *
	 * @param {TrackingPlanTipInteracted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingPlanTipInteracted,
	/**
	 * Specs for events to track were selected by a user
	 *
	 * @param {TrackingSpecsSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	trackingSpecsSelected,
	/**
	 * Fires a 'Transactional Error' track call.
	 *
	 * @param {TransactionalError} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	transactionalError,
	/**
	 * When a user creates a new transformation
	 *
	 * @param {TransformationCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	transformationCreated,
	/**
	 * When user deletes a transformation
	 *
	 * @param {TransformationDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	transformationDeleted,
	/**
	 * User selects a different trigger type than the default
	 *
	 * @param {TriggerTypeReSelected} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	triggerTypeReSelected,
	/**
	 * Fires a 'URL Field Edited' track call.
	 *
	 * @param {UrlFieldEdited} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	urlFieldEdited,
	/**
	 * Fires a 'Unread Notification Count Displayed' track call.
	 *
	 * @param {UnreadNotificationCountDisplayed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	unreadNotificationCountDisplayed,
	/**
	 * Fires when user updates the state of an onboarding step, e.g. skipping a step.
	 *
	 * @param {UpdateOnboardingStepState} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	updateOnboardingStepState,
	/**
	 * Update Profile button clicked on the User Settings page
	 *
	 * @param {UpdateProfileClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	updateProfileClicked,
	/**
	 * Fires a 'Updated Components' track call.
	 *
	 * @param {UpdatedComponents} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	updatedComponents,
	/**
	 * Fires a 'Updated Contacts' track call.
	 *
	 * @param {UpdatedContacts} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	updatedContacts,
	/**
	 * Fires a 'Upgrade CTA Clicked' track call.
	 *
	 * @param {UpgradeCtaClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	upgradeCtaClicked,
	/**
	 * Fires a 'Upgrade Modal Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	upgradeModalClicked,
	/**
	 * Fires a 'Upvoted Wishlist Integration Request' track call.
	 *
	 * @param {UpvotedWishlistIntegrationRequest} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	upvotedWishlistIntegrationRequest,
	/**
	 * Fires a 'Usage Tab Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	usageTabClicked,
	/**
	 * Fires a 'User Created' track call.
	 *
	 * @param {UserCreated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userCreated,
	/**
	 * Delete Account button clicked on the User Settings page
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userDeleteClicked,
	/**
	 * Fires a 'User Deleted' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userDeleted,
	/**
	 * Fires a 'User Impersonated' track call.
	 *
	 * @param {UserImpersonated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userImpersonated,
	/**
	 * Fires a 'User Linked to Workspace' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userLinkedToWorkspace,
	/**
	 * Fires a 'User Logged In' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userLoggedIn,
	/**
	 * Fires a 'User Signed Up' track call.
	 *
	 * @param {UserSignedUp} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	userSignedUp,
	/**
	 * Fires a 'VT Get Started Button Clicked' track call.
	 *
	 * @param {VtGetStartedButtonClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	vtGetStartedButtonClicked,
	/**
	 * Fires a 'VT Legal Modal Install Button Clicked' track call.
	 *
	 * @param {VtLegalModalInstallButtonClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	vtLegalModalInstallButtonClicked,
	/**
	 * Fires a 'VT View Debugger Clicked' track call.
	 *
	 * @param {VtViewDebuggerClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	vtViewDebuggerClicked,
	/**
	 * Fire when user clicks validate data to view the "Data Validation" report
	 *
	 * @param {ValidateDataClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	validateDataClicked,
	/**
	 * This event is fired when a user clicks View Changelog for a Tracking Plan.
	 *
	 * @param {ViewChangelogClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewChangelogClicked,
	/**
	 * Fires when user clicks "View Debugger"
	 *
	 * @param {ViewDebuggerClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewDebuggerClicked,
	/**
	 * Fires a 'View Libraries Clicked' track call.
	 *
	 * @param {ViewLibrariesClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewLibrariesClicked,
	/**
	 * Fire when a user clicks to edit protocols schema settings
	 *
	 * @param {ViewSchemaConfigurationClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewSchemaConfigurationClicked,
	/**
	 * Fire when a user clicks to view the schema tab for a specific source
	 *
	 * @param {ViewSourceSchemaClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewSourceSchemaClicked,
	/**
	 * When user clicks to view tracking plan in edit mode
	 *
	 * @param {ViewTrackingPlanClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewTrackingPlanClicked,
	/**
	 * Fires a 'View Transformations Clicked' track call.
	 *
	 * @param {ViewTransformationsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewTransformationsClicked,
	/**
	 * Fire when user clicks to view violations in either Schema, violation summary or Data Validation views
	 *
	 * @param {ViewViolationsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewViolationsClicked,
	/**
	 * Fires a 'Viewed Featured Destinations' track call.
	 *
	 * @param {ViewedFeaturedDestinations} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewedFeaturedDestinations,
	/**
	 * Fires a 'Viewed Integration' track call.
	 *
	 * @param {ViewedIntegration} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewedIntegration,
	/**
	 * Fires a 'Viewed lockout' track call.
	 *
	 * @param {ViewedLockout} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewedLockout,
	/**
	 * Fire when a user deletes violations.
	 *
	 * @param {ViolationsDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	violationsDeleted,
	/**
	 * Fires a 'Visited Integration Docs' track call.
	 *
	 * @param {VisitedIntegrationDocs} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visitedIntegrationDocs,
	/**
	 * When a customer creates and saves an Event in the Visual Tagger
	 *
	 * @param {VisualEventCreated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualEventCreated,
	/**
	 * VT build page
	 *
	 * @param {VisualTaggerAddPropertyClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerAddPropertyClicked,
	/**
	 * Fires a 'Visual Tagger Advanced Options Clicked' track call.
	 *
	 * @param {VisualTaggerAdvancedOptionsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerAdvancedOptionsClicked,
	/**
	 * "Visual Tagger" Clicked on the Source Page
	 *
	 * @param {VisualTaggerClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerClicked,
	/**
	 * This happens when user clicks into the build page, and the source is not correctly configured.
	 *
	 * @param {VisualTaggerCopySnippetClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerCopySnippetClicked,
	/**
	 * on the "build" page
	 *
	 * @param {VisualTaggerCreateEventClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerCreateEventClicked,
	/**
	 * on the VT home page
	 *
	 * @param {VisualTaggerCreateEventsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerCreateEventsClicked,
	/**
	 * on the published table
	 *
	 * @param {VisualTaggerCreateNewClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerCreateNewClicked,
	/**
	 * on the published table
	 *
	 * @param {VisualTaggerDeleteClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerDeleteClicked,
	/**
	 * Fires a 'Visual Tagger Doc Clicked' track call.
	 *
	 * @param {VisualTaggerDocClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerDocClicked,
	/**
	 * on the published table
	 *
	 * @param {VisualTaggerEditClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerEditClicked,
	/**
	 * Fires a 'Visual Tagger Enter Value Clicked' track call.
	 *
	 * @param {VisualTaggerEnterValueClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerEnterValueClicked,
	/**
	 * triggered when "publish" is clicked
	 *
	 * @param {VisualTaggerEventCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerEventCreated,
	/**
	 * User clicks "save" in the event details editing modal in the iframe view
	 *
	 * @param {VisualTaggerEventSaved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerEventSaved,
	/**
	 * after click the "Test Events", user click on the image, and see the test result
	 *
	 * @param {VisualTaggerEventTested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerEventTested,
	/**
	 * VT Build Page
	 *
	 * @param {VisualTaggerExitClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerExitClicked,
	/**
	 * the click after clicking visual tagger on the Source page
	 *
	 * @param {VisualTaggerGetStartedButtonClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerGetStartedButtonClicked,
	/**
	 * VT Build Page
	 *
	 * @param {VisualTaggerGuideClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerGuideClicked,
	/**
	 * When the customer turns on/off the Visual Tagger integration the event is triggered.
	 *
	 * @param {VisualTaggerIntegrationToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerIntegrationToggled,
	/**
	 * VT Build Page
	 *
	 * @param {VisualTaggerLearnBestPracticeClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerLearnBestPracticeClicked,
	/**
	 * Fires a 'Visual Tagger Publish Clicked' track call.
	 *
	 * @param {VisualTaggerPublishClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerPublishClicked,
	/**
	 * Fires a 'Visual Tagger Select Value From Page Clicked' track call.
	 *
	 * @param {VisualTaggerSelectValueFromPageClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerSelectValueFromPageClicked,
	/**
	 * Setup Steps have been completed and user clicks "Continue"
	 *
	 * @param {VisualTaggerSetupStepsContinueClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerSetupStepsContinueClicked,
	/**
	 * on the VT home page
	 *
	 * @param {VisualTaggerTemplateClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerTemplateClicked,
	/**
	 * "Tests Events Clicked"
	 *
	 * @param {VisualTaggerTestEventsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerTestEventsClicked,
	/**
	 * VT build page, after click "create event", you can click "buttons", "Forms:, or "Any"
	 *
	 * @param {VisualTaggerTrackAnyClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerTrackAnyClicked,
	/**
	 * VT build page, after click "create event", you can click "buttons", "Forms:, or "Any"
	 *
	 * @param {VisualTaggerTrackButtonsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerTrackButtonsClicked,
	/**
	 * VT build page, after click "create event", you can click "buttons", "Forms:, or "Any"
	 *
	 * @param {VisualTaggerTrackFormsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerTrackFormsClicked,
	/**
	 * on the VT home/guide page.
	 *
	 * @param {VisualTaggerVideoClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerVideoClicked,
	/**
	 * Intro Page
	 *
	 * @param {VisualTaggerViewAgreementClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerViewAgreementClicked,
	/**
	 * Intro Page
	 *
	 * @param {VisualTaggerViewExtensionClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	visualTaggerViewExtensionClicked,
	/**
	 * Fires a 'Warehouse Connection Failed' track call.
	 *
	 * @param {WarehouseConnectionFailed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseConnectionFailed,
	/**
	 * Fires a 'Warehouse Connection Tested' track call.
	 *
	 * @param {WarehouseConnectionTested} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseConnectionTested,
	/**
	 * Fires a 'Warehouse Connection Updated' track call.
	 *
	 * @param {WarehouseConnectionUpdated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseConnectionUpdated,
	/**
	 * Fires a 'Warehouse Created' track call.
	 *
	 * @param {WarehouseCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseCreated,
	/**
	 * Fires a 'Warehouse Delete Clicked' track call.
	 *
	 * @param {WarehouseDeleteClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseDeleteClicked,
	/**
	 * Fires a 'Warehouse Deleted' track call.
	 *
	 * @param {WarehouseDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseDeleted,
	/**
	 * Fires a 'Warehouse Disabled' track call.
	 *
	 * @param {WarehouseDisabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseDisabled,
	/**
	 * Fires a 'Warehouse Enabled' track call.
	 *
	 * @param {WarehouseEnabled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseEnabled,
	/**
	 * Fires a 'Warehouse Nickname Changed' track call.
	 *
	 * @param {WarehouseNicknameChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseNicknameChanged,
	/**
	 * Fires when a user updates the Selective Sync Schema for a Warehouse
	 *
	 * @param {WarehouseSchemaUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSchemaUpdated,
	/**
	 * Fires a 'Warehouse Settings Saved' track call.
	 *
	 * @param {WarehouseSettingsSaved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSettingsSaved,
	/**
	 * Fires a 'Warehouse Simulator Query Executed' track call.
	 *
	 * @param {WarehouseSimulatorQueryExecuted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSimulatorQueryExecuted,
	/**
	 * Fires when a user toggles the Enable/Disable toggle on the Warehouse Source Page
	 *
	 * @param {WarehouseSourceEnableToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSourceEnableToggled,
	/**
	 * Fires a 'Warehouse Sync Schedule Disabled' track call.
	 *
	 * @param {WarehouseSyncScheduleDisabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSyncScheduleDisabled,
	/**
	 * Fires a 'Warehouse Sync Schedule Enabled' track call.
	 *
	 * @param {WarehouseSyncScheduleEnabled} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSyncScheduleEnabled,
	/**
	 * Fires a 'Warehouse Sync Schedule Saved' track call.
	 *
	 * @param {WarehouseSyncScheduleSaved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	warehouseSyncScheduleSaved,
	/**
	 * Fires a 'Workspace Add Clicked' track call.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceAddClicked,
	/**
	 * Fires a 'Workspace Created' track call.
	 *
	 * @param {WorkspaceCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceCreated,
	/**
	 * Fires a 'Workspace Deleted' track call.
	 *
	 * @param {WorkspaceDeleted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceDeleted,
	/**
	 * Fires a 'Workspace Home Add Visual Tagger Clicked' track call.
	 *
	 * @param {WorkspaceHomeAddVisualTaggerClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceHomeAddVisualTaggerClicked,
	/**
	 * Fires a 'Workspace Home Edit Destination Settings' track call.
	 *
	 * @param {WorkspaceHomeEditDestinationSettings} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceHomeEditDestinationSettings,
	/**
	 * View Catalog button when setting up the destination
	 *
	 * @param {WorkspaceHomeViewCatalogClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceHomeViewCatalogClicked,
	/**
	 * on workspace home w. VT
	 *
	 * @param {WorkspaceHomeViewCodeDocsClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceHomeViewCodeDocsClicked,
	/**
	 * Copy Snippet button clicked at Workspace Home with VT availabe
	 *
	 * @param {WorkspaceHomeVisualTaggerCopySnippetClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceHomeVisualTaggerCopySnippetClicked,
	/**
	 * Tracks when users change the period in which they view the sources count and MTU data
	 *
	 * @param {WorkspaceInsightsCsvDownloaded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceInsightsCsvDownloaded,
	/**
	 * Tracks when users change click to download the sources count and MTU data
	 *
	 * @param {WorkspaceInsightsPeriodChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceInsightsPeriodChanged,
	/**
	 * Fires a 'Workspace Settings Tab Clicked' track call.
	 *
	 * @param {WorkspaceSettingsTabClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceSettingsTabClicked,
	/**
	 * Tracks when users download a CSV report of a usage metric
	 *
	 * @param {WorkspaceUsageMetricCsvDownloaded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceUsageMetricCsvDownloaded,
	/**
	 * Tracks when users expand the metric overview details accordion in the usage page
	 *
	 * @param {WorkspaceUsageMetricOverviewDetailsExpanded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceUsageMetricOverviewDetailsExpanded,
	/**
	 * Tracks when users select a metric tab in the usage page
	 *
	 * @param {WorkspaceUsageMetricTabSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceUsageMetricTabSelected,
	/**
	 * Tracks when users trigger a tooltip render in the usage page
	 *
	 * @param {WorkspaceUsageMetricTooltipViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceUsageMetricTooltipViewed,
	/**
	 * Tracks when users change the viewable invoice period for the current workspace usage.
	 *
	 * @param {WorkspaceUsagePeriodChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceUsagePeriodChanged,
	/**
	 * Tracks when users click on the upgrade plan CTA while viewing usage details
	 *
	 * @param {WorkspaceUsageUpgradeCtaClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspaceUsageUpgradeCtaClicked,
	/**
	 * Event fired when comparing the existing workspace flags and the prototyped ones
	 *
	 * @param {WorkspacesFlagsComparison} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspacesFlagsComparison,
	/**
	 * Event fired when comparing the existing workspace quotas and the prototyped ones
	 *
	 * @param {WorkspacesQuotaComparison} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	workspacesQuotaComparison,
	/**
	 * Fires a 'Write Key Change Clicked' track call.
	 *
	 * @param {WriteKeyChangeClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	writeKeyChangeClicked,
	/**
	 * Fires a 'Write Key Changed' track call.
	 *
	 * @param {WriteKeyChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	writeKeyChanged,
	/**
	 * Fires a 'Writekey Retry Clicked' track call.
	 *
	 * @param {WritekeyRetryClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	writekeyRetryClicked,
	/**
	 * Fires when user clicks the Setup Guide docs link on the Workspace Home
	 *
	 * @param {DoNotAddYetWorkspaceHomeSetupGuideDocsClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	doNotAddYetWorkspaceHomeSetupGuideDocsClicked,
	/**
	 * Fires a 'clicked connect pane link' track call.
	 *
	 * @param {ClickedConnectPaneLink} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	clickedConnectPaneLink,
	/**
	 * Fires a 'viewed connect pane' track call.
	 *
	 * @param {ViewedConnectPane} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	viewedConnectPane,
}

export default new Proxy<typeof clientAPI>(clientAPI, {
	get(target, method) {
		if (typeof method === 'string' && target.hasOwnProperty(method)) {
			return target[method as keyof typeof clientAPI]
		}

		return () => {
			console.warn(`⚠️  You made an analytics call (${String(
				method
			)}) that can't be found. Either:
    a) Re-generate your typewriter client: \`npx typewriter\`
    b) Add it to your Tracking Plan: https://app.segment.com/segment_prod/protocols/tracking-plans/rs_16W7KaDjpZ09dI341chHKgYJah9`)
			const a = analytics()
			if (a) {
				a.track(
					'Unknown Analytics Call Fired',
					{
						method,
					},
					withTypewriterContext()
				)
			}
		}
	},
})
